/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const util = $root.util = (() => {

    /**
     * Namespace util.
     * @exports util
     * @namespace
     */
    const util = {};

    util.KeyValueDay = (function() {

        /**
         * Properties of a KeyValueDay.
         * @memberof util
         * @interface IKeyValueDay
         * @property {string|null} [key] KeyValueDay key
         * @property {string|null} [value] KeyValueDay value
         * @property {string|null} [day] KeyValueDay day
         */

        /**
         * Constructs a new KeyValueDay.
         * @memberof util
         * @classdesc Represents a KeyValueDay.
         * @implements IKeyValueDay
         * @constructor
         * @param {util.IKeyValueDay=} [properties] Properties to set
         */
        function KeyValueDay(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeyValueDay key.
         * @member {string} key
         * @memberof util.KeyValueDay
         * @instance
         */
        KeyValueDay.prototype.key = "";

        /**
         * KeyValueDay value.
         * @member {string} value
         * @memberof util.KeyValueDay
         * @instance
         */
        KeyValueDay.prototype.value = "";

        /**
         * KeyValueDay day.
         * @member {string} day
         * @memberof util.KeyValueDay
         * @instance
         */
        KeyValueDay.prototype.day = "";

        /**
         * Creates a new KeyValueDay instance using the specified properties.
         * @function create
         * @memberof util.KeyValueDay
         * @static
         * @param {util.IKeyValueDay=} [properties] Properties to set
         * @returns {util.KeyValueDay} KeyValueDay instance
         */
        KeyValueDay.create = function create(properties) {
            return new KeyValueDay(properties);
        };

        /**
         * Encodes the specified KeyValueDay message. Does not implicitly {@link util.KeyValueDay.verify|verify} messages.
         * @function encode
         * @memberof util.KeyValueDay
         * @static
         * @param {util.IKeyValueDay} message KeyValueDay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValueDay.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && message.hasOwnProperty("key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
            if (message.day != null && message.hasOwnProperty("day"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.day);
            return writer;
        };

        /**
         * Encodes the specified KeyValueDay message, length delimited. Does not implicitly {@link util.KeyValueDay.verify|verify} messages.
         * @function encodeDelimited
         * @memberof util.KeyValueDay
         * @static
         * @param {util.IKeyValueDay} message KeyValueDay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValueDay.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KeyValueDay message from the specified reader or buffer.
         * @function decode
         * @memberof util.KeyValueDay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {util.KeyValueDay} KeyValueDay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValueDay.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.util.KeyValueDay();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    message.day = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KeyValueDay message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof util.KeyValueDay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {util.KeyValueDay} KeyValueDay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValueDay.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KeyValueDay message.
         * @function verify
         * @memberof util.KeyValueDay
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KeyValueDay.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            if (message.day != null && message.hasOwnProperty("day"))
                if (!$util.isString(message.day))
                    return "day: string expected";
            return null;
        };

        /**
         * Creates a KeyValueDay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof util.KeyValueDay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {util.KeyValueDay} KeyValueDay
         */
        KeyValueDay.fromObject = function fromObject(object) {
            if (object instanceof $root.util.KeyValueDay)
                return object;
            let message = new $root.util.KeyValueDay();
            if (object.key != null)
                message.key = String(object.key);
            if (object.value != null)
                message.value = String(object.value);
            if (object.day != null)
                message.day = String(object.day);
            return message;
        };

        /**
         * Creates a plain object from a KeyValueDay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof util.KeyValueDay
         * @static
         * @param {util.KeyValueDay} message KeyValueDay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyValueDay.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.value = "";
                object.day = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            return object;
        };

        /**
         * Converts this KeyValueDay to JSON.
         * @function toJSON
         * @memberof util.KeyValueDay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyValueDay.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return KeyValueDay;
    })();

    return util;
})();

export const rpc = $root.rpc = (() => {

    /**
     * Namespace rpc.
     * @exports rpc
     * @namespace
     */
    const rpc = {};

    rpc.Message = (function() {

        /**
         * Properties of a Message.
         * @memberof rpc
         * @interface IMessage
         * @property {rpc.IRequest|null} [request] Message request
         * @property {rpc.IReply|null} [reply] Message reply
         * @property {Uint8Array|null} [event] Message event
         */

        /**
         * Constructs a new Message.
         * @memberof rpc
         * @classdesc Represents a Message.
         * @implements IMessage
         * @constructor
         * @param {rpc.IMessage=} [properties] Properties to set
         */
        function Message(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Message request.
         * @member {rpc.IRequest|null|undefined} request
         * @memberof rpc.Message
         * @instance
         */
        Message.prototype.request = null;

        /**
         * Message reply.
         * @member {rpc.IReply|null|undefined} reply
         * @memberof rpc.Message
         * @instance
         */
        Message.prototype.reply = null;

        /**
         * Message event.
         * @member {Uint8Array} event
         * @memberof rpc.Message
         * @instance
         */
        Message.prototype.event = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Message data.
         * @member {"request"|"reply"|"event"|undefined} data
         * @memberof rpc.Message
         * @instance
         */
        Object.defineProperty(Message.prototype, "data", {
            get: $util.oneOfGetter($oneOfFields = ["request", "reply", "event"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Message instance using the specified properties.
         * @function create
         * @memberof rpc.Message
         * @static
         * @param {rpc.IMessage=} [properties] Properties to set
         * @returns {rpc.Message} Message instance
         */
        Message.create = function create(properties) {
            return new Message(properties);
        };

        /**
         * Encodes the specified Message message. Does not implicitly {@link rpc.Message.verify|verify} messages.
         * @function encode
         * @memberof rpc.Message
         * @static
         * @param {rpc.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.request != null && message.hasOwnProperty("request"))
                $root.rpc.Request.encode(message.request, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.reply != null && message.hasOwnProperty("reply"))
                $root.rpc.Reply.encode(message.reply, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.event != null && message.hasOwnProperty("event"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.event);
            return writer;
        };

        /**
         * Encodes the specified Message message, length delimited. Does not implicitly {@link rpc.Message.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rpc.Message
         * @static
         * @param {rpc.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Message message from the specified reader or buffer.
         * @function decode
         * @memberof rpc.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rpc.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.rpc.Message();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.request = $root.rpc.Request.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.reply = $root.rpc.Reply.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.event = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Message message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rpc.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rpc.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Message message.
         * @function verify
         * @memberof rpc.Message
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Message.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.request != null && message.hasOwnProperty("request")) {
                properties.data = 1;
                {
                    let error = $root.rpc.Request.verify(message.request);
                    if (error)
                        return "request." + error;
                }
            }
            if (message.reply != null && message.hasOwnProperty("reply")) {
                if (properties.data === 1)
                    return "data: multiple values";
                properties.data = 1;
                {
                    let error = $root.rpc.Reply.verify(message.reply);
                    if (error)
                        return "reply." + error;
                }
            }
            if (message.event != null && message.hasOwnProperty("event")) {
                if (properties.data === 1)
                    return "data: multiple values";
                properties.data = 1;
                if (!(message.event && typeof message.event.length === "number" || $util.isString(message.event)))
                    return "event: buffer expected";
            }
            return null;
        };

        /**
         * Creates a Message message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rpc.Message
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rpc.Message} Message
         */
        Message.fromObject = function fromObject(object) {
            if (object instanceof $root.rpc.Message)
                return object;
            let message = new $root.rpc.Message();
            if (object.request != null) {
                if (typeof object.request !== "object")
                    throw TypeError(".rpc.Message.request: object expected");
                message.request = $root.rpc.Request.fromObject(object.request);
            }
            if (object.reply != null) {
                if (typeof object.reply !== "object")
                    throw TypeError(".rpc.Message.reply: object expected");
                message.reply = $root.rpc.Reply.fromObject(object.reply);
            }
            if (object.event != null)
                if (typeof object.event === "string")
                    $util.base64.decode(object.event, message.event = $util.newBuffer($util.base64.length(object.event)), 0);
                else if (object.event.length)
                    message.event = object.event;
            return message;
        };

        /**
         * Creates a plain object from a Message message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rpc.Message
         * @static
         * @param {rpc.Message} message Message
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Message.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.request != null && message.hasOwnProperty("request")) {
                object.request = $root.rpc.Request.toObject(message.request, options);
                if (options.oneofs)
                    object.data = "request";
            }
            if (message.reply != null && message.hasOwnProperty("reply")) {
                object.reply = $root.rpc.Reply.toObject(message.reply, options);
                if (options.oneofs)
                    object.data = "reply";
            }
            if (message.event != null && message.hasOwnProperty("event")) {
                object.event = options.bytes === String ? $util.base64.encode(message.event, 0, message.event.length) : options.bytes === Array ? Array.prototype.slice.call(message.event) : message.event;
                if (options.oneofs)
                    object.data = "event";
            }
            return object;
        };

        /**
         * Converts this Message to JSON.
         * @function toJSON
         * @memberof rpc.Message
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Message.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Message;
    })();

    rpc.Request = (function() {

        /**
         * Properties of a Request.
         * @memberof rpc
         * @interface IRequest
         * @property {number|null} [seq] Request seq
         * @property {string|null} [name] Request name
         * @property {Uint8Array|null} [payload] Request payload
         */

        /**
         * Constructs a new Request.
         * @memberof rpc
         * @classdesc Represents a Request.
         * @implements IRequest
         * @constructor
         * @param {rpc.IRequest=} [properties] Properties to set
         */
        function Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Request seq.
         * @member {number} seq
         * @memberof rpc.Request
         * @instance
         */
        Request.prototype.seq = 0;

        /**
         * Request name.
         * @member {string} name
         * @memberof rpc.Request
         * @instance
         */
        Request.prototype.name = "";

        /**
         * Request payload.
         * @member {Uint8Array} payload
         * @memberof rpc.Request
         * @instance
         */
        Request.prototype.payload = $util.newBuffer([]);

        /**
         * Creates a new Request instance using the specified properties.
         * @function create
         * @memberof rpc.Request
         * @static
         * @param {rpc.IRequest=} [properties] Properties to set
         * @returns {rpc.Request} Request instance
         */
        Request.create = function create(properties) {
            return new Request(properties);
        };

        /**
         * Encodes the specified Request message. Does not implicitly {@link rpc.Request.verify|verify} messages.
         * @function encode
         * @memberof rpc.Request
         * @static
         * @param {rpc.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seq != null && message.hasOwnProperty("seq"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seq);
            if (message.name != null && message.hasOwnProperty("name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.payload != null && message.hasOwnProperty("payload"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.payload);
            return writer;
        };

        /**
         * Encodes the specified Request message, length delimited. Does not implicitly {@link rpc.Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rpc.Request
         * @static
         * @param {rpc.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Request message from the specified reader or buffer.
         * @function decode
         * @memberof rpc.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rpc.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.rpc.Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seq = reader.uint32();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rpc.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rpc.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Request message.
         * @function verify
         * @memberof rpc.Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seq != null && message.hasOwnProperty("seq"))
                if (!$util.isInteger(message.seq))
                    return "seq: integer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                    return "payload: buffer expected";
            return null;
        };

        /**
         * Creates a Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rpc.Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rpc.Request} Request
         */
        Request.fromObject = function fromObject(object) {
            if (object instanceof $root.rpc.Request)
                return object;
            let message = new $root.rpc.Request();
            if (object.seq != null)
                message.seq = object.seq >>> 0;
            if (object.name != null)
                message.name = String(object.name);
            if (object.payload != null)
                if (typeof object.payload === "string")
                    $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
                else if (object.payload.length)
                    message.payload = object.payload;
            return message;
        };

        /**
         * Creates a plain object from a Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rpc.Request
         * @static
         * @param {rpc.Request} message Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.seq = 0;
                object.name = "";
                object.payload = options.bytes === String ? "" : [];
            }
            if (message.seq != null && message.hasOwnProperty("seq"))
                object.seq = message.seq;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            return object;
        };

        /**
         * Converts this Request to JSON.
         * @function toJSON
         * @memberof rpc.Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Request;
    })();

    rpc.Reply = (function() {

        /**
         * Properties of a Reply.
         * @memberof rpc
         * @interface IReply
         * @property {rpc.IError|null} [error] Reply error
         * @property {string|null} [message] Reply message
         */

        /**
         * Constructs a new Reply.
         * @memberof rpc
         * @classdesc Represents a Reply.
         * @implements IReply
         * @constructor
         * @param {rpc.IReply=} [properties] Properties to set
         */
        function Reply(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Reply error.
         * @member {rpc.IError|null|undefined} error
         * @memberof rpc.Reply
         * @instance
         */
        Reply.prototype.error = null;

        /**
         * Reply message.
         * @member {string} message
         * @memberof rpc.Reply
         * @instance
         */
        Reply.prototype.message = "";

        /**
         * Creates a new Reply instance using the specified properties.
         * @function create
         * @memberof rpc.Reply
         * @static
         * @param {rpc.IReply=} [properties] Properties to set
         * @returns {rpc.Reply} Reply instance
         */
        Reply.create = function create(properties) {
            return new Reply(properties);
        };

        /**
         * Encodes the specified Reply message. Does not implicitly {@link rpc.Reply.verify|verify} messages.
         * @function encode
         * @memberof rpc.Reply
         * @static
         * @param {rpc.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.error != null && message.hasOwnProperty("error"))
                $root.rpc.Error.encode(message.error, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.message != null && message.hasOwnProperty("message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Reply message, length delimited. Does not implicitly {@link rpc.Reply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rpc.Reply
         * @static
         * @param {rpc.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Reply message from the specified reader or buffer.
         * @function decode
         * @memberof rpc.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rpc.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.rpc.Reply();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.error = $root.rpc.Error.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Reply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rpc.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rpc.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Reply message.
         * @function verify
         * @memberof rpc.Reply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Reply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.error != null && message.hasOwnProperty("error")) {
                let error = $root.rpc.Error.verify(message.error);
                if (error)
                    return "error." + error;
            }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a Reply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rpc.Reply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rpc.Reply} Reply
         */
        Reply.fromObject = function fromObject(object) {
            if (object instanceof $root.rpc.Reply)
                return object;
            let message = new $root.rpc.Reply();
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".rpc.Reply.error: object expected");
                message.error = $root.rpc.Error.fromObject(object.error);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a Reply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rpc.Reply
         * @static
         * @param {rpc.Reply} message Reply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Reply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.error = null;
                object.message = "";
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = $root.rpc.Error.toObject(message.error, options);
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this Reply to JSON.
         * @function toJSON
         * @memberof rpc.Reply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Reply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Reply;
    })();

    rpc.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof rpc
         * @interface IError
         * @property {string|null} [message] Error message
         * @property {string|null} [name] Error name
         * @property {Object.<string,string>|null} [details] Error details
         */

        /**
         * Constructs a new Error.
         * @memberof rpc
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {rpc.IError=} [properties] Properties to set
         */
        function Error(properties) {
            this.details = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Error message.
         * @member {string} message
         * @memberof rpc.Error
         * @instance
         */
        Error.prototype.message = "";

        /**
         * Error name.
         * @member {string} name
         * @memberof rpc.Error
         * @instance
         */
        Error.prototype.name = "";

        /**
         * Error details.
         * @member {Object.<string,string>} details
         * @memberof rpc.Error
         * @instance
         */
        Error.prototype.details = $util.emptyObject;

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof rpc.Error
         * @static
         * @param {rpc.IError=} [properties] Properties to set
         * @returns {rpc.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link rpc.Error.verify|verify} messages.
         * @function encode
         * @memberof rpc.Error
         * @static
         * @param {rpc.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.message != null && message.hasOwnProperty("message"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
            if (message.name != null && message.hasOwnProperty("name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.details != null && message.hasOwnProperty("details"))
                for (let keys = Object.keys(message.details), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.details[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Error message, length delimited. Does not implicitly {@link rpc.Error.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rpc.Error
         * @static
         * @param {rpc.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof rpc.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rpc.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.rpc.Error(), key;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    reader.skip().pos++;
                    if (message.details === $util.emptyObject)
                        message.details = {};
                    key = reader.string();
                    reader.pos++;
                    message.details[key] = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Error message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rpc.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rpc.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Error message.
         * @function verify
         * @memberof rpc.Error
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Error.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.details != null && message.hasOwnProperty("details")) {
                if (!$util.isObject(message.details))
                    return "details: object expected";
                let key = Object.keys(message.details);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.details[key[i]]))
                        return "details: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rpc.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rpc.Error} Error
         */
        Error.fromObject = function fromObject(object) {
            if (object instanceof $root.rpc.Error)
                return object;
            let message = new $root.rpc.Error();
            if (object.message != null)
                message.message = String(object.message);
            if (object.name != null)
                message.name = String(object.name);
            if (object.details) {
                if (typeof object.details !== "object")
                    throw TypeError(".rpc.Error.details: object expected");
                message.details = {};
                for (let keys = Object.keys(object.details), i = 0; i < keys.length; ++i)
                    message.details[keys[i]] = String(object.details[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rpc.Error
         * @static
         * @param {rpc.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.details = {};
            if (options.defaults) {
                object.message = "";
                object.name = "";
            }
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            let keys2;
            if (message.details && (keys2 = Object.keys(message.details)).length) {
                object.details = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.details[keys2[j]] = message.details[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof rpc.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Error;
    })();

    rpc.Void = (function() {

        /**
         * Properties of a Void.
         * @memberof rpc
         * @interface IVoid
         */

        /**
         * Constructs a new Void.
         * @memberof rpc
         * @classdesc Represents a Void.
         * @implements IVoid
         * @constructor
         * @param {rpc.IVoid=} [properties] Properties to set
         */
        function Void(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Void instance using the specified properties.
         * @function create
         * @memberof rpc.Void
         * @static
         * @param {rpc.IVoid=} [properties] Properties to set
         * @returns {rpc.Void} Void instance
         */
        Void.create = function create(properties) {
            return new Void(properties);
        };

        /**
         * Encodes the specified Void message. Does not implicitly {@link rpc.Void.verify|verify} messages.
         * @function encode
         * @memberof rpc.Void
         * @static
         * @param {rpc.IVoid} message Void message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Void.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Void message, length delimited. Does not implicitly {@link rpc.Void.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rpc.Void
         * @static
         * @param {rpc.IVoid} message Void message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Void.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Void message from the specified reader or buffer.
         * @function decode
         * @memberof rpc.Void
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rpc.Void} Void
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Void.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.rpc.Void();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Void message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rpc.Void
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rpc.Void} Void
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Void.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Void message.
         * @function verify
         * @memberof rpc.Void
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Void.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Void message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rpc.Void
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rpc.Void} Void
         */
        Void.fromObject = function fromObject(object) {
            if (object instanceof $root.rpc.Void)
                return object;
            return new $root.rpc.Void();
        };

        /**
         * Creates a plain object from a Void message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rpc.Void
         * @static
         * @param {rpc.Void} message Void
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Void.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Void to JSON.
         * @function toJSON
         * @memberof rpc.Void
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Void.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Void;
    })();

    return rpc;
})();

export const mirana = $root.mirana = (() => {

    /**
     * Namespace mirana.
     * @exports mirana
     * @namespace
     */
    const mirana = {};

    mirana.PlanCobertura = (function() {

        /**
         * Properties of a PlanCobertura.
         * @memberof mirana
         * @interface IPlanCobertura
         * @property {string|null} [oficinaVentas] PlanCobertura oficinaVentas
         * @property {string|null} [raz] PlanCobertura raz
         * @property {string|null} [distribuidora] PlanCobertura distribuidora
         * @property {number|null} [sublineaOrden] PlanCobertura sublineaOrden
         * @property {string|null} [sublinea] PlanCobertura sublinea
         * @property {number|null} [cobertura] PlanCobertura cobertura
         * @property {string|null} [fechaCarga] PlanCobertura fechaCarga
         * @property {Array.<util.IKeyValueDay>|null} [resultados] PlanCobertura resultados
         */

        /**
         * Constructs a new PlanCobertura.
         * @memberof mirana
         * @classdesc Represents a PlanCobertura.
         * @implements IPlanCobertura
         * @constructor
         * @param {mirana.IPlanCobertura=} [properties] Properties to set
         */
        function PlanCobertura(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlanCobertura oficinaVentas.
         * @member {string} oficinaVentas
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.oficinaVentas = "";

        /**
         * PlanCobertura raz.
         * @member {string} raz
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.raz = "";

        /**
         * PlanCobertura distribuidora.
         * @member {string} distribuidora
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.distribuidora = "";

        /**
         * PlanCobertura sublineaOrden.
         * @member {number} sublineaOrden
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.sublineaOrden = 0;

        /**
         * PlanCobertura sublinea.
         * @member {string} sublinea
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.sublinea = "";

        /**
         * PlanCobertura cobertura.
         * @member {number} cobertura
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.cobertura = 0;

        /**
         * PlanCobertura fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.fechaCarga = "";

        /**
         * PlanCobertura resultados.
         * @member {Array.<util.IKeyValueDay>} resultados
         * @memberof mirana.PlanCobertura
         * @instance
         */
        PlanCobertura.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new PlanCobertura instance using the specified properties.
         * @function create
         * @memberof mirana.PlanCobertura
         * @static
         * @param {mirana.IPlanCobertura=} [properties] Properties to set
         * @returns {mirana.PlanCobertura} PlanCobertura instance
         */
        PlanCobertura.create = function create(properties) {
            return new PlanCobertura(properties);
        };

        /**
         * Encodes the specified PlanCobertura message. Does not implicitly {@link mirana.PlanCobertura.verify|verify} messages.
         * @function encode
         * @memberof mirana.PlanCobertura
         * @static
         * @param {mirana.IPlanCobertura} message PlanCobertura message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlanCobertura.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.oficinaVentas != null && message.hasOwnProperty("oficinaVentas"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.oficinaVentas);
            if (message.raz != null && message.hasOwnProperty("raz"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.raz);
            if (message.distribuidora != null && message.hasOwnProperty("distribuidora"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.distribuidora);
            if (message.sublineaOrden != null && message.hasOwnProperty("sublineaOrden"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sublineaOrden);
            if (message.sublinea != null && message.hasOwnProperty("sublinea"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.sublinea);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.cobertura);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.fechaCarga);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.util.KeyValueDay.encode(message.resultados[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PlanCobertura message, length delimited. Does not implicitly {@link mirana.PlanCobertura.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PlanCobertura
         * @static
         * @param {mirana.IPlanCobertura} message PlanCobertura message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlanCobertura.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlanCobertura message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PlanCobertura
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PlanCobertura} PlanCobertura
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlanCobertura.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PlanCobertura();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.oficinaVentas = reader.string();
                    break;
                case 2:
                    message.raz = reader.string();
                    break;
                case 3:
                    message.distribuidora = reader.string();
                    break;
                case 4:
                    message.sublineaOrden = reader.int32();
                    break;
                case 5:
                    message.sublinea = reader.string();
                    break;
                case 6:
                    message.cobertura = reader.double();
                    break;
                case 7:
                    message.fechaCarga = reader.string();
                    break;
                case 8:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.util.KeyValueDay.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlanCobertura message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PlanCobertura
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PlanCobertura} PlanCobertura
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlanCobertura.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlanCobertura message.
         * @function verify
         * @memberof mirana.PlanCobertura
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlanCobertura.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.oficinaVentas != null && message.hasOwnProperty("oficinaVentas"))
                if (!$util.isString(message.oficinaVentas))
                    return "oficinaVentas: string expected";
            if (message.raz != null && message.hasOwnProperty("raz"))
                if (!$util.isString(message.raz))
                    return "raz: string expected";
            if (message.distribuidora != null && message.hasOwnProperty("distribuidora"))
                if (!$util.isString(message.distribuidora))
                    return "distribuidora: string expected";
            if (message.sublineaOrden != null && message.hasOwnProperty("sublineaOrden"))
                if (!$util.isInteger(message.sublineaOrden))
                    return "sublineaOrden: integer expected";
            if (message.sublinea != null && message.hasOwnProperty("sublinea"))
                if (!$util.isString(message.sublinea))
                    return "sublinea: string expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.util.KeyValueDay.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PlanCobertura message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PlanCobertura
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PlanCobertura} PlanCobertura
         */
        PlanCobertura.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PlanCobertura)
                return object;
            let message = new $root.mirana.PlanCobertura();
            if (object.oficinaVentas != null)
                message.oficinaVentas = String(object.oficinaVentas);
            if (object.raz != null)
                message.raz = String(object.raz);
            if (object.distribuidora != null)
                message.distribuidora = String(object.distribuidora);
            if (object.sublineaOrden != null)
                message.sublineaOrden = object.sublineaOrden | 0;
            if (object.sublinea != null)
                message.sublinea = String(object.sublinea);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.PlanCobertura.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.PlanCobertura.resultados: object expected");
                    message.resultados[i] = $root.util.KeyValueDay.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PlanCobertura message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PlanCobertura
         * @static
         * @param {mirana.PlanCobertura} message PlanCobertura
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlanCobertura.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.oficinaVentas = "";
                object.raz = "";
                object.distribuidora = "";
                object.sublineaOrden = 0;
                object.sublinea = "";
                object.cobertura = 0;
                object.fechaCarga = "";
            }
            if (message.oficinaVentas != null && message.hasOwnProperty("oficinaVentas"))
                object.oficinaVentas = message.oficinaVentas;
            if (message.raz != null && message.hasOwnProperty("raz"))
                object.raz = message.raz;
            if (message.distribuidora != null && message.hasOwnProperty("distribuidora"))
                object.distribuidora = message.distribuidora;
            if (message.sublineaOrden != null && message.hasOwnProperty("sublineaOrden"))
                object.sublineaOrden = message.sublineaOrden;
            if (message.sublinea != null && message.hasOwnProperty("sublinea"))
                object.sublinea = message.sublinea;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.util.KeyValueDay.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this PlanCobertura to JSON.
         * @function toJSON
         * @memberof mirana.PlanCobertura
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlanCobertura.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlanCobertura;
    })();

    mirana.CoberturasList = (function() {

        /**
         * Properties of a CoberturasList.
         * @memberof mirana
         * @interface ICoberturasList
         * @property {Array.<mirana.IPlanCobertura>|null} [coberturas] CoberturasList coberturas
         */

        /**
         * Constructs a new CoberturasList.
         * @memberof mirana
         * @classdesc Represents a CoberturasList.
         * @implements ICoberturasList
         * @constructor
         * @param {mirana.ICoberturasList=} [properties] Properties to set
         */
        function CoberturasList(properties) {
            this.coberturas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturasList coberturas.
         * @member {Array.<mirana.IPlanCobertura>} coberturas
         * @memberof mirana.CoberturasList
         * @instance
         */
        CoberturasList.prototype.coberturas = $util.emptyArray;

        /**
         * Creates a new CoberturasList instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturasList
         * @static
         * @param {mirana.ICoberturasList=} [properties] Properties to set
         * @returns {mirana.CoberturasList} CoberturasList instance
         */
        CoberturasList.create = function create(properties) {
            return new CoberturasList(properties);
        };

        /**
         * Encodes the specified CoberturasList message. Does not implicitly {@link mirana.CoberturasList.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturasList
         * @static
         * @param {mirana.ICoberturasList} message CoberturasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturasList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coberturas != null && message.coberturas.length)
                for (let i = 0; i < message.coberturas.length; ++i)
                    $root.mirana.PlanCobertura.encode(message.coberturas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CoberturasList message, length delimited. Does not implicitly {@link mirana.CoberturasList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturasList
         * @static
         * @param {mirana.ICoberturasList} message CoberturasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturasList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturasList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturasList} CoberturasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturasList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturasList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.coberturas && message.coberturas.length))
                        message.coberturas = [];
                    message.coberturas.push($root.mirana.PlanCobertura.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturasList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturasList} CoberturasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturasList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturasList message.
         * @function verify
         * @memberof mirana.CoberturasList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturasList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coberturas != null && message.hasOwnProperty("coberturas")) {
                if (!Array.isArray(message.coberturas))
                    return "coberturas: array expected";
                for (let i = 0; i < message.coberturas.length; ++i) {
                    let error = $root.mirana.PlanCobertura.verify(message.coberturas[i]);
                    if (error)
                        return "coberturas." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CoberturasList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturasList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturasList} CoberturasList
         */
        CoberturasList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturasList)
                return object;
            let message = new $root.mirana.CoberturasList();
            if (object.coberturas) {
                if (!Array.isArray(object.coberturas))
                    throw TypeError(".mirana.CoberturasList.coberturas: array expected");
                message.coberturas = [];
                for (let i = 0; i < object.coberturas.length; ++i) {
                    if (typeof object.coberturas[i] !== "object")
                        throw TypeError(".mirana.CoberturasList.coberturas: object expected");
                    message.coberturas[i] = $root.mirana.PlanCobertura.fromObject(object.coberturas[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CoberturasList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturasList
         * @static
         * @param {mirana.CoberturasList} message CoberturasList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturasList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturas = [];
            if (message.coberturas && message.coberturas.length) {
                object.coberturas = [];
                for (let j = 0; j < message.coberturas.length; ++j)
                    object.coberturas[j] = $root.mirana.PlanCobertura.toObject(message.coberturas[j], options);
            }
            return object;
        };

        /**
         * Converts this CoberturasList to JSON.
         * @function toJSON
         * @memberof mirana.CoberturasList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturasList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturasList;
    })();

    mirana.PlanCoberturaRequest = (function() {

        /**
         * Properties of a PlanCoberturaRequest.
         * @memberof mirana
         * @interface IPlanCoberturaRequest
         * @property {string|null} [fechaCarga] PlanCoberturaRequest fechaCarga
         * @property {Array.<mirana.IPlanCobertura>|null} [planCobertura] PlanCoberturaRequest planCobertura
         */

        /**
         * Constructs a new PlanCoberturaRequest.
         * @memberof mirana
         * @classdesc Represents a PlanCoberturaRequest.
         * @implements IPlanCoberturaRequest
         * @constructor
         * @param {mirana.IPlanCoberturaRequest=} [properties] Properties to set
         */
        function PlanCoberturaRequest(properties) {
            this.planCobertura = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlanCoberturaRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.PlanCoberturaRequest
         * @instance
         */
        PlanCoberturaRequest.prototype.fechaCarga = "";

        /**
         * PlanCoberturaRequest planCobertura.
         * @member {Array.<mirana.IPlanCobertura>} planCobertura
         * @memberof mirana.PlanCoberturaRequest
         * @instance
         */
        PlanCoberturaRequest.prototype.planCobertura = $util.emptyArray;

        /**
         * Creates a new PlanCoberturaRequest instance using the specified properties.
         * @function create
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {mirana.IPlanCoberturaRequest=} [properties] Properties to set
         * @returns {mirana.PlanCoberturaRequest} PlanCoberturaRequest instance
         */
        PlanCoberturaRequest.create = function create(properties) {
            return new PlanCoberturaRequest(properties);
        };

        /**
         * Encodes the specified PlanCoberturaRequest message. Does not implicitly {@link mirana.PlanCoberturaRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {mirana.IPlanCoberturaRequest} message PlanCoberturaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlanCoberturaRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.planCobertura != null && message.planCobertura.length)
                for (let i = 0; i < message.planCobertura.length; ++i)
                    $root.mirana.PlanCobertura.encode(message.planCobertura[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PlanCoberturaRequest message, length delimited. Does not implicitly {@link mirana.PlanCoberturaRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {mirana.IPlanCoberturaRequest} message PlanCoberturaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlanCoberturaRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlanCoberturaRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PlanCoberturaRequest} PlanCoberturaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlanCoberturaRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PlanCoberturaRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.planCobertura && message.planCobertura.length))
                        message.planCobertura = [];
                    message.planCobertura.push($root.mirana.PlanCobertura.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PlanCoberturaRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PlanCoberturaRequest} PlanCoberturaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlanCoberturaRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlanCoberturaRequest message.
         * @function verify
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlanCoberturaRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.planCobertura != null && message.hasOwnProperty("planCobertura")) {
                if (!Array.isArray(message.planCobertura))
                    return "planCobertura: array expected";
                for (let i = 0; i < message.planCobertura.length; ++i) {
                    let error = $root.mirana.PlanCobertura.verify(message.planCobertura[i]);
                    if (error)
                        return "planCobertura." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PlanCoberturaRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PlanCoberturaRequest} PlanCoberturaRequest
         */
        PlanCoberturaRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PlanCoberturaRequest)
                return object;
            let message = new $root.mirana.PlanCoberturaRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.planCobertura) {
                if (!Array.isArray(object.planCobertura))
                    throw TypeError(".mirana.PlanCoberturaRequest.planCobertura: array expected");
                message.planCobertura = [];
                for (let i = 0; i < object.planCobertura.length; ++i) {
                    if (typeof object.planCobertura[i] !== "object")
                        throw TypeError(".mirana.PlanCoberturaRequest.planCobertura: object expected");
                    message.planCobertura[i] = $root.mirana.PlanCobertura.fromObject(object.planCobertura[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PlanCoberturaRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PlanCoberturaRequest
         * @static
         * @param {mirana.PlanCoberturaRequest} message PlanCoberturaRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlanCoberturaRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.planCobertura = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.planCobertura && message.planCobertura.length) {
                object.planCobertura = [];
                for (let j = 0; j < message.planCobertura.length; ++j)
                    object.planCobertura[j] = $root.mirana.PlanCobertura.toObject(message.planCobertura[j], options);
            }
            return object;
        };

        /**
         * Converts this PlanCoberturaRequest to JSON.
         * @function toJSON
         * @memberof mirana.PlanCoberturaRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlanCoberturaRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlanCoberturaRequest;
    })();

    mirana.PlanCoberturaService = (function() {

        /**
         * Constructs a new PlanCoberturaService service.
         * @memberof mirana
         * @classdesc Represents a PlanCoberturaService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PlanCoberturaService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PlanCoberturaService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PlanCoberturaService;

        /**
         * Creates new PlanCoberturaService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.PlanCoberturaService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PlanCoberturaService} RPC service. Useful where requests and/or responses are streamed.
         */
        PlanCoberturaService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.PlanCoberturaService#syncPlanCobertura}.
         * @memberof mirana.PlanCoberturaService
         * @typedef syncPlanCoberturaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncPlanCobertura.
         * @function syncPlanCobertura
         * @memberof mirana.PlanCoberturaService
         * @instance
         * @param {mirana.IPlanCoberturaRequest} request PlanCoberturaRequest message or plain object
         * @param {mirana.PlanCoberturaService.syncPlanCoberturaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        PlanCoberturaService.prototype.syncPlanCobertura = function syncPlanCobertura(request, callback) {
            return this.rpcCall(syncPlanCobertura, $root.mirana.PlanCoberturaRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncPlanCobertura.
         * @function syncPlanCobertura
         * @memberof mirana.PlanCoberturaService
         * @instance
         * @param {mirana.IPlanCoberturaRequest} request PlanCoberturaRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return PlanCoberturaService;
    })();

    mirana.Visicooler = (function() {

        /**
         * Properties of a Visicooler.
         * @memberof mirana
         * @interface IVisicooler
         * @property {string|null} [fuerzaVentaId] Visicooler fuerzaVentaId
         * @property {string|null} [mesaId] Visicooler mesaId
         * @property {string|null} [mesaDescripcion] Visicooler mesaDescripcion
         * @property {string|null} [rutaId] Visicooler rutaId
         * @property {string|null} [vendedorId] Visicooler vendedorId
         * @property {string|null} [vendedorNombre] Visicooler vendedorNombre
         * @property {string|null} [moduloId] Visicooler moduloId
         * @property {string|null} [diaVisita] Visicooler diaVisita
         * @property {string|null} [clienteId] Visicooler clienteId
         * @property {string|null} [clienteRazonSocial] Visicooler clienteRazonSocial
         * @property {string|null} [clienteTipoDocumento] Visicooler clienteTipoDocumento
         * @property {string|null} [clienteNumeroDocumento] Visicooler clienteNumeroDocumento
         * @property {string|null} [clienteDireccion] Visicooler clienteDireccion
         * @property {string|null} [clienteDistrito] Visicooler clienteDistrito
         * @property {string|null} [clienteGiro] Visicooler clienteGiro
         * @property {string|null} [clienteLongitud] Visicooler clienteLongitud
         * @property {string|null} [clienteLatitud] Visicooler clienteLatitud
         * @property {number|null} [avance] Visicooler avance
         * @property {string|null} [fechaConsulta] Visicooler fechaConsulta
         */

        /**
         * Constructs a new Visicooler.
         * @memberof mirana
         * @classdesc Represents a Visicooler.
         * @implements IVisicooler
         * @constructor
         * @param {mirana.IVisicooler=} [properties] Properties to set
         */
        function Visicooler(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Visicooler fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.fuerzaVentaId = "";

        /**
         * Visicooler mesaId.
         * @member {string} mesaId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.mesaId = "";

        /**
         * Visicooler mesaDescripcion.
         * @member {string} mesaDescripcion
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.mesaDescripcion = "";

        /**
         * Visicooler rutaId.
         * @member {string} rutaId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.rutaId = "";

        /**
         * Visicooler vendedorId.
         * @member {string} vendedorId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.vendedorId = "";

        /**
         * Visicooler vendedorNombre.
         * @member {string} vendedorNombre
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.vendedorNombre = "";

        /**
         * Visicooler moduloId.
         * @member {string} moduloId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.moduloId = "";

        /**
         * Visicooler diaVisita.
         * @member {string} diaVisita
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.diaVisita = "";

        /**
         * Visicooler clienteId.
         * @member {string} clienteId
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteId = "";

        /**
         * Visicooler clienteRazonSocial.
         * @member {string} clienteRazonSocial
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteRazonSocial = "";

        /**
         * Visicooler clienteTipoDocumento.
         * @member {string} clienteTipoDocumento
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteTipoDocumento = "";

        /**
         * Visicooler clienteNumeroDocumento.
         * @member {string} clienteNumeroDocumento
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteNumeroDocumento = "";

        /**
         * Visicooler clienteDireccion.
         * @member {string} clienteDireccion
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteDireccion = "";

        /**
         * Visicooler clienteDistrito.
         * @member {string} clienteDistrito
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteDistrito = "";

        /**
         * Visicooler clienteGiro.
         * @member {string} clienteGiro
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteGiro = "";

        /**
         * Visicooler clienteLongitud.
         * @member {string} clienteLongitud
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteLongitud = "";

        /**
         * Visicooler clienteLatitud.
         * @member {string} clienteLatitud
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.clienteLatitud = "";

        /**
         * Visicooler avance.
         * @member {number} avance
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.avance = 0;

        /**
         * Visicooler fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.Visicooler
         * @instance
         */
        Visicooler.prototype.fechaConsulta = "";

        /**
         * Creates a new Visicooler instance using the specified properties.
         * @function create
         * @memberof mirana.Visicooler
         * @static
         * @param {mirana.IVisicooler=} [properties] Properties to set
         * @returns {mirana.Visicooler} Visicooler instance
         */
        Visicooler.create = function create(properties) {
            return new Visicooler(properties);
        };

        /**
         * Encodes the specified Visicooler message. Does not implicitly {@link mirana.Visicooler.verify|verify} messages.
         * @function encode
         * @memberof mirana.Visicooler
         * @static
         * @param {mirana.IVisicooler} message Visicooler message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Visicooler.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mesaId);
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mesaDescripcion);
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.rutaId);
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.vendedorId);
            if (message.vendedorNombre != null && message.hasOwnProperty("vendedorNombre"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.vendedorNombre);
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.moduloId);
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.diaVisita);
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.clienteId);
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.clienteRazonSocial);
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.clienteTipoDocumento);
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.clienteNumeroDocumento);
            if (message.clienteDireccion != null && message.hasOwnProperty("clienteDireccion"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.clienteDireccion);
            if (message.clienteDistrito != null && message.hasOwnProperty("clienteDistrito"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.clienteDistrito);
            if (message.clienteGiro != null && message.hasOwnProperty("clienteGiro"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.clienteGiro);
            if (message.clienteLongitud != null && message.hasOwnProperty("clienteLongitud"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.clienteLongitud);
            if (message.clienteLatitud != null && message.hasOwnProperty("clienteLatitud"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.clienteLatitud);
            if (message.avance != null && message.hasOwnProperty("avance"))
                writer.uint32(/* id 17, wireType 1 =*/137).double(message.avance);
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.fechaConsulta);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified Visicooler message, length delimited. Does not implicitly {@link mirana.Visicooler.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Visicooler
         * @static
         * @param {mirana.IVisicooler} message Visicooler message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Visicooler.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Visicooler message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Visicooler
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Visicooler} Visicooler
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Visicooler.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Visicooler();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 19:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 1:
                    message.mesaId = reader.string();
                    break;
                case 2:
                    message.mesaDescripcion = reader.string();
                    break;
                case 3:
                    message.rutaId = reader.string();
                    break;
                case 4:
                    message.vendedorId = reader.string();
                    break;
                case 5:
                    message.vendedorNombre = reader.string();
                    break;
                case 6:
                    message.moduloId = reader.string();
                    break;
                case 7:
                    message.diaVisita = reader.string();
                    break;
                case 8:
                    message.clienteId = reader.string();
                    break;
                case 9:
                    message.clienteRazonSocial = reader.string();
                    break;
                case 10:
                    message.clienteTipoDocumento = reader.string();
                    break;
                case 11:
                    message.clienteNumeroDocumento = reader.string();
                    break;
                case 12:
                    message.clienteDireccion = reader.string();
                    break;
                case 13:
                    message.clienteDistrito = reader.string();
                    break;
                case 14:
                    message.clienteGiro = reader.string();
                    break;
                case 15:
                    message.clienteLongitud = reader.string();
                    break;
                case 16:
                    message.clienteLatitud = reader.string();
                    break;
                case 17:
                    message.avance = reader.double();
                    break;
                case 18:
                    message.fechaConsulta = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Visicooler message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Visicooler
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Visicooler} Visicooler
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Visicooler.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Visicooler message.
         * @function verify
         * @memberof mirana.Visicooler
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Visicooler.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                if (!$util.isString(message.mesaDescripcion))
                    return "mesaDescripcion: string expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                if (!$util.isString(message.vendedorId))
                    return "vendedorId: string expected";
            if (message.vendedorNombre != null && message.hasOwnProperty("vendedorNombre"))
                if (!$util.isString(message.vendedorNombre))
                    return "vendedorNombre: string expected";
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                if (!$util.isString(message.moduloId))
                    return "moduloId: string expected";
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                if (!$util.isString(message.diaVisita))
                    return "diaVisita: string expected";
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                if (!$util.isString(message.clienteId))
                    return "clienteId: string expected";
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                if (!$util.isString(message.clienteRazonSocial))
                    return "clienteRazonSocial: string expected";
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                if (!$util.isString(message.clienteTipoDocumento))
                    return "clienteTipoDocumento: string expected";
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                if (!$util.isString(message.clienteNumeroDocumento))
                    return "clienteNumeroDocumento: string expected";
            if (message.clienteDireccion != null && message.hasOwnProperty("clienteDireccion"))
                if (!$util.isString(message.clienteDireccion))
                    return "clienteDireccion: string expected";
            if (message.clienteDistrito != null && message.hasOwnProperty("clienteDistrito"))
                if (!$util.isString(message.clienteDistrito))
                    return "clienteDistrito: string expected";
            if (message.clienteGiro != null && message.hasOwnProperty("clienteGiro"))
                if (!$util.isString(message.clienteGiro))
                    return "clienteGiro: string expected";
            if (message.clienteLongitud != null && message.hasOwnProperty("clienteLongitud"))
                if (!$util.isString(message.clienteLongitud))
                    return "clienteLongitud: string expected";
            if (message.clienteLatitud != null && message.hasOwnProperty("clienteLatitud"))
                if (!$util.isString(message.clienteLatitud))
                    return "clienteLatitud: string expected";
            if (message.avance != null && message.hasOwnProperty("avance"))
                if (typeof message.avance !== "number")
                    return "avance: number expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            return null;
        };

        /**
         * Creates a Visicooler message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Visicooler
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Visicooler} Visicooler
         */
        Visicooler.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Visicooler)
                return object;
            let message = new $root.mirana.Visicooler();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.mesaDescripcion != null)
                message.mesaDescripcion = String(object.mesaDescripcion);
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.vendedorId != null)
                message.vendedorId = String(object.vendedorId);
            if (object.vendedorNombre != null)
                message.vendedorNombre = String(object.vendedorNombre);
            if (object.moduloId != null)
                message.moduloId = String(object.moduloId);
            if (object.diaVisita != null)
                message.diaVisita = String(object.diaVisita);
            if (object.clienteId != null)
                message.clienteId = String(object.clienteId);
            if (object.clienteRazonSocial != null)
                message.clienteRazonSocial = String(object.clienteRazonSocial);
            if (object.clienteTipoDocumento != null)
                message.clienteTipoDocumento = String(object.clienteTipoDocumento);
            if (object.clienteNumeroDocumento != null)
                message.clienteNumeroDocumento = String(object.clienteNumeroDocumento);
            if (object.clienteDireccion != null)
                message.clienteDireccion = String(object.clienteDireccion);
            if (object.clienteDistrito != null)
                message.clienteDistrito = String(object.clienteDistrito);
            if (object.clienteGiro != null)
                message.clienteGiro = String(object.clienteGiro);
            if (object.clienteLongitud != null)
                message.clienteLongitud = String(object.clienteLongitud);
            if (object.clienteLatitud != null)
                message.clienteLatitud = String(object.clienteLatitud);
            if (object.avance != null)
                message.avance = Number(object.avance);
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            return message;
        };

        /**
         * Creates a plain object from a Visicooler message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Visicooler
         * @static
         * @param {mirana.Visicooler} message Visicooler
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Visicooler.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.mesaId = "";
                object.mesaDescripcion = "";
                object.rutaId = "";
                object.vendedorId = "";
                object.vendedorNombre = "";
                object.moduloId = "";
                object.diaVisita = "";
                object.clienteId = "";
                object.clienteRazonSocial = "";
                object.clienteTipoDocumento = "";
                object.clienteNumeroDocumento = "";
                object.clienteDireccion = "";
                object.clienteDistrito = "";
                object.clienteGiro = "";
                object.clienteLongitud = "";
                object.clienteLatitud = "";
                object.avance = 0;
                object.fechaConsulta = "";
                object.fuerzaVentaId = "";
            }
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                object.mesaDescripcion = message.mesaDescripcion;
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                object.vendedorId = message.vendedorId;
            if (message.vendedorNombre != null && message.hasOwnProperty("vendedorNombre"))
                object.vendedorNombre = message.vendedorNombre;
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                object.moduloId = message.moduloId;
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                object.diaVisita = message.diaVisita;
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                object.clienteId = message.clienteId;
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                object.clienteRazonSocial = message.clienteRazonSocial;
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                object.clienteTipoDocumento = message.clienteTipoDocumento;
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                object.clienteNumeroDocumento = message.clienteNumeroDocumento;
            if (message.clienteDireccion != null && message.hasOwnProperty("clienteDireccion"))
                object.clienteDireccion = message.clienteDireccion;
            if (message.clienteDistrito != null && message.hasOwnProperty("clienteDistrito"))
                object.clienteDistrito = message.clienteDistrito;
            if (message.clienteGiro != null && message.hasOwnProperty("clienteGiro"))
                object.clienteGiro = message.clienteGiro;
            if (message.clienteLongitud != null && message.hasOwnProperty("clienteLongitud"))
                object.clienteLongitud = message.clienteLongitud;
            if (message.clienteLatitud != null && message.hasOwnProperty("clienteLatitud"))
                object.clienteLatitud = message.clienteLatitud;
            if (message.avance != null && message.hasOwnProperty("avance"))
                object.avance = options.json && !isFinite(message.avance) ? String(message.avance) : message.avance;
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this Visicooler to JSON.
         * @function toJSON
         * @memberof mirana.Visicooler
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Visicooler.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Visicooler;
    })();

    mirana.VisicoolerResumen = (function() {

        /**
         * Properties of a VisicoolerResumen.
         * @memberof mirana
         * @interface IVisicoolerResumen
         * @property {string|null} [mesaId] VisicoolerResumen mesaId
         * @property {string|null} [mesaDescripcion] VisicoolerResumen mesaDescripcion
         * @property {string|null} [rutaId] VisicoolerResumen rutaId
         * @property {number|null} [aceptable] VisicoolerResumen aceptable
         * @property {number|null} [regular] VisicoolerResumen regular
         * @property {number|null} [deficiente] VisicoolerResumen deficiente
         * @property {number|null} [alerta] VisicoolerResumen alerta
         * @property {number|null} [total] VisicoolerResumen total
         */

        /**
         * Constructs a new VisicoolerResumen.
         * @memberof mirana
         * @classdesc Represents a VisicoolerResumen.
         * @implements IVisicoolerResumen
         * @constructor
         * @param {mirana.IVisicoolerResumen=} [properties] Properties to set
         */
        function VisicoolerResumen(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VisicoolerResumen mesaId.
         * @member {string} mesaId
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.mesaId = "";

        /**
         * VisicoolerResumen mesaDescripcion.
         * @member {string} mesaDescripcion
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.mesaDescripcion = "";

        /**
         * VisicoolerResumen rutaId.
         * @member {string} rutaId
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.rutaId = "";

        /**
         * VisicoolerResumen aceptable.
         * @member {number} aceptable
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.aceptable = 0;

        /**
         * VisicoolerResumen regular.
         * @member {number} regular
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.regular = 0;

        /**
         * VisicoolerResumen deficiente.
         * @member {number} deficiente
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.deficiente = 0;

        /**
         * VisicoolerResumen alerta.
         * @member {number} alerta
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.alerta = 0;

        /**
         * VisicoolerResumen total.
         * @member {number} total
         * @memberof mirana.VisicoolerResumen
         * @instance
         */
        VisicoolerResumen.prototype.total = 0;

        /**
         * Creates a new VisicoolerResumen instance using the specified properties.
         * @function create
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {mirana.IVisicoolerResumen=} [properties] Properties to set
         * @returns {mirana.VisicoolerResumen} VisicoolerResumen instance
         */
        VisicoolerResumen.create = function create(properties) {
            return new VisicoolerResumen(properties);
        };

        /**
         * Encodes the specified VisicoolerResumen message. Does not implicitly {@link mirana.VisicoolerResumen.verify|verify} messages.
         * @function encode
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {mirana.IVisicoolerResumen} message VisicoolerResumen message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerResumen.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mesaId);
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mesaDescripcion);
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.rutaId);
            if (message.aceptable != null && message.hasOwnProperty("aceptable"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.aceptable);
            if (message.regular != null && message.hasOwnProperty("regular"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.regular);
            if (message.deficiente != null && message.hasOwnProperty("deficiente"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.deficiente);
            if (message.alerta != null && message.hasOwnProperty("alerta"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.alerta);
            if (message.total != null && message.hasOwnProperty("total"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.total);
            return writer;
        };

        /**
         * Encodes the specified VisicoolerResumen message, length delimited. Does not implicitly {@link mirana.VisicoolerResumen.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {mirana.IVisicoolerResumen} message VisicoolerResumen message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerResumen.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VisicoolerResumen message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.VisicoolerResumen} VisicoolerResumen
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerResumen.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.VisicoolerResumen();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mesaId = reader.string();
                    break;
                case 2:
                    message.mesaDescripcion = reader.string();
                    break;
                case 3:
                    message.rutaId = reader.string();
                    break;
                case 4:
                    message.aceptable = reader.int32();
                    break;
                case 5:
                    message.regular = reader.int32();
                    break;
                case 6:
                    message.deficiente = reader.int32();
                    break;
                case 7:
                    message.alerta = reader.int32();
                    break;
                case 8:
                    message.total = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VisicoolerResumen message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.VisicoolerResumen} VisicoolerResumen
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerResumen.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VisicoolerResumen message.
         * @function verify
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VisicoolerResumen.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                if (!$util.isString(message.mesaDescripcion))
                    return "mesaDescripcion: string expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.aceptable != null && message.hasOwnProperty("aceptable"))
                if (!$util.isInteger(message.aceptable))
                    return "aceptable: integer expected";
            if (message.regular != null && message.hasOwnProperty("regular"))
                if (!$util.isInteger(message.regular))
                    return "regular: integer expected";
            if (message.deficiente != null && message.hasOwnProperty("deficiente"))
                if (!$util.isInteger(message.deficiente))
                    return "deficiente: integer expected";
            if (message.alerta != null && message.hasOwnProperty("alerta"))
                if (!$util.isInteger(message.alerta))
                    return "alerta: integer expected";
            if (message.total != null && message.hasOwnProperty("total"))
                if (!$util.isInteger(message.total))
                    return "total: integer expected";
            return null;
        };

        /**
         * Creates a VisicoolerResumen message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.VisicoolerResumen} VisicoolerResumen
         */
        VisicoolerResumen.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.VisicoolerResumen)
                return object;
            let message = new $root.mirana.VisicoolerResumen();
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.mesaDescripcion != null)
                message.mesaDescripcion = String(object.mesaDescripcion);
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.aceptable != null)
                message.aceptable = object.aceptable | 0;
            if (object.regular != null)
                message.regular = object.regular | 0;
            if (object.deficiente != null)
                message.deficiente = object.deficiente | 0;
            if (object.alerta != null)
                message.alerta = object.alerta | 0;
            if (object.total != null)
                message.total = object.total | 0;
            return message;
        };

        /**
         * Creates a plain object from a VisicoolerResumen message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.VisicoolerResumen
         * @static
         * @param {mirana.VisicoolerResumen} message VisicoolerResumen
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VisicoolerResumen.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.mesaId = "";
                object.mesaDescripcion = "";
                object.rutaId = "";
                object.aceptable = 0;
                object.regular = 0;
                object.deficiente = 0;
                object.alerta = 0;
                object.total = 0;
            }
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.mesaDescripcion != null && message.hasOwnProperty("mesaDescripcion"))
                object.mesaDescripcion = message.mesaDescripcion;
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.aceptable != null && message.hasOwnProperty("aceptable"))
                object.aceptable = message.aceptable;
            if (message.regular != null && message.hasOwnProperty("regular"))
                object.regular = message.regular;
            if (message.deficiente != null && message.hasOwnProperty("deficiente"))
                object.deficiente = message.deficiente;
            if (message.alerta != null && message.hasOwnProperty("alerta"))
                object.alerta = message.alerta;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this VisicoolerResumen to JSON.
         * @function toJSON
         * @memberof mirana.VisicoolerResumen
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VisicoolerResumen.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VisicoolerResumen;
    })();

    mirana.VisicoolerModelo = (function() {

        /**
         * Properties of a VisicoolerModelo.
         * @memberof mirana
         * @interface IVisicoolerModelo
         * @property {string|null} [fuerzaVentaId] VisicoolerModelo fuerzaVentaId
         * @property {number|null} [modeloId] VisicoolerModelo modeloId
         * @property {string|null} [descripcion] VisicoolerModelo descripcion
         * @property {number|null} [cuota] VisicoolerModelo cuota
         * @property {number|null} [estado] VisicoolerModelo estado
         * @property {string|null} [estadoStr] VisicoolerModelo estadoStr
         */

        /**
         * Constructs a new VisicoolerModelo.
         * @memberof mirana
         * @classdesc Represents a VisicoolerModelo.
         * @implements IVisicoolerModelo
         * @constructor
         * @param {mirana.IVisicoolerModelo=} [properties] Properties to set
         */
        function VisicoolerModelo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VisicoolerModelo fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.fuerzaVentaId = "";

        /**
         * VisicoolerModelo modeloId.
         * @member {number} modeloId
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.modeloId = 0;

        /**
         * VisicoolerModelo descripcion.
         * @member {string} descripcion
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.descripcion = "";

        /**
         * VisicoolerModelo cuota.
         * @member {number} cuota
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.cuota = 0;

        /**
         * VisicoolerModelo estado.
         * @member {number} estado
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.estado = 0;

        /**
         * VisicoolerModelo estadoStr.
         * @member {string} estadoStr
         * @memberof mirana.VisicoolerModelo
         * @instance
         */
        VisicoolerModelo.prototype.estadoStr = "";

        /**
         * Creates a new VisicoolerModelo instance using the specified properties.
         * @function create
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {mirana.IVisicoolerModelo=} [properties] Properties to set
         * @returns {mirana.VisicoolerModelo} VisicoolerModelo instance
         */
        VisicoolerModelo.create = function create(properties) {
            return new VisicoolerModelo(properties);
        };

        /**
         * Encodes the specified VisicoolerModelo message. Does not implicitly {@link mirana.VisicoolerModelo.verify|verify} messages.
         * @function encode
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {mirana.IVisicoolerModelo} message VisicoolerModelo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerModelo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.modeloId);
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.descripcion);
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.cuota);
            if (message.estado != null && message.hasOwnProperty("estado"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.estado);
            if (message.estadoStr != null && message.hasOwnProperty("estadoStr"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.estadoStr);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified VisicoolerModelo message, length delimited. Does not implicitly {@link mirana.VisicoolerModelo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {mirana.IVisicoolerModelo} message VisicoolerModelo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerModelo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VisicoolerModelo message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.VisicoolerModelo} VisicoolerModelo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerModelo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.VisicoolerModelo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 6:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 1:
                    message.modeloId = reader.int32();
                    break;
                case 2:
                    message.descripcion = reader.string();
                    break;
                case 3:
                    message.cuota = reader.double();
                    break;
                case 4:
                    message.estado = reader.int32();
                    break;
                case 5:
                    message.estadoStr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VisicoolerModelo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.VisicoolerModelo} VisicoolerModelo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerModelo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VisicoolerModelo message.
         * @function verify
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VisicoolerModelo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                if (!$util.isInteger(message.modeloId))
                    return "modeloId: integer expected";
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                if (!$util.isString(message.descripcion))
                    return "descripcion: string expected";
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                if (typeof message.cuota !== "number")
                    return "cuota: number expected";
            if (message.estado != null && message.hasOwnProperty("estado"))
                if (!$util.isInteger(message.estado))
                    return "estado: integer expected";
            if (message.estadoStr != null && message.hasOwnProperty("estadoStr"))
                if (!$util.isString(message.estadoStr))
                    return "estadoStr: string expected";
            return null;
        };

        /**
         * Creates a VisicoolerModelo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.VisicoolerModelo} VisicoolerModelo
         */
        VisicoolerModelo.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.VisicoolerModelo)
                return object;
            let message = new $root.mirana.VisicoolerModelo();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.modeloId != null)
                message.modeloId = object.modeloId | 0;
            if (object.descripcion != null)
                message.descripcion = String(object.descripcion);
            if (object.cuota != null)
                message.cuota = Number(object.cuota);
            if (object.estado != null)
                message.estado = object.estado | 0;
            if (object.estadoStr != null)
                message.estadoStr = String(object.estadoStr);
            return message;
        };

        /**
         * Creates a plain object from a VisicoolerModelo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.VisicoolerModelo
         * @static
         * @param {mirana.VisicoolerModelo} message VisicoolerModelo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VisicoolerModelo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.modeloId = 0;
                object.descripcion = "";
                object.cuota = 0;
                object.estado = 0;
                object.estadoStr = "";
                object.fuerzaVentaId = "";
            }
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                object.modeloId = message.modeloId;
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                object.descripcion = message.descripcion;
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                object.cuota = options.json && !isFinite(message.cuota) ? String(message.cuota) : message.cuota;
            if (message.estado != null && message.hasOwnProperty("estado"))
                object.estado = message.estado;
            if (message.estadoStr != null && message.hasOwnProperty("estadoStr"))
                object.estadoStr = message.estadoStr;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this VisicoolerModelo to JSON.
         * @function toJSON
         * @memberof mirana.VisicoolerModelo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VisicoolerModelo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VisicoolerModelo;
    })();

    mirana.UIVisicooler = (function() {

        /**
         * Properties of a UIVisicooler.
         * @memberof mirana
         * @interface IUIVisicooler
         * @property {string|null} [fuerzaVentaId] UIVisicooler fuerzaVentaId
         * @property {string|null} [mesaId] UIVisicooler mesaId
         * @property {string|null} [mesa] UIVisicooler mesa
         * @property {string|null} [ruta] UIVisicooler ruta
         * @property {string|null} [diaVisita] UIVisicooler diaVisita
         * @property {string|null} [clienteId] UIVisicooler clienteId
         * @property {string|null} [clienteTipoDocumento] UIVisicooler clienteTipoDocumento
         * @property {string|null} [clienteNumeroDocumento] UIVisicooler clienteNumeroDocumento
         * @property {string|null} [clienteRazonSocial] UIVisicooler clienteRazonSocial
         * @property {string|null} [modelo] UIVisicooler modelo
         * @property {string|null} [estado] UIVisicooler estado
         * @property {string|null} [avanceCuota] UIVisicooler avanceCuota
         * @property {number|null} [productividad] UIVisicooler productividad
         * @property {string|null} [moduloId] UIVisicooler moduloId
         * @property {string|null} [direccion] UIVisicooler direccion
         * @property {string|null} [distrito] UIVisicooler distrito
         * @property {string|null} [giro] UIVisicooler giro
         * @property {string|null} [longitud] UIVisicooler longitud
         * @property {string|null} [latitud] UIVisicooler latitud
         * @property {string|null} [vendedor] UIVisicooler vendedor
         * @property {number|null} [modeloId] UIVisicooler modeloId
         * @property {number|null} [avance] UIVisicooler avance
         * @property {number|null} [cuota] UIVisicooler cuota
         * @property {string|null} [rango] UIVisicooler rango
         * @property {number|null} [estadoId] UIVisicooler estadoId
         */

        /**
         * Constructs a new UIVisicooler.
         * @memberof mirana
         * @classdesc Represents a UIVisicooler.
         * @implements IUIVisicooler
         * @constructor
         * @param {mirana.IUIVisicooler=} [properties] Properties to set
         */
        function UIVisicooler(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UIVisicooler fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.fuerzaVentaId = "";

        /**
         * UIVisicooler mesaId.
         * @member {string} mesaId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.mesaId = "";

        /**
         * UIVisicooler mesa.
         * @member {string} mesa
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.mesa = "";

        /**
         * UIVisicooler ruta.
         * @member {string} ruta
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.ruta = "";

        /**
         * UIVisicooler diaVisita.
         * @member {string} diaVisita
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.diaVisita = "";

        /**
         * UIVisicooler clienteId.
         * @member {string} clienteId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.clienteId = "";

        /**
         * UIVisicooler clienteTipoDocumento.
         * @member {string} clienteTipoDocumento
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.clienteTipoDocumento = "";

        /**
         * UIVisicooler clienteNumeroDocumento.
         * @member {string} clienteNumeroDocumento
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.clienteNumeroDocumento = "";

        /**
         * UIVisicooler clienteRazonSocial.
         * @member {string} clienteRazonSocial
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.clienteRazonSocial = "";

        /**
         * UIVisicooler modelo.
         * @member {string} modelo
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.modelo = "";

        /**
         * UIVisicooler estado.
         * @member {string} estado
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.estado = "";

        /**
         * UIVisicooler avanceCuota.
         * @member {string} avanceCuota
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.avanceCuota = "";

        /**
         * UIVisicooler productividad.
         * @member {number} productividad
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.productividad = 0;

        /**
         * UIVisicooler moduloId.
         * @member {string} moduloId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.moduloId = "";

        /**
         * UIVisicooler direccion.
         * @member {string} direccion
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.direccion = "";

        /**
         * UIVisicooler distrito.
         * @member {string} distrito
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.distrito = "";

        /**
         * UIVisicooler giro.
         * @member {string} giro
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.giro = "";

        /**
         * UIVisicooler longitud.
         * @member {string} longitud
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.longitud = "";

        /**
         * UIVisicooler latitud.
         * @member {string} latitud
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.latitud = "";

        /**
         * UIVisicooler vendedor.
         * @member {string} vendedor
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.vendedor = "";

        /**
         * UIVisicooler modeloId.
         * @member {number} modeloId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.modeloId = 0;

        /**
         * UIVisicooler avance.
         * @member {number} avance
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.avance = 0;

        /**
         * UIVisicooler cuota.
         * @member {number} cuota
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.cuota = 0;

        /**
         * UIVisicooler rango.
         * @member {string} rango
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.rango = "";

        /**
         * UIVisicooler estadoId.
         * @member {number} estadoId
         * @memberof mirana.UIVisicooler
         * @instance
         */
        UIVisicooler.prototype.estadoId = 0;

        /**
         * Creates a new UIVisicooler instance using the specified properties.
         * @function create
         * @memberof mirana.UIVisicooler
         * @static
         * @param {mirana.IUIVisicooler=} [properties] Properties to set
         * @returns {mirana.UIVisicooler} UIVisicooler instance
         */
        UIVisicooler.create = function create(properties) {
            return new UIVisicooler(properties);
        };

        /**
         * Encodes the specified UIVisicooler message. Does not implicitly {@link mirana.UIVisicooler.verify|verify} messages.
         * @function encode
         * @memberof mirana.UIVisicooler
         * @static
         * @param {mirana.IUIVisicooler} message UIVisicooler message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIVisicooler.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mesaId);
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mesa);
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.ruta);
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.diaVisita);
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clienteId);
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.clienteTipoDocumento);
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.clienteNumeroDocumento);
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.clienteRazonSocial);
            if (message.modelo != null && message.hasOwnProperty("modelo"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.modelo);
            if (message.estado != null && message.hasOwnProperty("estado"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.estado);
            if (message.avanceCuota != null && message.hasOwnProperty("avanceCuota"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.avanceCuota);
            if (message.productividad != null && message.hasOwnProperty("productividad"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.productividad);
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.moduloId);
            if (message.direccion != null && message.hasOwnProperty("direccion"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.direccion);
            if (message.distrito != null && message.hasOwnProperty("distrito"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.distrito);
            if (message.giro != null && message.hasOwnProperty("giro"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.giro);
            if (message.longitud != null && message.hasOwnProperty("longitud"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.longitud);
            if (message.latitud != null && message.hasOwnProperty("latitud"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.latitud);
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.vendedor);
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.modeloId);
            if (message.avance != null && message.hasOwnProperty("avance"))
                writer.uint32(/* id 21, wireType 1 =*/169).double(message.avance);
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                writer.uint32(/* id 22, wireType 1 =*/177).double(message.cuota);
            if (message.rango != null && message.hasOwnProperty("rango"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.rango);
            if (message.estadoId != null && message.hasOwnProperty("estadoId"))
                writer.uint32(/* id 24, wireType 0 =*/192).int32(message.estadoId);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 25, wireType 2 =*/202).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified UIVisicooler message, length delimited. Does not implicitly {@link mirana.UIVisicooler.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UIVisicooler
         * @static
         * @param {mirana.IUIVisicooler} message UIVisicooler message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIVisicooler.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UIVisicooler message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UIVisicooler
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UIVisicooler} UIVisicooler
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIVisicooler.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UIVisicooler();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 25:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 1:
                    message.mesaId = reader.string();
                    break;
                case 2:
                    message.mesa = reader.string();
                    break;
                case 3:
                    message.ruta = reader.string();
                    break;
                case 4:
                    message.diaVisita = reader.string();
                    break;
                case 5:
                    message.clienteId = reader.string();
                    break;
                case 6:
                    message.clienteTipoDocumento = reader.string();
                    break;
                case 7:
                    message.clienteNumeroDocumento = reader.string();
                    break;
                case 8:
                    message.clienteRazonSocial = reader.string();
                    break;
                case 9:
                    message.modelo = reader.string();
                    break;
                case 10:
                    message.estado = reader.string();
                    break;
                case 11:
                    message.avanceCuota = reader.string();
                    break;
                case 12:
                    message.productividad = reader.double();
                    break;
                case 13:
                    message.moduloId = reader.string();
                    break;
                case 14:
                    message.direccion = reader.string();
                    break;
                case 15:
                    message.distrito = reader.string();
                    break;
                case 16:
                    message.giro = reader.string();
                    break;
                case 17:
                    message.longitud = reader.string();
                    break;
                case 18:
                    message.latitud = reader.string();
                    break;
                case 19:
                    message.vendedor = reader.string();
                    break;
                case 20:
                    message.modeloId = reader.int32();
                    break;
                case 21:
                    message.avance = reader.double();
                    break;
                case 22:
                    message.cuota = reader.double();
                    break;
                case 23:
                    message.rango = reader.string();
                    break;
                case 24:
                    message.estadoId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UIVisicooler message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UIVisicooler
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UIVisicooler} UIVisicooler
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIVisicooler.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UIVisicooler message.
         * @function verify
         * @memberof mirana.UIVisicooler
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UIVisicooler.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                if (!$util.isString(message.mesa))
                    return "mesa: string expected";
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                if (!$util.isString(message.ruta))
                    return "ruta: string expected";
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                if (!$util.isString(message.diaVisita))
                    return "diaVisita: string expected";
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                if (!$util.isString(message.clienteId))
                    return "clienteId: string expected";
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                if (!$util.isString(message.clienteTipoDocumento))
                    return "clienteTipoDocumento: string expected";
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                if (!$util.isString(message.clienteNumeroDocumento))
                    return "clienteNumeroDocumento: string expected";
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                if (!$util.isString(message.clienteRazonSocial))
                    return "clienteRazonSocial: string expected";
            if (message.modelo != null && message.hasOwnProperty("modelo"))
                if (!$util.isString(message.modelo))
                    return "modelo: string expected";
            if (message.estado != null && message.hasOwnProperty("estado"))
                if (!$util.isString(message.estado))
                    return "estado: string expected";
            if (message.avanceCuota != null && message.hasOwnProperty("avanceCuota"))
                if (!$util.isString(message.avanceCuota))
                    return "avanceCuota: string expected";
            if (message.productividad != null && message.hasOwnProperty("productividad"))
                if (typeof message.productividad !== "number")
                    return "productividad: number expected";
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                if (!$util.isString(message.moduloId))
                    return "moduloId: string expected";
            if (message.direccion != null && message.hasOwnProperty("direccion"))
                if (!$util.isString(message.direccion))
                    return "direccion: string expected";
            if (message.distrito != null && message.hasOwnProperty("distrito"))
                if (!$util.isString(message.distrito))
                    return "distrito: string expected";
            if (message.giro != null && message.hasOwnProperty("giro"))
                if (!$util.isString(message.giro))
                    return "giro: string expected";
            if (message.longitud != null && message.hasOwnProperty("longitud"))
                if (!$util.isString(message.longitud))
                    return "longitud: string expected";
            if (message.latitud != null && message.hasOwnProperty("latitud"))
                if (!$util.isString(message.latitud))
                    return "latitud: string expected";
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                if (!$util.isString(message.vendedor))
                    return "vendedor: string expected";
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                if (!$util.isInteger(message.modeloId))
                    return "modeloId: integer expected";
            if (message.avance != null && message.hasOwnProperty("avance"))
                if (typeof message.avance !== "number")
                    return "avance: number expected";
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                if (typeof message.cuota !== "number")
                    return "cuota: number expected";
            if (message.rango != null && message.hasOwnProperty("rango"))
                if (!$util.isString(message.rango))
                    return "rango: string expected";
            if (message.estadoId != null && message.hasOwnProperty("estadoId"))
                if (!$util.isInteger(message.estadoId))
                    return "estadoId: integer expected";
            return null;
        };

        /**
         * Creates a UIVisicooler message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UIVisicooler
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UIVisicooler} UIVisicooler
         */
        UIVisicooler.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UIVisicooler)
                return object;
            let message = new $root.mirana.UIVisicooler();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.mesa != null)
                message.mesa = String(object.mesa);
            if (object.ruta != null)
                message.ruta = String(object.ruta);
            if (object.diaVisita != null)
                message.diaVisita = String(object.diaVisita);
            if (object.clienteId != null)
                message.clienteId = String(object.clienteId);
            if (object.clienteTipoDocumento != null)
                message.clienteTipoDocumento = String(object.clienteTipoDocumento);
            if (object.clienteNumeroDocumento != null)
                message.clienteNumeroDocumento = String(object.clienteNumeroDocumento);
            if (object.clienteRazonSocial != null)
                message.clienteRazonSocial = String(object.clienteRazonSocial);
            if (object.modelo != null)
                message.modelo = String(object.modelo);
            if (object.estado != null)
                message.estado = String(object.estado);
            if (object.avanceCuota != null)
                message.avanceCuota = String(object.avanceCuota);
            if (object.productividad != null)
                message.productividad = Number(object.productividad);
            if (object.moduloId != null)
                message.moduloId = String(object.moduloId);
            if (object.direccion != null)
                message.direccion = String(object.direccion);
            if (object.distrito != null)
                message.distrito = String(object.distrito);
            if (object.giro != null)
                message.giro = String(object.giro);
            if (object.longitud != null)
                message.longitud = String(object.longitud);
            if (object.latitud != null)
                message.latitud = String(object.latitud);
            if (object.vendedor != null)
                message.vendedor = String(object.vendedor);
            if (object.modeloId != null)
                message.modeloId = object.modeloId | 0;
            if (object.avance != null)
                message.avance = Number(object.avance);
            if (object.cuota != null)
                message.cuota = Number(object.cuota);
            if (object.rango != null)
                message.rango = String(object.rango);
            if (object.estadoId != null)
                message.estadoId = object.estadoId | 0;
            return message;
        };

        /**
         * Creates a plain object from a UIVisicooler message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UIVisicooler
         * @static
         * @param {mirana.UIVisicooler} message UIVisicooler
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UIVisicooler.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.mesaId = "";
                object.mesa = "";
                object.ruta = "";
                object.diaVisita = "";
                object.clienteId = "";
                object.clienteTipoDocumento = "";
                object.clienteNumeroDocumento = "";
                object.clienteRazonSocial = "";
                object.modelo = "";
                object.estado = "";
                object.avanceCuota = "";
                object.productividad = 0;
                object.moduloId = "";
                object.direccion = "";
                object.distrito = "";
                object.giro = "";
                object.longitud = "";
                object.latitud = "";
                object.vendedor = "";
                object.modeloId = 0;
                object.avance = 0;
                object.cuota = 0;
                object.rango = "";
                object.estadoId = 0;
                object.fuerzaVentaId = "";
            }
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                object.mesa = message.mesa;
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                object.ruta = message.ruta;
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                object.diaVisita = message.diaVisita;
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                object.clienteId = message.clienteId;
            if (message.clienteTipoDocumento != null && message.hasOwnProperty("clienteTipoDocumento"))
                object.clienteTipoDocumento = message.clienteTipoDocumento;
            if (message.clienteNumeroDocumento != null && message.hasOwnProperty("clienteNumeroDocumento"))
                object.clienteNumeroDocumento = message.clienteNumeroDocumento;
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                object.clienteRazonSocial = message.clienteRazonSocial;
            if (message.modelo != null && message.hasOwnProperty("modelo"))
                object.modelo = message.modelo;
            if (message.estado != null && message.hasOwnProperty("estado"))
                object.estado = message.estado;
            if (message.avanceCuota != null && message.hasOwnProperty("avanceCuota"))
                object.avanceCuota = message.avanceCuota;
            if (message.productividad != null && message.hasOwnProperty("productividad"))
                object.productividad = options.json && !isFinite(message.productividad) ? String(message.productividad) : message.productividad;
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                object.moduloId = message.moduloId;
            if (message.direccion != null && message.hasOwnProperty("direccion"))
                object.direccion = message.direccion;
            if (message.distrito != null && message.hasOwnProperty("distrito"))
                object.distrito = message.distrito;
            if (message.giro != null && message.hasOwnProperty("giro"))
                object.giro = message.giro;
            if (message.longitud != null && message.hasOwnProperty("longitud"))
                object.longitud = message.longitud;
            if (message.latitud != null && message.hasOwnProperty("latitud"))
                object.latitud = message.latitud;
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                object.vendedor = message.vendedor;
            if (message.modeloId != null && message.hasOwnProperty("modeloId"))
                object.modeloId = message.modeloId;
            if (message.avance != null && message.hasOwnProperty("avance"))
                object.avance = options.json && !isFinite(message.avance) ? String(message.avance) : message.avance;
            if (message.cuota != null && message.hasOwnProperty("cuota"))
                object.cuota = options.json && !isFinite(message.cuota) ? String(message.cuota) : message.cuota;
            if (message.rango != null && message.hasOwnProperty("rango"))
                object.rango = message.rango;
            if (message.estadoId != null && message.hasOwnProperty("estadoId"))
                object.estadoId = message.estadoId;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this UIVisicooler to JSON.
         * @function toJSON
         * @memberof mirana.UIVisicooler
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UIVisicooler.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UIVisicooler;
    })();

    mirana.BuscarVisicoolersResponse = (function() {

        /**
         * Properties of a BuscarVisicoolersResponse.
         * @memberof mirana
         * @interface IBuscarVisicoolersResponse
         * @property {Array.<mirana.IUIVisicooler>|null} [visicoolers] BuscarVisicoolersResponse visicoolers
         * @property {number|null} [numFound] BuscarVisicoolersResponse numFound
         * @property {number|null} [pageSize] BuscarVisicoolersResponse pageSize
         * @property {number|null} [page] BuscarVisicoolersResponse page
         */

        /**
         * Constructs a new BuscarVisicoolersResponse.
         * @memberof mirana
         * @classdesc Represents a BuscarVisicoolersResponse.
         * @implements IBuscarVisicoolersResponse
         * @constructor
         * @param {mirana.IBuscarVisicoolersResponse=} [properties] Properties to set
         */
        function BuscarVisicoolersResponse(properties) {
            this.visicoolers = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BuscarVisicoolersResponse visicoolers.
         * @member {Array.<mirana.IUIVisicooler>} visicoolers
         * @memberof mirana.BuscarVisicoolersResponse
         * @instance
         */
        BuscarVisicoolersResponse.prototype.visicoolers = $util.emptyArray;

        /**
         * BuscarVisicoolersResponse numFound.
         * @member {number} numFound
         * @memberof mirana.BuscarVisicoolersResponse
         * @instance
         */
        BuscarVisicoolersResponse.prototype.numFound = 0;

        /**
         * BuscarVisicoolersResponse pageSize.
         * @member {number} pageSize
         * @memberof mirana.BuscarVisicoolersResponse
         * @instance
         */
        BuscarVisicoolersResponse.prototype.pageSize = 0;

        /**
         * BuscarVisicoolersResponse page.
         * @member {number} page
         * @memberof mirana.BuscarVisicoolersResponse
         * @instance
         */
        BuscarVisicoolersResponse.prototype.page = 0;

        /**
         * Creates a new BuscarVisicoolersResponse instance using the specified properties.
         * @function create
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {mirana.IBuscarVisicoolersResponse=} [properties] Properties to set
         * @returns {mirana.BuscarVisicoolersResponse} BuscarVisicoolersResponse instance
         */
        BuscarVisicoolersResponse.create = function create(properties) {
            return new BuscarVisicoolersResponse(properties);
        };

        /**
         * Encodes the specified BuscarVisicoolersResponse message. Does not implicitly {@link mirana.BuscarVisicoolersResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {mirana.IBuscarVisicoolersResponse} message BuscarVisicoolersResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BuscarVisicoolersResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.visicoolers != null && message.visicoolers.length)
                for (let i = 0; i < message.visicoolers.length; ++i)
                    $root.mirana.UIVisicooler.encode(message.visicoolers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.numFound != null && message.hasOwnProperty("numFound"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numFound);
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
            if (message.page != null && message.hasOwnProperty("page"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.page);
            return writer;
        };

        /**
         * Encodes the specified BuscarVisicoolersResponse message, length delimited. Does not implicitly {@link mirana.BuscarVisicoolersResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {mirana.IBuscarVisicoolersResponse} message BuscarVisicoolersResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BuscarVisicoolersResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BuscarVisicoolersResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.BuscarVisicoolersResponse} BuscarVisicoolersResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BuscarVisicoolersResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.BuscarVisicoolersResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.visicoolers && message.visicoolers.length))
                        message.visicoolers = [];
                    message.visicoolers.push($root.mirana.UIVisicooler.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.numFound = reader.int32();
                    break;
                case 3:
                    message.pageSize = reader.int32();
                    break;
                case 4:
                    message.page = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BuscarVisicoolersResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.BuscarVisicoolersResponse} BuscarVisicoolersResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BuscarVisicoolersResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BuscarVisicoolersResponse message.
         * @function verify
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BuscarVisicoolersResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.visicoolers != null && message.hasOwnProperty("visicoolers")) {
                if (!Array.isArray(message.visicoolers))
                    return "visicoolers: array expected";
                for (let i = 0; i < message.visicoolers.length; ++i) {
                    let error = $root.mirana.UIVisicooler.verify(message.visicoolers[i]);
                    if (error)
                        return "visicoolers." + error;
                }
            }
            if (message.numFound != null && message.hasOwnProperty("numFound"))
                if (!$util.isInteger(message.numFound))
                    return "numFound: integer expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            if (message.page != null && message.hasOwnProperty("page"))
                if (!$util.isInteger(message.page))
                    return "page: integer expected";
            return null;
        };

        /**
         * Creates a BuscarVisicoolersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.BuscarVisicoolersResponse} BuscarVisicoolersResponse
         */
        BuscarVisicoolersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.BuscarVisicoolersResponse)
                return object;
            let message = new $root.mirana.BuscarVisicoolersResponse();
            if (object.visicoolers) {
                if (!Array.isArray(object.visicoolers))
                    throw TypeError(".mirana.BuscarVisicoolersResponse.visicoolers: array expected");
                message.visicoolers = [];
                for (let i = 0; i < object.visicoolers.length; ++i) {
                    if (typeof object.visicoolers[i] !== "object")
                        throw TypeError(".mirana.BuscarVisicoolersResponse.visicoolers: object expected");
                    message.visicoolers[i] = $root.mirana.UIVisicooler.fromObject(object.visicoolers[i]);
                }
            }
            if (object.numFound != null)
                message.numFound = object.numFound | 0;
            if (object.pageSize != null)
                message.pageSize = object.pageSize | 0;
            if (object.page != null)
                message.page = object.page | 0;
            return message;
        };

        /**
         * Creates a plain object from a BuscarVisicoolersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.BuscarVisicoolersResponse
         * @static
         * @param {mirana.BuscarVisicoolersResponse} message BuscarVisicoolersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BuscarVisicoolersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.visicoolers = [];
            if (options.defaults) {
                object.numFound = 0;
                object.pageSize = 0;
                object.page = 0;
            }
            if (message.visicoolers && message.visicoolers.length) {
                object.visicoolers = [];
                for (let j = 0; j < message.visicoolers.length; ++j)
                    object.visicoolers[j] = $root.mirana.UIVisicooler.toObject(message.visicoolers[j], options);
            }
            if (message.numFound != null && message.hasOwnProperty("numFound"))
                object.numFound = message.numFound;
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                object.pageSize = message.pageSize;
            if (message.page != null && message.hasOwnProperty("page"))
                object.page = message.page;
            return object;
        };

        /**
         * Converts this BuscarVisicoolersResponse to JSON.
         * @function toJSON
         * @memberof mirana.BuscarVisicoolersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BuscarVisicoolersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BuscarVisicoolersResponse;
    })();

    mirana.VisicoolerModeloResponse = (function() {

        /**
         * Properties of a VisicoolerModeloResponse.
         * @memberof mirana
         * @interface IVisicoolerModeloResponse
         * @property {Array.<mirana.IVisicoolerModelo>|null} [modelos] VisicoolerModeloResponse modelos
         */

        /**
         * Constructs a new VisicoolerModeloResponse.
         * @memberof mirana
         * @classdesc Represents a VisicoolerModeloResponse.
         * @implements IVisicoolerModeloResponse
         * @constructor
         * @param {mirana.IVisicoolerModeloResponse=} [properties] Properties to set
         */
        function VisicoolerModeloResponse(properties) {
            this.modelos = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VisicoolerModeloResponse modelos.
         * @member {Array.<mirana.IVisicoolerModelo>} modelos
         * @memberof mirana.VisicoolerModeloResponse
         * @instance
         */
        VisicoolerModeloResponse.prototype.modelos = $util.emptyArray;

        /**
         * Creates a new VisicoolerModeloResponse instance using the specified properties.
         * @function create
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {mirana.IVisicoolerModeloResponse=} [properties] Properties to set
         * @returns {mirana.VisicoolerModeloResponse} VisicoolerModeloResponse instance
         */
        VisicoolerModeloResponse.create = function create(properties) {
            return new VisicoolerModeloResponse(properties);
        };

        /**
         * Encodes the specified VisicoolerModeloResponse message. Does not implicitly {@link mirana.VisicoolerModeloResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {mirana.IVisicoolerModeloResponse} message VisicoolerModeloResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerModeloResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.modelos != null && message.modelos.length)
                for (let i = 0; i < message.modelos.length; ++i)
                    $root.mirana.VisicoolerModelo.encode(message.modelos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VisicoolerModeloResponse message, length delimited. Does not implicitly {@link mirana.VisicoolerModeloResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {mirana.IVisicoolerModeloResponse} message VisicoolerModeloResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerModeloResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VisicoolerModeloResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.VisicoolerModeloResponse} VisicoolerModeloResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerModeloResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.VisicoolerModeloResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.modelos && message.modelos.length))
                        message.modelos = [];
                    message.modelos.push($root.mirana.VisicoolerModelo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VisicoolerModeloResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.VisicoolerModeloResponse} VisicoolerModeloResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerModeloResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VisicoolerModeloResponse message.
         * @function verify
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VisicoolerModeloResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.modelos != null && message.hasOwnProperty("modelos")) {
                if (!Array.isArray(message.modelos))
                    return "modelos: array expected";
                for (let i = 0; i < message.modelos.length; ++i) {
                    let error = $root.mirana.VisicoolerModelo.verify(message.modelos[i]);
                    if (error)
                        return "modelos." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VisicoolerModeloResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.VisicoolerModeloResponse} VisicoolerModeloResponse
         */
        VisicoolerModeloResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.VisicoolerModeloResponse)
                return object;
            let message = new $root.mirana.VisicoolerModeloResponse();
            if (object.modelos) {
                if (!Array.isArray(object.modelos))
                    throw TypeError(".mirana.VisicoolerModeloResponse.modelos: array expected");
                message.modelos = [];
                for (let i = 0; i < object.modelos.length; ++i) {
                    if (typeof object.modelos[i] !== "object")
                        throw TypeError(".mirana.VisicoolerModeloResponse.modelos: object expected");
                    message.modelos[i] = $root.mirana.VisicoolerModelo.fromObject(object.modelos[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VisicoolerModeloResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.VisicoolerModeloResponse
         * @static
         * @param {mirana.VisicoolerModeloResponse} message VisicoolerModeloResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VisicoolerModeloResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.modelos = [];
            if (message.modelos && message.modelos.length) {
                object.modelos = [];
                for (let j = 0; j < message.modelos.length; ++j)
                    object.modelos[j] = $root.mirana.VisicoolerModelo.toObject(message.modelos[j], options);
            }
            return object;
        };

        /**
         * Converts this VisicoolerModeloResponse to JSON.
         * @function toJSON
         * @memberof mirana.VisicoolerModeloResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VisicoolerModeloResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VisicoolerModeloResponse;
    })();

    mirana.VisicoolerRequest = (function() {

        /**
         * Properties of a VisicoolerRequest.
         * @memberof mirana
         * @interface IVisicoolerRequest
         * @property {string|null} [fuerzaVentaId] VisicoolerRequest fuerzaVentaId
         * @property {string|null} [fechaConsulta] VisicoolerRequest fechaConsulta
         * @property {Array.<mirana.IVisicooler>|null} [visicoolers] VisicoolerRequest visicoolers
         */

        /**
         * Constructs a new VisicoolerRequest.
         * @memberof mirana
         * @classdesc Represents a VisicoolerRequest.
         * @implements IVisicoolerRequest
         * @constructor
         * @param {mirana.IVisicoolerRequest=} [properties] Properties to set
         */
        function VisicoolerRequest(properties) {
            this.visicoolers = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VisicoolerRequest fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.VisicoolerRequest
         * @instance
         */
        VisicoolerRequest.prototype.fuerzaVentaId = "";

        /**
         * VisicoolerRequest fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.VisicoolerRequest
         * @instance
         */
        VisicoolerRequest.prototype.fechaConsulta = "";

        /**
         * VisicoolerRequest visicoolers.
         * @member {Array.<mirana.IVisicooler>} visicoolers
         * @memberof mirana.VisicoolerRequest
         * @instance
         */
        VisicoolerRequest.prototype.visicoolers = $util.emptyArray;

        /**
         * Creates a new VisicoolerRequest instance using the specified properties.
         * @function create
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {mirana.IVisicoolerRequest=} [properties] Properties to set
         * @returns {mirana.VisicoolerRequest} VisicoolerRequest instance
         */
        VisicoolerRequest.create = function create(properties) {
            return new VisicoolerRequest(properties);
        };

        /**
         * Encodes the specified VisicoolerRequest message. Does not implicitly {@link mirana.VisicoolerRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {mirana.IVisicoolerRequest} message VisicoolerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaConsulta);
            if (message.visicoolers != null && message.visicoolers.length)
                for (let i = 0; i < message.visicoolers.length; ++i)
                    $root.mirana.Visicooler.encode(message.visicoolers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified VisicoolerRequest message, length delimited. Does not implicitly {@link mirana.VisicoolerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {mirana.IVisicoolerRequest} message VisicoolerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisicoolerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VisicoolerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.VisicoolerRequest} VisicoolerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.VisicoolerRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 1:
                    message.fechaConsulta = reader.string();
                    break;
                case 2:
                    if (!(message.visicoolers && message.visicoolers.length))
                        message.visicoolers = [];
                    message.visicoolers.push($root.mirana.Visicooler.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VisicoolerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.VisicoolerRequest} VisicoolerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisicoolerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VisicoolerRequest message.
         * @function verify
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VisicoolerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            if (message.visicoolers != null && message.hasOwnProperty("visicoolers")) {
                if (!Array.isArray(message.visicoolers))
                    return "visicoolers: array expected";
                for (let i = 0; i < message.visicoolers.length; ++i) {
                    let error = $root.mirana.Visicooler.verify(message.visicoolers[i]);
                    if (error)
                        return "visicoolers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VisicoolerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.VisicoolerRequest} VisicoolerRequest
         */
        VisicoolerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.VisicoolerRequest)
                return object;
            let message = new $root.mirana.VisicoolerRequest();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            if (object.visicoolers) {
                if (!Array.isArray(object.visicoolers))
                    throw TypeError(".mirana.VisicoolerRequest.visicoolers: array expected");
                message.visicoolers = [];
                for (let i = 0; i < object.visicoolers.length; ++i) {
                    if (typeof object.visicoolers[i] !== "object")
                        throw TypeError(".mirana.VisicoolerRequest.visicoolers: object expected");
                    message.visicoolers[i] = $root.mirana.Visicooler.fromObject(object.visicoolers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VisicoolerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.VisicoolerRequest
         * @static
         * @param {mirana.VisicoolerRequest} message VisicoolerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VisicoolerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.visicoolers = [];
            if (options.defaults) {
                object.fechaConsulta = "";
                object.fuerzaVentaId = "";
            }
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.visicoolers && message.visicoolers.length) {
                object.visicoolers = [];
                for (let j = 0; j < message.visicoolers.length; ++j)
                    object.visicoolers[j] = $root.mirana.Visicooler.toObject(message.visicoolers[j], options);
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this VisicoolerRequest to JSON.
         * @function toJSON
         * @memberof mirana.VisicoolerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VisicoolerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VisicoolerRequest;
    })();

    mirana.VisicoolerService = (function() {

        /**
         * Constructs a new VisicoolerService service.
         * @memberof mirana
         * @classdesc Represents a VisicoolerService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function VisicoolerService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (VisicoolerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = VisicoolerService;

        /**
         * Creates new VisicoolerService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.VisicoolerService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {VisicoolerService} RPC service. Useful where requests and/or responses are streamed.
         */
        VisicoolerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.VisicoolerService#syncVisicooler}.
         * @memberof mirana.VisicoolerService
         * @typedef syncVisicoolerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncVisicooler.
         * @function syncVisicooler
         * @memberof mirana.VisicoolerService
         * @instance
         * @param {mirana.IVisicoolerRequest} request VisicoolerRequest message or plain object
         * @param {mirana.VisicoolerService.syncVisicoolerCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        VisicoolerService.prototype.syncVisicooler = function syncVisicooler(request, callback) {
            return this.rpcCall(syncVisicooler, $root.mirana.VisicoolerRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncVisicooler.
         * @function syncVisicooler
         * @memberof mirana.VisicoolerService
         * @instance
         * @param {mirana.IVisicoolerRequest} request VisicoolerRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return VisicoolerService;
    })();

    mirana.UIStock = (function() {

        /**
         * Properties of a UIStock.
         * @memberof mirana
         * @interface IUIStock
         * @property {string|null} [linea] UIStock linea
         * @property {number|null} [stock] UIStock stock
         * @property {string|null} [marca] UIStock marca
         * @property {number|null} [promedioDiario] UIStock promedioDiario
         * @property {number|null} [diasStock] UIStock diasStock
         * @property {string|null} [categoria] UIStock categoria
         * @property {number|null} [volumen] UIStock volumen
         * @property {number|null} [cobertura] UIStock cobertura
         * @property {string|null} [fechaCarga] UIStock fechaCarga
         */

        /**
         * Constructs a new UIStock.
         * @memberof mirana
         * @classdesc Represents a UIStock.
         * @implements IUIStock
         * @constructor
         * @param {mirana.IUIStock=} [properties] Properties to set
         */
        function UIStock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UIStock linea.
         * @member {string} linea
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.linea = "";

        /**
         * UIStock stock.
         * @member {number} stock
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.stock = 0;

        /**
         * UIStock marca.
         * @member {string} marca
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.marca = "";

        /**
         * UIStock promedioDiario.
         * @member {number} promedioDiario
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.promedioDiario = 0;

        /**
         * UIStock diasStock.
         * @member {number} diasStock
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.diasStock = 0;

        /**
         * UIStock categoria.
         * @member {string} categoria
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.categoria = "";

        /**
         * UIStock volumen.
         * @member {number} volumen
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.volumen = 0;

        /**
         * UIStock cobertura.
         * @member {number} cobertura
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.cobertura = 0;

        /**
         * UIStock fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.UIStock
         * @instance
         */
        UIStock.prototype.fechaCarga = "";

        /**
         * Creates a new UIStock instance using the specified properties.
         * @function create
         * @memberof mirana.UIStock
         * @static
         * @param {mirana.IUIStock=} [properties] Properties to set
         * @returns {mirana.UIStock} UIStock instance
         */
        UIStock.create = function create(properties) {
            return new UIStock(properties);
        };

        /**
         * Encodes the specified UIStock message. Does not implicitly {@link mirana.UIStock.verify|verify} messages.
         * @function encode
         * @memberof mirana.UIStock
         * @static
         * @param {mirana.IUIStock} message UIStock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIStock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.linea);
            if (message.stock != null && message.hasOwnProperty("stock"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.stock);
            if (message.marca != null && message.hasOwnProperty("marca"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.marca);
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.promedioDiario);
            if (message.diasStock != null && message.hasOwnProperty("diasStock"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.diasStock);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.categoria);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.volumen);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.cobertura);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified UIStock message, length delimited. Does not implicitly {@link mirana.UIStock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UIStock
         * @static
         * @param {mirana.IUIStock} message UIStock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIStock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UIStock message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UIStock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UIStock} UIStock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIStock.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UIStock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.linea = reader.string();
                    break;
                case 2:
                    message.stock = reader.double();
                    break;
                case 3:
                    message.marca = reader.string();
                    break;
                case 4:
                    message.promedioDiario = reader.double();
                    break;
                case 5:
                    message.diasStock = reader.double();
                    break;
                case 6:
                    message.categoria = reader.string();
                    break;
                case 7:
                    message.volumen = reader.double();
                    break;
                case 8:
                    message.cobertura = reader.double();
                    break;
                case 9:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UIStock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UIStock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UIStock} UIStock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIStock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UIStock message.
         * @function verify
         * @memberof mirana.UIStock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UIStock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.stock != null && message.hasOwnProperty("stock"))
                if (typeof message.stock !== "number")
                    return "stock: number expected";
            if (message.marca != null && message.hasOwnProperty("marca"))
                if (!$util.isString(message.marca))
                    return "marca: string expected";
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                if (typeof message.promedioDiario !== "number")
                    return "promedioDiario: number expected";
            if (message.diasStock != null && message.hasOwnProperty("diasStock"))
                if (typeof message.diasStock !== "number")
                    return "diasStock: number expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a UIStock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UIStock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UIStock} UIStock
         */
        UIStock.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UIStock)
                return object;
            let message = new $root.mirana.UIStock();
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.stock != null)
                message.stock = Number(object.stock);
            if (object.marca != null)
                message.marca = String(object.marca);
            if (object.promedioDiario != null)
                message.promedioDiario = Number(object.promedioDiario);
            if (object.diasStock != null)
                message.diasStock = Number(object.diasStock);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a UIStock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UIStock
         * @static
         * @param {mirana.UIStock} message UIStock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UIStock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.linea = "";
                object.stock = 0;
                object.marca = "";
                object.promedioDiario = 0;
                object.diasStock = 0;
                object.categoria = "";
                object.volumen = 0;
                object.cobertura = 0;
                object.fechaCarga = "";
            }
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.stock != null && message.hasOwnProperty("stock"))
                object.stock = options.json && !isFinite(message.stock) ? String(message.stock) : message.stock;
            if (message.marca != null && message.hasOwnProperty("marca"))
                object.marca = message.marca;
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                object.promedioDiario = options.json && !isFinite(message.promedioDiario) ? String(message.promedioDiario) : message.promedioDiario;
            if (message.diasStock != null && message.hasOwnProperty("diasStock"))
                object.diasStock = options.json && !isFinite(message.diasStock) ? String(message.diasStock) : message.diasStock;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this UIStock to JSON.
         * @function toJSON
         * @memberof mirana.UIStock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UIStock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UIStock;
    })();

    mirana.FiltrarStockResponse = (function() {

        /**
         * Properties of a FiltrarStockResponse.
         * @memberof mirana
         * @interface IFiltrarStockResponse
         * @property {Array.<mirana.IUIStock>|null} [stocks] FiltrarStockResponse stocks
         */

        /**
         * Constructs a new FiltrarStockResponse.
         * @memberof mirana
         * @classdesc Represents a FiltrarStockResponse.
         * @implements IFiltrarStockResponse
         * @constructor
         * @param {mirana.IFiltrarStockResponse=} [properties] Properties to set
         */
        function FiltrarStockResponse(properties) {
            this.stocks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FiltrarStockResponse stocks.
         * @member {Array.<mirana.IUIStock>} stocks
         * @memberof mirana.FiltrarStockResponse
         * @instance
         */
        FiltrarStockResponse.prototype.stocks = $util.emptyArray;

        /**
         * Creates a new FiltrarStockResponse instance using the specified properties.
         * @function create
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {mirana.IFiltrarStockResponse=} [properties] Properties to set
         * @returns {mirana.FiltrarStockResponse} FiltrarStockResponse instance
         */
        FiltrarStockResponse.create = function create(properties) {
            return new FiltrarStockResponse(properties);
        };

        /**
         * Encodes the specified FiltrarStockResponse message. Does not implicitly {@link mirana.FiltrarStockResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {mirana.IFiltrarStockResponse} message FiltrarStockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarStockResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.stocks != null && message.stocks.length)
                for (let i = 0; i < message.stocks.length; ++i)
                    $root.mirana.UIStock.encode(message.stocks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FiltrarStockResponse message, length delimited. Does not implicitly {@link mirana.FiltrarStockResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {mirana.IFiltrarStockResponse} message FiltrarStockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarStockResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FiltrarStockResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FiltrarStockResponse} FiltrarStockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarStockResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FiltrarStockResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.stocks && message.stocks.length))
                        message.stocks = [];
                    message.stocks.push($root.mirana.UIStock.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FiltrarStockResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FiltrarStockResponse} FiltrarStockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarStockResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FiltrarStockResponse message.
         * @function verify
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FiltrarStockResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.stocks != null && message.hasOwnProperty("stocks")) {
                if (!Array.isArray(message.stocks))
                    return "stocks: array expected";
                for (let i = 0; i < message.stocks.length; ++i) {
                    let error = $root.mirana.UIStock.verify(message.stocks[i]);
                    if (error)
                        return "stocks." + error;
                }
            }
            return null;
        };

        /**
         * Creates a FiltrarStockResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FiltrarStockResponse} FiltrarStockResponse
         */
        FiltrarStockResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FiltrarStockResponse)
                return object;
            let message = new $root.mirana.FiltrarStockResponse();
            if (object.stocks) {
                if (!Array.isArray(object.stocks))
                    throw TypeError(".mirana.FiltrarStockResponse.stocks: array expected");
                message.stocks = [];
                for (let i = 0; i < object.stocks.length; ++i) {
                    if (typeof object.stocks[i] !== "object")
                        throw TypeError(".mirana.FiltrarStockResponse.stocks: object expected");
                    message.stocks[i] = $root.mirana.UIStock.fromObject(object.stocks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FiltrarStockResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FiltrarStockResponse
         * @static
         * @param {mirana.FiltrarStockResponse} message FiltrarStockResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FiltrarStockResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.stocks = [];
            if (message.stocks && message.stocks.length) {
                object.stocks = [];
                for (let j = 0; j < message.stocks.length; ++j)
                    object.stocks[j] = $root.mirana.UIStock.toObject(message.stocks[j], options);
            }
            return object;
        };

        /**
         * Converts this FiltrarStockResponse to JSON.
         * @function toJSON
         * @memberof mirana.FiltrarStockResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FiltrarStockResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FiltrarStockResponse;
    })();

    mirana.Stock = (function() {

        /**
         * Properties of a Stock.
         * @memberof mirana
         * @interface IStock
         * @property {string|null} [linea] Stock linea
         * @property {string|null} [categoria] Stock categoria
         * @property {number|null} [stock] Stock stock
         * @property {string|null} [marca] Stock marca
         * @property {string|null} [fechaCarga] Stock fechaCarga
         */

        /**
         * Constructs a new Stock.
         * @memberof mirana
         * @classdesc Represents a Stock.
         * @implements IStock
         * @constructor
         * @param {mirana.IStock=} [properties] Properties to set
         */
        function Stock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Stock linea.
         * @member {string} linea
         * @memberof mirana.Stock
         * @instance
         */
        Stock.prototype.linea = "";

        /**
         * Stock categoria.
         * @member {string} categoria
         * @memberof mirana.Stock
         * @instance
         */
        Stock.prototype.categoria = "";

        /**
         * Stock stock.
         * @member {number} stock
         * @memberof mirana.Stock
         * @instance
         */
        Stock.prototype.stock = 0;

        /**
         * Stock marca.
         * @member {string} marca
         * @memberof mirana.Stock
         * @instance
         */
        Stock.prototype.marca = "";

        /**
         * Stock fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.Stock
         * @instance
         */
        Stock.prototype.fechaCarga = "";

        /**
         * Creates a new Stock instance using the specified properties.
         * @function create
         * @memberof mirana.Stock
         * @static
         * @param {mirana.IStock=} [properties] Properties to set
         * @returns {mirana.Stock} Stock instance
         */
        Stock.create = function create(properties) {
            return new Stock(properties);
        };

        /**
         * Encodes the specified Stock message. Does not implicitly {@link mirana.Stock.verify|verify} messages.
         * @function encode
         * @memberof mirana.Stock
         * @static
         * @param {mirana.IStock} message Stock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Stock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.linea);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoria);
            if (message.stock != null && message.hasOwnProperty("stock"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.stock);
            if (message.marca != null && message.hasOwnProperty("marca"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.marca);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified Stock message, length delimited. Does not implicitly {@link mirana.Stock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Stock
         * @static
         * @param {mirana.IStock} message Stock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Stock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Stock message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Stock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Stock} Stock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Stock.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Stock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.linea = reader.string();
                    break;
                case 2:
                    message.categoria = reader.string();
                    break;
                case 3:
                    message.stock = reader.double();
                    break;
                case 4:
                    message.marca = reader.string();
                    break;
                case 5:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Stock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Stock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Stock} Stock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Stock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Stock message.
         * @function verify
         * @memberof mirana.Stock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Stock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.stock != null && message.hasOwnProperty("stock"))
                if (typeof message.stock !== "number")
                    return "stock: number expected";
            if (message.marca != null && message.hasOwnProperty("marca"))
                if (!$util.isString(message.marca))
                    return "marca: string expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a Stock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Stock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Stock} Stock
         */
        Stock.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Stock)
                return object;
            let message = new $root.mirana.Stock();
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.stock != null)
                message.stock = Number(object.stock);
            if (object.marca != null)
                message.marca = String(object.marca);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a Stock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Stock
         * @static
         * @param {mirana.Stock} message Stock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Stock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.linea = "";
                object.categoria = "";
                object.stock = 0;
                object.marca = "";
                object.fechaCarga = "";
            }
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.stock != null && message.hasOwnProperty("stock"))
                object.stock = options.json && !isFinite(message.stock) ? String(message.stock) : message.stock;
            if (message.marca != null && message.hasOwnProperty("marca"))
                object.marca = message.marca;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this Stock to JSON.
         * @function toJSON
         * @memberof mirana.Stock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Stock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Stock;
    })();

    mirana.StockRequest = (function() {

        /**
         * Properties of a StockRequest.
         * @memberof mirana
         * @interface IStockRequest
         * @property {string|null} [fechaCarga] StockRequest fechaCarga
         * @property {Array.<mirana.IStock>|null} [stock] StockRequest stock
         */

        /**
         * Constructs a new StockRequest.
         * @memberof mirana
         * @classdesc Represents a StockRequest.
         * @implements IStockRequest
         * @constructor
         * @param {mirana.IStockRequest=} [properties] Properties to set
         */
        function StockRequest(properties) {
            this.stock = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StockRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.StockRequest
         * @instance
         */
        StockRequest.prototype.fechaCarga = "";

        /**
         * StockRequest stock.
         * @member {Array.<mirana.IStock>} stock
         * @memberof mirana.StockRequest
         * @instance
         */
        StockRequest.prototype.stock = $util.emptyArray;

        /**
         * Creates a new StockRequest instance using the specified properties.
         * @function create
         * @memberof mirana.StockRequest
         * @static
         * @param {mirana.IStockRequest=} [properties] Properties to set
         * @returns {mirana.StockRequest} StockRequest instance
         */
        StockRequest.create = function create(properties) {
            return new StockRequest(properties);
        };

        /**
         * Encodes the specified StockRequest message. Does not implicitly {@link mirana.StockRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.StockRequest
         * @static
         * @param {mirana.IStockRequest} message StockRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.stock != null && message.stock.length)
                for (let i = 0; i < message.stock.length; ++i)
                    $root.mirana.Stock.encode(message.stock[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StockRequest message, length delimited. Does not implicitly {@link mirana.StockRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.StockRequest
         * @static
         * @param {mirana.IStockRequest} message StockRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StockRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.StockRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.StockRequest} StockRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.StockRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 3:
                    if (!(message.stock && message.stock.length))
                        message.stock = [];
                    message.stock.push($root.mirana.Stock.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StockRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.StockRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.StockRequest} StockRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StockRequest message.
         * @function verify
         * @memberof mirana.StockRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StockRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.stock != null && message.hasOwnProperty("stock")) {
                if (!Array.isArray(message.stock))
                    return "stock: array expected";
                for (let i = 0; i < message.stock.length; ++i) {
                    let error = $root.mirana.Stock.verify(message.stock[i]);
                    if (error)
                        return "stock." + error;
                }
            }
            return null;
        };

        /**
         * Creates a StockRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.StockRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.StockRequest} StockRequest
         */
        StockRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.StockRequest)
                return object;
            let message = new $root.mirana.StockRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.stock) {
                if (!Array.isArray(object.stock))
                    throw TypeError(".mirana.StockRequest.stock: array expected");
                message.stock = [];
                for (let i = 0; i < object.stock.length; ++i) {
                    if (typeof object.stock[i] !== "object")
                        throw TypeError(".mirana.StockRequest.stock: object expected");
                    message.stock[i] = $root.mirana.Stock.fromObject(object.stock[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a StockRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.StockRequest
         * @static
         * @param {mirana.StockRequest} message StockRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StockRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.stock = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.stock && message.stock.length) {
                object.stock = [];
                for (let j = 0; j < message.stock.length; ++j)
                    object.stock[j] = $root.mirana.Stock.toObject(message.stock[j], options);
            }
            return object;
        };

        /**
         * Converts this StockRequest to JSON.
         * @function toJSON
         * @memberof mirana.StockRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StockRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StockRequest;
    })();

    mirana.CoberturaAvance = (function() {

        /**
         * Properties of a CoberturaAvance.
         * @memberof mirana
         * @interface ICoberturaAvance
         * @property {string|null} [periodo] CoberturaAvance periodo
         * @property {string|null} [linea] CoberturaAvance linea
         * @property {number|null} [volumen] CoberturaAvance volumen
         * @property {number|null} [cobertura] CoberturaAvance cobertura
         * @property {string|null} [fechaCarga] CoberturaAvance fechaCarga
         */

        /**
         * Constructs a new CoberturaAvance.
         * @memberof mirana
         * @classdesc Represents a CoberturaAvance.
         * @implements ICoberturaAvance
         * @constructor
         * @param {mirana.ICoberturaAvance=} [properties] Properties to set
         */
        function CoberturaAvance(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturaAvance periodo.
         * @member {string} periodo
         * @memberof mirana.CoberturaAvance
         * @instance
         */
        CoberturaAvance.prototype.periodo = "";

        /**
         * CoberturaAvance linea.
         * @member {string} linea
         * @memberof mirana.CoberturaAvance
         * @instance
         */
        CoberturaAvance.prototype.linea = "";

        /**
         * CoberturaAvance volumen.
         * @member {number} volumen
         * @memberof mirana.CoberturaAvance
         * @instance
         */
        CoberturaAvance.prototype.volumen = 0;

        /**
         * CoberturaAvance cobertura.
         * @member {number} cobertura
         * @memberof mirana.CoberturaAvance
         * @instance
         */
        CoberturaAvance.prototype.cobertura = 0;

        /**
         * CoberturaAvance fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.CoberturaAvance
         * @instance
         */
        CoberturaAvance.prototype.fechaCarga = "";

        /**
         * Creates a new CoberturaAvance instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {mirana.ICoberturaAvance=} [properties] Properties to set
         * @returns {mirana.CoberturaAvance} CoberturaAvance instance
         */
        CoberturaAvance.create = function create(properties) {
            return new CoberturaAvance(properties);
        };

        /**
         * Encodes the specified CoberturaAvance message. Does not implicitly {@link mirana.CoberturaAvance.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {mirana.ICoberturaAvance} message CoberturaAvance message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAvance.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.periodo);
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.linea);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.volumen);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.cobertura);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified CoberturaAvance message, length delimited. Does not implicitly {@link mirana.CoberturaAvance.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {mirana.ICoberturaAvance} message CoberturaAvance message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAvance.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturaAvance message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturaAvance} CoberturaAvance
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAvance.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturaAvance();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.periodo = reader.string();
                    break;
                case 2:
                    message.linea = reader.string();
                    break;
                case 3:
                    message.volumen = reader.double();
                    break;
                case 4:
                    message.cobertura = reader.double();
                    break;
                case 5:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturaAvance message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturaAvance} CoberturaAvance
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAvance.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturaAvance message.
         * @function verify
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturaAvance.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                if (!$util.isString(message.periodo))
                    return "periodo: string expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a CoberturaAvance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturaAvance} CoberturaAvance
         */
        CoberturaAvance.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturaAvance)
                return object;
            let message = new $root.mirana.CoberturaAvance();
            if (object.periodo != null)
                message.periodo = String(object.periodo);
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a CoberturaAvance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturaAvance
         * @static
         * @param {mirana.CoberturaAvance} message CoberturaAvance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturaAvance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.periodo = "";
                object.linea = "";
                object.volumen = 0;
                object.cobertura = 0;
                object.fechaCarga = "";
            }
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                object.periodo = message.periodo;
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this CoberturaAvance to JSON.
         * @function toJSON
         * @memberof mirana.CoberturaAvance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturaAvance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturaAvance;
    })();

    mirana.CoberturaAvanceRequest = (function() {

        /**
         * Properties of a CoberturaAvanceRequest.
         * @memberof mirana
         * @interface ICoberturaAvanceRequest
         * @property {string|null} [fechaCarga] CoberturaAvanceRequest fechaCarga
         * @property {Array.<mirana.ICoberturaAvance>|null} [coberturaAvance] CoberturaAvanceRequest coberturaAvance
         */

        /**
         * Constructs a new CoberturaAvanceRequest.
         * @memberof mirana
         * @classdesc Represents a CoberturaAvanceRequest.
         * @implements ICoberturaAvanceRequest
         * @constructor
         * @param {mirana.ICoberturaAvanceRequest=} [properties] Properties to set
         */
        function CoberturaAvanceRequest(properties) {
            this.coberturaAvance = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturaAvanceRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.CoberturaAvanceRequest
         * @instance
         */
        CoberturaAvanceRequest.prototype.fechaCarga = "";

        /**
         * CoberturaAvanceRequest coberturaAvance.
         * @member {Array.<mirana.ICoberturaAvance>} coberturaAvance
         * @memberof mirana.CoberturaAvanceRequest
         * @instance
         */
        CoberturaAvanceRequest.prototype.coberturaAvance = $util.emptyArray;

        /**
         * Creates a new CoberturaAvanceRequest instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {mirana.ICoberturaAvanceRequest=} [properties] Properties to set
         * @returns {mirana.CoberturaAvanceRequest} CoberturaAvanceRequest instance
         */
        CoberturaAvanceRequest.create = function create(properties) {
            return new CoberturaAvanceRequest(properties);
        };

        /**
         * Encodes the specified CoberturaAvanceRequest message. Does not implicitly {@link mirana.CoberturaAvanceRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {mirana.ICoberturaAvanceRequest} message CoberturaAvanceRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAvanceRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.coberturaAvance != null && message.coberturaAvance.length)
                for (let i = 0; i < message.coberturaAvance.length; ++i)
                    $root.mirana.CoberturaAvance.encode(message.coberturaAvance[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CoberturaAvanceRequest message, length delimited. Does not implicitly {@link mirana.CoberturaAvanceRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {mirana.ICoberturaAvanceRequest} message CoberturaAvanceRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAvanceRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturaAvanceRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturaAvanceRequest} CoberturaAvanceRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAvanceRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturaAvanceRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.coberturaAvance && message.coberturaAvance.length))
                        message.coberturaAvance = [];
                    message.coberturaAvance.push($root.mirana.CoberturaAvance.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturaAvanceRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturaAvanceRequest} CoberturaAvanceRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAvanceRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturaAvanceRequest message.
         * @function verify
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturaAvanceRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.coberturaAvance != null && message.hasOwnProperty("coberturaAvance")) {
                if (!Array.isArray(message.coberturaAvance))
                    return "coberturaAvance: array expected";
                for (let i = 0; i < message.coberturaAvance.length; ++i) {
                    let error = $root.mirana.CoberturaAvance.verify(message.coberturaAvance[i]);
                    if (error)
                        return "coberturaAvance." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CoberturaAvanceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturaAvanceRequest} CoberturaAvanceRequest
         */
        CoberturaAvanceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturaAvanceRequest)
                return object;
            let message = new $root.mirana.CoberturaAvanceRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.coberturaAvance) {
                if (!Array.isArray(object.coberturaAvance))
                    throw TypeError(".mirana.CoberturaAvanceRequest.coberturaAvance: array expected");
                message.coberturaAvance = [];
                for (let i = 0; i < object.coberturaAvance.length; ++i) {
                    if (typeof object.coberturaAvance[i] !== "object")
                        throw TypeError(".mirana.CoberturaAvanceRequest.coberturaAvance: object expected");
                    message.coberturaAvance[i] = $root.mirana.CoberturaAvance.fromObject(object.coberturaAvance[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CoberturaAvanceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturaAvanceRequest
         * @static
         * @param {mirana.CoberturaAvanceRequest} message CoberturaAvanceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturaAvanceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturaAvance = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.coberturaAvance && message.coberturaAvance.length) {
                object.coberturaAvance = [];
                for (let j = 0; j < message.coberturaAvance.length; ++j)
                    object.coberturaAvance[j] = $root.mirana.CoberturaAvance.toObject(message.coberturaAvance[j], options);
            }
            return object;
        };

        /**
         * Converts this CoberturaAvanceRequest to JSON.
         * @function toJSON
         * @memberof mirana.CoberturaAvanceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturaAvanceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturaAvanceRequest;
    })();

    mirana.CalcularStockRestanteRequest = (function() {

        /**
         * Properties of a CalcularStockRestanteRequest.
         * @memberof mirana
         * @interface ICalcularStockRestanteRequest
         * @property {string|null} [fechaCarga] CalcularStockRestanteRequest fechaCarga
         */

        /**
         * Constructs a new CalcularStockRestanteRequest.
         * @memberof mirana
         * @classdesc Represents a CalcularStockRestanteRequest.
         * @implements ICalcularStockRestanteRequest
         * @constructor
         * @param {mirana.ICalcularStockRestanteRequest=} [properties] Properties to set
         */
        function CalcularStockRestanteRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CalcularStockRestanteRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.CalcularStockRestanteRequest
         * @instance
         */
        CalcularStockRestanteRequest.prototype.fechaCarga = "";

        /**
         * Creates a new CalcularStockRestanteRequest instance using the specified properties.
         * @function create
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {mirana.ICalcularStockRestanteRequest=} [properties] Properties to set
         * @returns {mirana.CalcularStockRestanteRequest} CalcularStockRestanteRequest instance
         */
        CalcularStockRestanteRequest.create = function create(properties) {
            return new CalcularStockRestanteRequest(properties);
        };

        /**
         * Encodes the specified CalcularStockRestanteRequest message. Does not implicitly {@link mirana.CalcularStockRestanteRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {mirana.ICalcularStockRestanteRequest} message CalcularStockRestanteRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CalcularStockRestanteRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified CalcularStockRestanteRequest message, length delimited. Does not implicitly {@link mirana.CalcularStockRestanteRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {mirana.ICalcularStockRestanteRequest} message CalcularStockRestanteRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CalcularStockRestanteRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CalcularStockRestanteRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CalcularStockRestanteRequest} CalcularStockRestanteRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CalcularStockRestanteRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CalcularStockRestanteRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CalcularStockRestanteRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CalcularStockRestanteRequest} CalcularStockRestanteRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CalcularStockRestanteRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CalcularStockRestanteRequest message.
         * @function verify
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CalcularStockRestanteRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a CalcularStockRestanteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CalcularStockRestanteRequest} CalcularStockRestanteRequest
         */
        CalcularStockRestanteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CalcularStockRestanteRequest)
                return object;
            let message = new $root.mirana.CalcularStockRestanteRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a CalcularStockRestanteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CalcularStockRestanteRequest
         * @static
         * @param {mirana.CalcularStockRestanteRequest} message CalcularStockRestanteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CalcularStockRestanteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this CalcularStockRestanteRequest to JSON.
         * @function toJSON
         * @memberof mirana.CalcularStockRestanteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CalcularStockRestanteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CalcularStockRestanteRequest;
    })();

    mirana.StockService = (function() {

        /**
         * Constructs a new StockService service.
         * @memberof mirana
         * @classdesc Represents a StockService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function StockService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (StockService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StockService;

        /**
         * Creates new StockService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.StockService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {StockService} RPC service. Useful where requests and/or responses are streamed.
         */
        StockService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.StockService#syncStock}.
         * @memberof mirana.StockService
         * @typedef syncStockCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncStock.
         * @function syncStock
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockRequest} request StockRequest message or plain object
         * @param {mirana.StockService.syncStockCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.syncStock = function syncStock(request, callback) {
            return this.rpcCall(syncStock, $root.mirana.StockRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncStock.
         * @function syncStock
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockRequest} request StockRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#syncCoberturaAvance}.
         * @memberof mirana.StockService
         * @typedef syncCoberturaAvanceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncCoberturaAvance.
         * @function syncCoberturaAvance
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICoberturaAvanceRequest} request CoberturaAvanceRequest message or plain object
         * @param {mirana.StockService.syncCoberturaAvanceCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.syncCoberturaAvance = function syncCoberturaAvance(request, callback) {
            return this.rpcCall(syncCoberturaAvance, $root.mirana.CoberturaAvanceRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncCoberturaAvance.
         * @function syncCoberturaAvance
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICoberturaAvanceRequest} request CoberturaAvanceRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#syncStockProducto}.
         * @memberof mirana.StockService
         * @typedef syncStockProductoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncStockProducto.
         * @function syncStockProducto
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockProductoRequest} request StockProductoRequest message or plain object
         * @param {mirana.StockService.syncStockProductoCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.syncStockProducto = function syncStockProducto(request, callback) {
            return this.rpcCall(syncStockProducto, $root.mirana.StockProductoRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncStockProducto.
         * @function syncStockProducto
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockProductoRequest} request StockProductoRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#syncAvanceProducto}.
         * @memberof mirana.StockService
         * @typedef syncAvanceProductoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncAvanceProducto.
         * @function syncAvanceProducto
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IAvanceProductoRequest} request AvanceProductoRequest message or plain object
         * @param {mirana.StockService.syncAvanceProductoCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.syncAvanceProducto = function syncAvanceProducto(request, callback) {
            return this.rpcCall(syncAvanceProducto, $root.mirana.AvanceProductoRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncAvanceProducto.
         * @function syncAvanceProducto
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IAvanceProductoRequest} request AvanceProductoRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#calcularStockRestante}.
         * @memberof mirana.StockService
         * @typedef calcularStockRestanteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls calcularStockRestante.
         * @function calcularStockRestante
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICalcularStockRestanteRequest} request CalcularStockRestanteRequest message or plain object
         * @param {mirana.StockService.calcularStockRestanteCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.calcularStockRestante = function calcularStockRestante(request, callback) {
            return this.rpcCall(calcularStockRestante, $root.mirana.CalcularStockRestanteRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls calcularStockRestante.
         * @function calcularStockRestante
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICalcularStockRestanteRequest} request CalcularStockRestanteRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#calcularStockProductoRestante}.
         * @memberof mirana.StockService
         * @typedef calcularStockProductoRestanteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls calcularStockProductoRestante.
         * @function calcularStockProductoRestante
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICalcularStockRestanteRequest} request CalcularStockRestanteRequest message or plain object
         * @param {mirana.StockService.calcularStockProductoRestanteCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.calcularStockProductoRestante = function calcularStockProductoRestante(request, callback) {
            return this.rpcCall(calcularStockProductoRestante, $root.mirana.CalcularStockRestanteRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls calcularStockProductoRestante.
         * @function calcularStockProductoRestante
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.ICalcularStockRestanteRequest} request CalcularStockRestanteRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.StockService#limpiarStockProductoPorFecha}.
         * @memberof mirana.StockService
         * @typedef limpiarStockProductoPorFechaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls limpiarStockProductoPorFecha.
         * @function limpiarStockProductoPorFecha
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockProductoRequest} request StockProductoRequest message or plain object
         * @param {mirana.StockService.limpiarStockProductoPorFechaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        StockService.prototype.limpiarStockProductoPorFecha = function limpiarStockProductoPorFecha(request, callback) {
            return this.rpcCall(limpiarStockProductoPorFecha, $root.mirana.StockProductoRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls limpiarStockProductoPorFecha.
         * @function limpiarStockProductoPorFecha
         * @memberof mirana.StockService
         * @instance
         * @param {mirana.IStockProductoRequest} request StockProductoRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return StockService;
    })();

    mirana.StockProducto = (function() {

        /**
         * Properties of a StockProducto.
         * @memberof mirana
         * @interface IStockProducto
         * @property {string|null} [fuerzaVentaId] StockProducto fuerzaVentaId
         * @property {string|null} [codigoProducto] StockProducto codigoProducto
         * @property {string|null} [descripcionProducto] StockProducto descripcionProducto
         * @property {string|null} [codigoCategoria] StockProducto codigoCategoria
         * @property {string|null} [descripcionCategoria] StockProducto descripcionCategoria
         * @property {string|null} [linea] StockProducto linea
         * @property {number|null} [stock] StockProducto stock
         * @property {string|null} [fechaCarga] StockProducto fechaCarga
         */

        /**
         * Constructs a new StockProducto.
         * @memberof mirana
         * @classdesc Represents a StockProducto.
         * @implements IStockProducto
         * @constructor
         * @param {mirana.IStockProducto=} [properties] Properties to set
         */
        function StockProducto(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StockProducto fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.fuerzaVentaId = "";

        /**
         * StockProducto codigoProducto.
         * @member {string} codigoProducto
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.codigoProducto = "";

        /**
         * StockProducto descripcionProducto.
         * @member {string} descripcionProducto
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.descripcionProducto = "";

        /**
         * StockProducto codigoCategoria.
         * @member {string} codigoCategoria
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.codigoCategoria = "";

        /**
         * StockProducto descripcionCategoria.
         * @member {string} descripcionCategoria
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.descripcionCategoria = "";

        /**
         * StockProducto linea.
         * @member {string} linea
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.linea = "";

        /**
         * StockProducto stock.
         * @member {number} stock
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.stock = 0;

        /**
         * StockProducto fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.StockProducto
         * @instance
         */
        StockProducto.prototype.fechaCarga = "";

        /**
         * Creates a new StockProducto instance using the specified properties.
         * @function create
         * @memberof mirana.StockProducto
         * @static
         * @param {mirana.IStockProducto=} [properties] Properties to set
         * @returns {mirana.StockProducto} StockProducto instance
         */
        StockProducto.create = function create(properties) {
            return new StockProducto(properties);
        };

        /**
         * Encodes the specified StockProducto message. Does not implicitly {@link mirana.StockProducto.verify|verify} messages.
         * @function encode
         * @memberof mirana.StockProducto
         * @static
         * @param {mirana.IStockProducto} message StockProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockProducto.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fuerzaVentaId);
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.codigoProducto);
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.descripcionProducto);
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.codigoCategoria);
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.descripcionCategoria);
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.linea);
            if (message.stock != null && message.hasOwnProperty("stock"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.stock);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified StockProducto message, length delimited. Does not implicitly {@link mirana.StockProducto.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.StockProducto
         * @static
         * @param {mirana.IStockProducto} message StockProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockProducto.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StockProducto message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.StockProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.StockProducto} StockProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockProducto.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.StockProducto();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 2:
                    message.codigoProducto = reader.string();
                    break;
                case 3:
                    message.descripcionProducto = reader.string();
                    break;
                case 4:
                    message.codigoCategoria = reader.string();
                    break;
                case 5:
                    message.descripcionCategoria = reader.string();
                    break;
                case 6:
                    message.linea = reader.string();
                    break;
                case 7:
                    message.stock = reader.double();
                    break;
                case 8:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StockProducto message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.StockProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.StockProducto} StockProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockProducto.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StockProducto message.
         * @function verify
         * @memberof mirana.StockProducto
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StockProducto.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                if (!$util.isString(message.codigoProducto))
                    return "codigoProducto: string expected";
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                if (!$util.isString(message.descripcionProducto))
                    return "descripcionProducto: string expected";
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                if (!$util.isString(message.codigoCategoria))
                    return "codigoCategoria: string expected";
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                if (!$util.isString(message.descripcionCategoria))
                    return "descripcionCategoria: string expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.stock != null && message.hasOwnProperty("stock"))
                if (typeof message.stock !== "number")
                    return "stock: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a StockProducto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.StockProducto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.StockProducto} StockProducto
         */
        StockProducto.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.StockProducto)
                return object;
            let message = new $root.mirana.StockProducto();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.codigoProducto != null)
                message.codigoProducto = String(object.codigoProducto);
            if (object.descripcionProducto != null)
                message.descripcionProducto = String(object.descripcionProducto);
            if (object.codigoCategoria != null)
                message.codigoCategoria = String(object.codigoCategoria);
            if (object.descripcionCategoria != null)
                message.descripcionCategoria = String(object.descripcionCategoria);
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.stock != null)
                message.stock = Number(object.stock);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a StockProducto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.StockProducto
         * @static
         * @param {mirana.StockProducto} message StockProducto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StockProducto.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fuerzaVentaId = "";
                object.codigoProducto = "";
                object.descripcionProducto = "";
                object.codigoCategoria = "";
                object.descripcionCategoria = "";
                object.linea = "";
                object.stock = 0;
                object.fechaCarga = "";
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                object.codigoProducto = message.codigoProducto;
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                object.descripcionProducto = message.descripcionProducto;
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                object.codigoCategoria = message.codigoCategoria;
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                object.descripcionCategoria = message.descripcionCategoria;
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.stock != null && message.hasOwnProperty("stock"))
                object.stock = options.json && !isFinite(message.stock) ? String(message.stock) : message.stock;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this StockProducto to JSON.
         * @function toJSON
         * @memberof mirana.StockProducto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StockProducto.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StockProducto;
    })();

    mirana.AvanceProducto = (function() {

        /**
         * Properties of an AvanceProducto.
         * @memberof mirana
         * @interface IAvanceProducto
         * @property {string|null} [periodo] AvanceProducto periodo
         * @property {string|null} [codigoProducto] AvanceProducto codigoProducto
         * @property {string|null} [codigoCategoria] AvanceProducto codigoCategoria
         * @property {number|null} [volumen] AvanceProducto volumen
         * @property {string|null} [fechaCarga] AvanceProducto fechaCarga
         */

        /**
         * Constructs a new AvanceProducto.
         * @memberof mirana
         * @classdesc Represents an AvanceProducto.
         * @implements IAvanceProducto
         * @constructor
         * @param {mirana.IAvanceProducto=} [properties] Properties to set
         */
        function AvanceProducto(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvanceProducto periodo.
         * @member {string} periodo
         * @memberof mirana.AvanceProducto
         * @instance
         */
        AvanceProducto.prototype.periodo = "";

        /**
         * AvanceProducto codigoProducto.
         * @member {string} codigoProducto
         * @memberof mirana.AvanceProducto
         * @instance
         */
        AvanceProducto.prototype.codigoProducto = "";

        /**
         * AvanceProducto codigoCategoria.
         * @member {string} codigoCategoria
         * @memberof mirana.AvanceProducto
         * @instance
         */
        AvanceProducto.prototype.codigoCategoria = "";

        /**
         * AvanceProducto volumen.
         * @member {number} volumen
         * @memberof mirana.AvanceProducto
         * @instance
         */
        AvanceProducto.prototype.volumen = 0;

        /**
         * AvanceProducto fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.AvanceProducto
         * @instance
         */
        AvanceProducto.prototype.fechaCarga = "";

        /**
         * Creates a new AvanceProducto instance using the specified properties.
         * @function create
         * @memberof mirana.AvanceProducto
         * @static
         * @param {mirana.IAvanceProducto=} [properties] Properties to set
         * @returns {mirana.AvanceProducto} AvanceProducto instance
         */
        AvanceProducto.create = function create(properties) {
            return new AvanceProducto(properties);
        };

        /**
         * Encodes the specified AvanceProducto message. Does not implicitly {@link mirana.AvanceProducto.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvanceProducto
         * @static
         * @param {mirana.IAvanceProducto} message AvanceProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceProducto.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.periodo);
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.codigoProducto);
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.codigoCategoria);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.volumen);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified AvanceProducto message, length delimited. Does not implicitly {@link mirana.AvanceProducto.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvanceProducto
         * @static
         * @param {mirana.IAvanceProducto} message AvanceProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceProducto.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvanceProducto message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvanceProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvanceProducto} AvanceProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceProducto.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvanceProducto();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.periodo = reader.string();
                    break;
                case 2:
                    message.codigoProducto = reader.string();
                    break;
                case 3:
                    message.codigoCategoria = reader.string();
                    break;
                case 4:
                    message.volumen = reader.double();
                    break;
                case 5:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvanceProducto message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvanceProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvanceProducto} AvanceProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceProducto.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvanceProducto message.
         * @function verify
         * @memberof mirana.AvanceProducto
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvanceProducto.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                if (!$util.isString(message.periodo))
                    return "periodo: string expected";
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                if (!$util.isString(message.codigoProducto))
                    return "codigoProducto: string expected";
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                if (!$util.isString(message.codigoCategoria))
                    return "codigoCategoria: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates an AvanceProducto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvanceProducto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvanceProducto} AvanceProducto
         */
        AvanceProducto.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvanceProducto)
                return object;
            let message = new $root.mirana.AvanceProducto();
            if (object.periodo != null)
                message.periodo = String(object.periodo);
            if (object.codigoProducto != null)
                message.codigoProducto = String(object.codigoProducto);
            if (object.codigoCategoria != null)
                message.codigoCategoria = String(object.codigoCategoria);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from an AvanceProducto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvanceProducto
         * @static
         * @param {mirana.AvanceProducto} message AvanceProducto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvanceProducto.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.periodo = "";
                object.codigoProducto = "";
                object.codigoCategoria = "";
                object.volumen = 0;
                object.fechaCarga = "";
            }
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                object.periodo = message.periodo;
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                object.codigoProducto = message.codigoProducto;
            if (message.codigoCategoria != null && message.hasOwnProperty("codigoCategoria"))
                object.codigoCategoria = message.codigoCategoria;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this AvanceProducto to JSON.
         * @function toJSON
         * @memberof mirana.AvanceProducto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvanceProducto.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvanceProducto;
    })();

    mirana.StockProductoRequest = (function() {

        /**
         * Properties of a StockProductoRequest.
         * @memberof mirana
         * @interface IStockProductoRequest
         * @property {string|null} [fechaCarga] StockProductoRequest fechaCarga
         * @property {Array.<mirana.IStockProducto>|null} [stocks] StockProductoRequest stocks
         */

        /**
         * Constructs a new StockProductoRequest.
         * @memberof mirana
         * @classdesc Represents a StockProductoRequest.
         * @implements IStockProductoRequest
         * @constructor
         * @param {mirana.IStockProductoRequest=} [properties] Properties to set
         */
        function StockProductoRequest(properties) {
            this.stocks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StockProductoRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.StockProductoRequest
         * @instance
         */
        StockProductoRequest.prototype.fechaCarga = "";

        /**
         * StockProductoRequest stocks.
         * @member {Array.<mirana.IStockProducto>} stocks
         * @memberof mirana.StockProductoRequest
         * @instance
         */
        StockProductoRequest.prototype.stocks = $util.emptyArray;

        /**
         * Creates a new StockProductoRequest instance using the specified properties.
         * @function create
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {mirana.IStockProductoRequest=} [properties] Properties to set
         * @returns {mirana.StockProductoRequest} StockProductoRequest instance
         */
        StockProductoRequest.create = function create(properties) {
            return new StockProductoRequest(properties);
        };

        /**
         * Encodes the specified StockProductoRequest message. Does not implicitly {@link mirana.StockProductoRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {mirana.IStockProductoRequest} message StockProductoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockProductoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.stocks != null && message.stocks.length)
                for (let i = 0; i < message.stocks.length; ++i)
                    $root.mirana.StockProducto.encode(message.stocks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StockProductoRequest message, length delimited. Does not implicitly {@link mirana.StockProductoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {mirana.IStockProductoRequest} message StockProductoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StockProductoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StockProductoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.StockProductoRequest} StockProductoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockProductoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.StockProductoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.stocks && message.stocks.length))
                        message.stocks = [];
                    message.stocks.push($root.mirana.StockProducto.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StockProductoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.StockProductoRequest} StockProductoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StockProductoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StockProductoRequest message.
         * @function verify
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StockProductoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.stocks != null && message.hasOwnProperty("stocks")) {
                if (!Array.isArray(message.stocks))
                    return "stocks: array expected";
                for (let i = 0; i < message.stocks.length; ++i) {
                    let error = $root.mirana.StockProducto.verify(message.stocks[i]);
                    if (error)
                        return "stocks." + error;
                }
            }
            return null;
        };

        /**
         * Creates a StockProductoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.StockProductoRequest} StockProductoRequest
         */
        StockProductoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.StockProductoRequest)
                return object;
            let message = new $root.mirana.StockProductoRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.stocks) {
                if (!Array.isArray(object.stocks))
                    throw TypeError(".mirana.StockProductoRequest.stocks: array expected");
                message.stocks = [];
                for (let i = 0; i < object.stocks.length; ++i) {
                    if (typeof object.stocks[i] !== "object")
                        throw TypeError(".mirana.StockProductoRequest.stocks: object expected");
                    message.stocks[i] = $root.mirana.StockProducto.fromObject(object.stocks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a StockProductoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.StockProductoRequest
         * @static
         * @param {mirana.StockProductoRequest} message StockProductoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StockProductoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.stocks = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.stocks && message.stocks.length) {
                object.stocks = [];
                for (let j = 0; j < message.stocks.length; ++j)
                    object.stocks[j] = $root.mirana.StockProducto.toObject(message.stocks[j], options);
            }
            return object;
        };

        /**
         * Converts this StockProductoRequest to JSON.
         * @function toJSON
         * @memberof mirana.StockProductoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StockProductoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StockProductoRequest;
    })();

    mirana.AvanceProductoRequest = (function() {

        /**
         * Properties of an AvanceProductoRequest.
         * @memberof mirana
         * @interface IAvanceProductoRequest
         * @property {string|null} [fechaCarga] AvanceProductoRequest fechaCarga
         * @property {Array.<mirana.IAvanceProducto>|null} [avances] AvanceProductoRequest avances
         */

        /**
         * Constructs a new AvanceProductoRequest.
         * @memberof mirana
         * @classdesc Represents an AvanceProductoRequest.
         * @implements IAvanceProductoRequest
         * @constructor
         * @param {mirana.IAvanceProductoRequest=} [properties] Properties to set
         */
        function AvanceProductoRequest(properties) {
            this.avances = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvanceProductoRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.AvanceProductoRequest
         * @instance
         */
        AvanceProductoRequest.prototype.fechaCarga = "";

        /**
         * AvanceProductoRequest avances.
         * @member {Array.<mirana.IAvanceProducto>} avances
         * @memberof mirana.AvanceProductoRequest
         * @instance
         */
        AvanceProductoRequest.prototype.avances = $util.emptyArray;

        /**
         * Creates a new AvanceProductoRequest instance using the specified properties.
         * @function create
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {mirana.IAvanceProductoRequest=} [properties] Properties to set
         * @returns {mirana.AvanceProductoRequest} AvanceProductoRequest instance
         */
        AvanceProductoRequest.create = function create(properties) {
            return new AvanceProductoRequest(properties);
        };

        /**
         * Encodes the specified AvanceProductoRequest message. Does not implicitly {@link mirana.AvanceProductoRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {mirana.IAvanceProductoRequest} message AvanceProductoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceProductoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.avances != null && message.avances.length)
                for (let i = 0; i < message.avances.length; ++i)
                    $root.mirana.AvanceProducto.encode(message.avances[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AvanceProductoRequest message, length delimited. Does not implicitly {@link mirana.AvanceProductoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {mirana.IAvanceProductoRequest} message AvanceProductoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceProductoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvanceProductoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvanceProductoRequest} AvanceProductoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceProductoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvanceProductoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.avances && message.avances.length))
                        message.avances = [];
                    message.avances.push($root.mirana.AvanceProducto.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvanceProductoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvanceProductoRequest} AvanceProductoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceProductoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvanceProductoRequest message.
         * @function verify
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvanceProductoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.avances != null && message.hasOwnProperty("avances")) {
                if (!Array.isArray(message.avances))
                    return "avances: array expected";
                for (let i = 0; i < message.avances.length; ++i) {
                    let error = $root.mirana.AvanceProducto.verify(message.avances[i]);
                    if (error)
                        return "avances." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AvanceProductoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvanceProductoRequest} AvanceProductoRequest
         */
        AvanceProductoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvanceProductoRequest)
                return object;
            let message = new $root.mirana.AvanceProductoRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.avances) {
                if (!Array.isArray(object.avances))
                    throw TypeError(".mirana.AvanceProductoRequest.avances: array expected");
                message.avances = [];
                for (let i = 0; i < object.avances.length; ++i) {
                    if (typeof object.avances[i] !== "object")
                        throw TypeError(".mirana.AvanceProductoRequest.avances: object expected");
                    message.avances[i] = $root.mirana.AvanceProducto.fromObject(object.avances[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AvanceProductoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvanceProductoRequest
         * @static
         * @param {mirana.AvanceProductoRequest} message AvanceProductoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvanceProductoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.avances = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.avances && message.avances.length) {
                object.avances = [];
                for (let j = 0; j < message.avances.length; ++j)
                    object.avances[j] = $root.mirana.AvanceProducto.toObject(message.avances[j], options);
            }
            return object;
        };

        /**
         * Converts this AvanceProductoRequest to JSON.
         * @function toJSON
         * @memberof mirana.AvanceProductoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvanceProductoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvanceProductoRequest;
    })();

    mirana.UIStockProducto = (function() {

        /**
         * Properties of a UIStockProducto.
         * @memberof mirana
         * @interface IUIStockProducto
         * @property {string|null} [fuerzaVenta] UIStockProducto fuerzaVenta
         * @property {string|null} [codigoProducto] UIStockProducto codigoProducto
         * @property {string|null} [descripcionProducto] UIStockProducto descripcionProducto
         * @property {string|null} [descripcionCategoria] UIStockProducto descripcionCategoria
         * @property {string|null} [linea] UIStockProducto linea
         * @property {number|null} [stock] UIStockProducto stock
         * @property {number|null} [promedioDiario] UIStockProducto promedioDiario
         * @property {number|null} [stockDisponible] UIStockProducto stockDisponible
         * @property {number|null} [volumen] UIStockProducto volumen
         * @property {string|null} [fechaCarga] UIStockProducto fechaCarga
         */

        /**
         * Constructs a new UIStockProducto.
         * @memberof mirana
         * @classdesc Represents a UIStockProducto.
         * @implements IUIStockProducto
         * @constructor
         * @param {mirana.IUIStockProducto=} [properties] Properties to set
         */
        function UIStockProducto(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UIStockProducto fuerzaVenta.
         * @member {string} fuerzaVenta
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.fuerzaVenta = "";

        /**
         * UIStockProducto codigoProducto.
         * @member {string} codigoProducto
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.codigoProducto = "";

        /**
         * UIStockProducto descripcionProducto.
         * @member {string} descripcionProducto
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.descripcionProducto = "";

        /**
         * UIStockProducto descripcionCategoria.
         * @member {string} descripcionCategoria
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.descripcionCategoria = "";

        /**
         * UIStockProducto linea.
         * @member {string} linea
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.linea = "";

        /**
         * UIStockProducto stock.
         * @member {number} stock
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.stock = 0;

        /**
         * UIStockProducto promedioDiario.
         * @member {number} promedioDiario
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.promedioDiario = 0;

        /**
         * UIStockProducto stockDisponible.
         * @member {number} stockDisponible
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.stockDisponible = 0;

        /**
         * UIStockProducto volumen.
         * @member {number} volumen
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.volumen = 0;

        /**
         * UIStockProducto fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.UIStockProducto
         * @instance
         */
        UIStockProducto.prototype.fechaCarga = "";

        /**
         * Creates a new UIStockProducto instance using the specified properties.
         * @function create
         * @memberof mirana.UIStockProducto
         * @static
         * @param {mirana.IUIStockProducto=} [properties] Properties to set
         * @returns {mirana.UIStockProducto} UIStockProducto instance
         */
        UIStockProducto.create = function create(properties) {
            return new UIStockProducto(properties);
        };

        /**
         * Encodes the specified UIStockProducto message. Does not implicitly {@link mirana.UIStockProducto.verify|verify} messages.
         * @function encode
         * @memberof mirana.UIStockProducto
         * @static
         * @param {mirana.IUIStockProducto} message UIStockProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIStockProducto.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fuerzaVenta);
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.codigoProducto);
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.descripcionProducto);
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.descripcionCategoria);
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.linea);
            if (message.stock != null && message.hasOwnProperty("stock"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.stock);
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.promedioDiario);
            if (message.stockDisponible != null && message.hasOwnProperty("stockDisponible"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.stockDisponible);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.volumen);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified UIStockProducto message, length delimited. Does not implicitly {@link mirana.UIStockProducto.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UIStockProducto
         * @static
         * @param {mirana.IUIStockProducto} message UIStockProducto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIStockProducto.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UIStockProducto message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UIStockProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UIStockProducto} UIStockProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIStockProducto.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UIStockProducto();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuerzaVenta = reader.string();
                    break;
                case 2:
                    message.codigoProducto = reader.string();
                    break;
                case 3:
                    message.descripcionProducto = reader.string();
                    break;
                case 4:
                    message.descripcionCategoria = reader.string();
                    break;
                case 5:
                    message.linea = reader.string();
                    break;
                case 6:
                    message.stock = reader.double();
                    break;
                case 7:
                    message.promedioDiario = reader.double();
                    break;
                case 8:
                    message.stockDisponible = reader.double();
                    break;
                case 9:
                    message.volumen = reader.double();
                    break;
                case 10:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UIStockProducto message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UIStockProducto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UIStockProducto} UIStockProducto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIStockProducto.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UIStockProducto message.
         * @function verify
         * @memberof mirana.UIStockProducto
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UIStockProducto.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                if (!$util.isString(message.fuerzaVenta))
                    return "fuerzaVenta: string expected";
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                if (!$util.isString(message.codigoProducto))
                    return "codigoProducto: string expected";
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                if (!$util.isString(message.descripcionProducto))
                    return "descripcionProducto: string expected";
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                if (!$util.isString(message.descripcionCategoria))
                    return "descripcionCategoria: string expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.stock != null && message.hasOwnProperty("stock"))
                if (typeof message.stock !== "number")
                    return "stock: number expected";
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                if (typeof message.promedioDiario !== "number")
                    return "promedioDiario: number expected";
            if (message.stockDisponible != null && message.hasOwnProperty("stockDisponible"))
                if (typeof message.stockDisponible !== "number")
                    return "stockDisponible: number expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a UIStockProducto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UIStockProducto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UIStockProducto} UIStockProducto
         */
        UIStockProducto.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UIStockProducto)
                return object;
            let message = new $root.mirana.UIStockProducto();
            if (object.fuerzaVenta != null)
                message.fuerzaVenta = String(object.fuerzaVenta);
            if (object.codigoProducto != null)
                message.codigoProducto = String(object.codigoProducto);
            if (object.descripcionProducto != null)
                message.descripcionProducto = String(object.descripcionProducto);
            if (object.descripcionCategoria != null)
                message.descripcionCategoria = String(object.descripcionCategoria);
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.stock != null)
                message.stock = Number(object.stock);
            if (object.promedioDiario != null)
                message.promedioDiario = Number(object.promedioDiario);
            if (object.stockDisponible != null)
                message.stockDisponible = Number(object.stockDisponible);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a UIStockProducto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UIStockProducto
         * @static
         * @param {mirana.UIStockProducto} message UIStockProducto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UIStockProducto.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fuerzaVenta = "";
                object.codigoProducto = "";
                object.descripcionProducto = "";
                object.descripcionCategoria = "";
                object.linea = "";
                object.stock = 0;
                object.promedioDiario = 0;
                object.stockDisponible = 0;
                object.volumen = 0;
                object.fechaCarga = "";
            }
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                object.fuerzaVenta = message.fuerzaVenta;
            if (message.codigoProducto != null && message.hasOwnProperty("codigoProducto"))
                object.codigoProducto = message.codigoProducto;
            if (message.descripcionProducto != null && message.hasOwnProperty("descripcionProducto"))
                object.descripcionProducto = message.descripcionProducto;
            if (message.descripcionCategoria != null && message.hasOwnProperty("descripcionCategoria"))
                object.descripcionCategoria = message.descripcionCategoria;
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.stock != null && message.hasOwnProperty("stock"))
                object.stock = options.json && !isFinite(message.stock) ? String(message.stock) : message.stock;
            if (message.promedioDiario != null && message.hasOwnProperty("promedioDiario"))
                object.promedioDiario = options.json && !isFinite(message.promedioDiario) ? String(message.promedioDiario) : message.promedioDiario;
            if (message.stockDisponible != null && message.hasOwnProperty("stockDisponible"))
                object.stockDisponible = options.json && !isFinite(message.stockDisponible) ? String(message.stockDisponible) : message.stockDisponible;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this UIStockProducto to JSON.
         * @function toJSON
         * @memberof mirana.UIStockProducto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UIStockProducto.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UIStockProducto;
    })();

    mirana.FiltrarStockProductoResponse = (function() {

        /**
         * Properties of a FiltrarStockProductoResponse.
         * @memberof mirana
         * @interface IFiltrarStockProductoResponse
         * @property {Array.<mirana.IUIStockProducto>|null} [stocks] FiltrarStockProductoResponse stocks
         */

        /**
         * Constructs a new FiltrarStockProductoResponse.
         * @memberof mirana
         * @classdesc Represents a FiltrarStockProductoResponse.
         * @implements IFiltrarStockProductoResponse
         * @constructor
         * @param {mirana.IFiltrarStockProductoResponse=} [properties] Properties to set
         */
        function FiltrarStockProductoResponse(properties) {
            this.stocks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FiltrarStockProductoResponse stocks.
         * @member {Array.<mirana.IUIStockProducto>} stocks
         * @memberof mirana.FiltrarStockProductoResponse
         * @instance
         */
        FiltrarStockProductoResponse.prototype.stocks = $util.emptyArray;

        /**
         * Creates a new FiltrarStockProductoResponse instance using the specified properties.
         * @function create
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {mirana.IFiltrarStockProductoResponse=} [properties] Properties to set
         * @returns {mirana.FiltrarStockProductoResponse} FiltrarStockProductoResponse instance
         */
        FiltrarStockProductoResponse.create = function create(properties) {
            return new FiltrarStockProductoResponse(properties);
        };

        /**
         * Encodes the specified FiltrarStockProductoResponse message. Does not implicitly {@link mirana.FiltrarStockProductoResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {mirana.IFiltrarStockProductoResponse} message FiltrarStockProductoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarStockProductoResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.stocks != null && message.stocks.length)
                for (let i = 0; i < message.stocks.length; ++i)
                    $root.mirana.UIStockProducto.encode(message.stocks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FiltrarStockProductoResponse message, length delimited. Does not implicitly {@link mirana.FiltrarStockProductoResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {mirana.IFiltrarStockProductoResponse} message FiltrarStockProductoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarStockProductoResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FiltrarStockProductoResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FiltrarStockProductoResponse} FiltrarStockProductoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarStockProductoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FiltrarStockProductoResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.stocks && message.stocks.length))
                        message.stocks = [];
                    message.stocks.push($root.mirana.UIStockProducto.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FiltrarStockProductoResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FiltrarStockProductoResponse} FiltrarStockProductoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarStockProductoResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FiltrarStockProductoResponse message.
         * @function verify
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FiltrarStockProductoResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.stocks != null && message.hasOwnProperty("stocks")) {
                if (!Array.isArray(message.stocks))
                    return "stocks: array expected";
                for (let i = 0; i < message.stocks.length; ++i) {
                    let error = $root.mirana.UIStockProducto.verify(message.stocks[i]);
                    if (error)
                        return "stocks." + error;
                }
            }
            return null;
        };

        /**
         * Creates a FiltrarStockProductoResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FiltrarStockProductoResponse} FiltrarStockProductoResponse
         */
        FiltrarStockProductoResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FiltrarStockProductoResponse)
                return object;
            let message = new $root.mirana.FiltrarStockProductoResponse();
            if (object.stocks) {
                if (!Array.isArray(object.stocks))
                    throw TypeError(".mirana.FiltrarStockProductoResponse.stocks: array expected");
                message.stocks = [];
                for (let i = 0; i < object.stocks.length; ++i) {
                    if (typeof object.stocks[i] !== "object")
                        throw TypeError(".mirana.FiltrarStockProductoResponse.stocks: object expected");
                    message.stocks[i] = $root.mirana.UIStockProducto.fromObject(object.stocks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FiltrarStockProductoResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FiltrarStockProductoResponse
         * @static
         * @param {mirana.FiltrarStockProductoResponse} message FiltrarStockProductoResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FiltrarStockProductoResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.stocks = [];
            if (message.stocks && message.stocks.length) {
                object.stocks = [];
                for (let j = 0; j < message.stocks.length; ++j)
                    object.stocks[j] = $root.mirana.UIStockProducto.toObject(message.stocks[j], options);
            }
            return object;
        };

        /**
         * Converts this FiltrarStockProductoResponse to JSON.
         * @function toJSON
         * @memberof mirana.FiltrarStockProductoResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FiltrarStockProductoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FiltrarStockProductoResponse;
    })();

    mirana.AvanceAnual = (function() {

        /**
         * Properties of an AvanceAnual.
         * @memberof mirana
         * @interface IAvanceAnual
         * @property {string|null} [anho] AvanceAnual anho
         * @property {string|null} [mes] AvanceAnual mes
         * @property {number|null} [categoriaOrden] AvanceAnual categoriaOrden
         * @property {string|null} [categoria] AvanceAnual categoria
         * @property {string|null} [linea] AvanceAnual linea
         * @property {number|null} [volumen] AvanceAnual volumen
         * @property {number|null} [monto] AvanceAnual monto
         * @property {number|null} [cobertura] AvanceAnual cobertura
         */

        /**
         * Constructs a new AvanceAnual.
         * @memberof mirana
         * @classdesc Represents an AvanceAnual.
         * @implements IAvanceAnual
         * @constructor
         * @param {mirana.IAvanceAnual=} [properties] Properties to set
         */
        function AvanceAnual(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvanceAnual anho.
         * @member {string} anho
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.anho = "";

        /**
         * AvanceAnual mes.
         * @member {string} mes
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.mes = "";

        /**
         * AvanceAnual categoriaOrden.
         * @member {number} categoriaOrden
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.categoriaOrden = 0;

        /**
         * AvanceAnual categoria.
         * @member {string} categoria
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.categoria = "";

        /**
         * AvanceAnual linea.
         * @member {string} linea
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.linea = "";

        /**
         * AvanceAnual volumen.
         * @member {number} volumen
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.volumen = 0;

        /**
         * AvanceAnual monto.
         * @member {number} monto
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.monto = 0;

        /**
         * AvanceAnual cobertura.
         * @member {number} cobertura
         * @memberof mirana.AvanceAnual
         * @instance
         */
        AvanceAnual.prototype.cobertura = 0;

        /**
         * Creates a new AvanceAnual instance using the specified properties.
         * @function create
         * @memberof mirana.AvanceAnual
         * @static
         * @param {mirana.IAvanceAnual=} [properties] Properties to set
         * @returns {mirana.AvanceAnual} AvanceAnual instance
         */
        AvanceAnual.create = function create(properties) {
            return new AvanceAnual(properties);
        };

        /**
         * Encodes the specified AvanceAnual message. Does not implicitly {@link mirana.AvanceAnual.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvanceAnual
         * @static
         * @param {mirana.IAvanceAnual} message AvanceAnual message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnual.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.anho != null && message.hasOwnProperty("anho"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.anho);
            if (message.mes != null && message.hasOwnProperty("mes"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mes);
            if (message.categoriaOrden != null && message.hasOwnProperty("categoriaOrden"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.categoriaOrden);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.categoria);
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.linea);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.volumen);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.monto);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.cobertura);
            return writer;
        };

        /**
         * Encodes the specified AvanceAnual message, length delimited. Does not implicitly {@link mirana.AvanceAnual.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvanceAnual
         * @static
         * @param {mirana.IAvanceAnual} message AvanceAnual message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnual.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvanceAnual message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvanceAnual
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvanceAnual} AvanceAnual
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnual.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvanceAnual();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.anho = reader.string();
                    break;
                case 2:
                    message.mes = reader.string();
                    break;
                case 3:
                    message.categoriaOrden = reader.int32();
                    break;
                case 4:
                    message.categoria = reader.string();
                    break;
                case 5:
                    message.linea = reader.string();
                    break;
                case 6:
                    message.volumen = reader.double();
                    break;
                case 7:
                    message.monto = reader.double();
                    break;
                case 8:
                    message.cobertura = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvanceAnual message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvanceAnual
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvanceAnual} AvanceAnual
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnual.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvanceAnual message.
         * @function verify
         * @memberof mirana.AvanceAnual
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvanceAnual.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.anho != null && message.hasOwnProperty("anho"))
                if (!$util.isString(message.anho))
                    return "anho: string expected";
            if (message.mes != null && message.hasOwnProperty("mes"))
                if (!$util.isString(message.mes))
                    return "mes: string expected";
            if (message.categoriaOrden != null && message.hasOwnProperty("categoriaOrden"))
                if (!$util.isInteger(message.categoriaOrden))
                    return "categoriaOrden: integer expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            return null;
        };

        /**
         * Creates an AvanceAnual message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvanceAnual
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvanceAnual} AvanceAnual
         */
        AvanceAnual.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvanceAnual)
                return object;
            let message = new $root.mirana.AvanceAnual();
            if (object.anho != null)
                message.anho = String(object.anho);
            if (object.mes != null)
                message.mes = String(object.mes);
            if (object.categoriaOrden != null)
                message.categoriaOrden = object.categoriaOrden | 0;
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            return message;
        };

        /**
         * Creates a plain object from an AvanceAnual message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvanceAnual
         * @static
         * @param {mirana.AvanceAnual} message AvanceAnual
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvanceAnual.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.anho = "";
                object.mes = "";
                object.categoriaOrden = 0;
                object.categoria = "";
                object.linea = "";
                object.volumen = 0;
                object.monto = 0;
                object.cobertura = 0;
            }
            if (message.anho != null && message.hasOwnProperty("anho"))
                object.anho = message.anho;
            if (message.mes != null && message.hasOwnProperty("mes"))
                object.mes = message.mes;
            if (message.categoriaOrden != null && message.hasOwnProperty("categoriaOrden"))
                object.categoriaOrden = message.categoriaOrden;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            return object;
        };

        /**
         * Converts this AvanceAnual to JSON.
         * @function toJSON
         * @memberof mirana.AvanceAnual
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvanceAnual.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvanceAnual;
    })();

    mirana.AvanceAnualList = (function() {

        /**
         * Properties of an AvanceAnualList.
         * @memberof mirana
         * @interface IAvanceAnualList
         * @property {Array.<number>|null} [anhos] AvanceAnualList anhos
         * @property {Array.<mirana.IAvanceAnual>|null} [avances] AvanceAnualList avances
         */

        /**
         * Constructs a new AvanceAnualList.
         * @memberof mirana
         * @classdesc Represents an AvanceAnualList.
         * @implements IAvanceAnualList
         * @constructor
         * @param {mirana.IAvanceAnualList=} [properties] Properties to set
         */
        function AvanceAnualList(properties) {
            this.anhos = [];
            this.avances = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvanceAnualList anhos.
         * @member {Array.<number>} anhos
         * @memberof mirana.AvanceAnualList
         * @instance
         */
        AvanceAnualList.prototype.anhos = $util.emptyArray;

        /**
         * AvanceAnualList avances.
         * @member {Array.<mirana.IAvanceAnual>} avances
         * @memberof mirana.AvanceAnualList
         * @instance
         */
        AvanceAnualList.prototype.avances = $util.emptyArray;

        /**
         * Creates a new AvanceAnualList instance using the specified properties.
         * @function create
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {mirana.IAvanceAnualList=} [properties] Properties to set
         * @returns {mirana.AvanceAnualList} AvanceAnualList instance
         */
        AvanceAnualList.create = function create(properties) {
            return new AvanceAnualList(properties);
        };

        /**
         * Encodes the specified AvanceAnualList message. Does not implicitly {@link mirana.AvanceAnualList.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {mirana.IAvanceAnualList} message AvanceAnualList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnualList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.anhos != null && message.anhos.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.anhos.length; ++i)
                    writer.int32(message.anhos[i]);
                writer.ldelim();
            }
            if (message.avances != null && message.avances.length)
                for (let i = 0; i < message.avances.length; ++i)
                    $root.mirana.AvanceAnual.encode(message.avances[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AvanceAnualList message, length delimited. Does not implicitly {@link mirana.AvanceAnualList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {mirana.IAvanceAnualList} message AvanceAnualList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnualList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvanceAnualList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvanceAnualList} AvanceAnualList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnualList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvanceAnualList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.anhos && message.anhos.length))
                        message.anhos = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.anhos.push(reader.int32());
                    } else
                        message.anhos.push(reader.int32());
                    break;
                case 2:
                    if (!(message.avances && message.avances.length))
                        message.avances = [];
                    message.avances.push($root.mirana.AvanceAnual.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvanceAnualList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvanceAnualList} AvanceAnualList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnualList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvanceAnualList message.
         * @function verify
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvanceAnualList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.anhos != null && message.hasOwnProperty("anhos")) {
                if (!Array.isArray(message.anhos))
                    return "anhos: array expected";
                for (let i = 0; i < message.anhos.length; ++i)
                    if (!$util.isInteger(message.anhos[i]))
                        return "anhos: integer[] expected";
            }
            if (message.avances != null && message.hasOwnProperty("avances")) {
                if (!Array.isArray(message.avances))
                    return "avances: array expected";
                for (let i = 0; i < message.avances.length; ++i) {
                    let error = $root.mirana.AvanceAnual.verify(message.avances[i]);
                    if (error)
                        return "avances." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AvanceAnualList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvanceAnualList} AvanceAnualList
         */
        AvanceAnualList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvanceAnualList)
                return object;
            let message = new $root.mirana.AvanceAnualList();
            if (object.anhos) {
                if (!Array.isArray(object.anhos))
                    throw TypeError(".mirana.AvanceAnualList.anhos: array expected");
                message.anhos = [];
                for (let i = 0; i < object.anhos.length; ++i)
                    message.anhos[i] = object.anhos[i] | 0;
            }
            if (object.avances) {
                if (!Array.isArray(object.avances))
                    throw TypeError(".mirana.AvanceAnualList.avances: array expected");
                message.avances = [];
                for (let i = 0; i < object.avances.length; ++i) {
                    if (typeof object.avances[i] !== "object")
                        throw TypeError(".mirana.AvanceAnualList.avances: object expected");
                    message.avances[i] = $root.mirana.AvanceAnual.fromObject(object.avances[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AvanceAnualList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvanceAnualList
         * @static
         * @param {mirana.AvanceAnualList} message AvanceAnualList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvanceAnualList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.anhos = [];
                object.avances = [];
            }
            if (message.anhos && message.anhos.length) {
                object.anhos = [];
                for (let j = 0; j < message.anhos.length; ++j)
                    object.anhos[j] = message.anhos[j];
            }
            if (message.avances && message.avances.length) {
                object.avances = [];
                for (let j = 0; j < message.avances.length; ++j)
                    object.avances[j] = $root.mirana.AvanceAnual.toObject(message.avances[j], options);
            }
            return object;
        };

        /**
         * Converts this AvanceAnualList to JSON.
         * @function toJSON
         * @memberof mirana.AvanceAnualList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvanceAnualList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvanceAnualList;
    })();

    mirana.AvanceAnualRequest = (function() {

        /**
         * Properties of an AvanceAnualRequest.
         * @memberof mirana
         * @interface IAvanceAnualRequest
         * @property {string|null} [anho] AvanceAnualRequest anho
         * @property {Array.<mirana.IAvanceAnual>|null} [avances] AvanceAnualRequest avances
         */

        /**
         * Constructs a new AvanceAnualRequest.
         * @memberof mirana
         * @classdesc Represents an AvanceAnualRequest.
         * @implements IAvanceAnualRequest
         * @constructor
         * @param {mirana.IAvanceAnualRequest=} [properties] Properties to set
         */
        function AvanceAnualRequest(properties) {
            this.avances = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvanceAnualRequest anho.
         * @member {string} anho
         * @memberof mirana.AvanceAnualRequest
         * @instance
         */
        AvanceAnualRequest.prototype.anho = "";

        /**
         * AvanceAnualRequest avances.
         * @member {Array.<mirana.IAvanceAnual>} avances
         * @memberof mirana.AvanceAnualRequest
         * @instance
         */
        AvanceAnualRequest.prototype.avances = $util.emptyArray;

        /**
         * Creates a new AvanceAnualRequest instance using the specified properties.
         * @function create
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {mirana.IAvanceAnualRequest=} [properties] Properties to set
         * @returns {mirana.AvanceAnualRequest} AvanceAnualRequest instance
         */
        AvanceAnualRequest.create = function create(properties) {
            return new AvanceAnualRequest(properties);
        };

        /**
         * Encodes the specified AvanceAnualRequest message. Does not implicitly {@link mirana.AvanceAnualRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {mirana.IAvanceAnualRequest} message AvanceAnualRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnualRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.anho != null && message.hasOwnProperty("anho"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.anho);
            if (message.avances != null && message.avances.length)
                for (let i = 0; i < message.avances.length; ++i)
                    $root.mirana.AvanceAnual.encode(message.avances[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AvanceAnualRequest message, length delimited. Does not implicitly {@link mirana.AvanceAnualRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {mirana.IAvanceAnualRequest} message AvanceAnualRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvanceAnualRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvanceAnualRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvanceAnualRequest} AvanceAnualRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnualRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvanceAnualRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.anho = reader.string();
                    break;
                case 2:
                    if (!(message.avances && message.avances.length))
                        message.avances = [];
                    message.avances.push($root.mirana.AvanceAnual.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvanceAnualRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvanceAnualRequest} AvanceAnualRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvanceAnualRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvanceAnualRequest message.
         * @function verify
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvanceAnualRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.anho != null && message.hasOwnProperty("anho"))
                if (!$util.isString(message.anho))
                    return "anho: string expected";
            if (message.avances != null && message.hasOwnProperty("avances")) {
                if (!Array.isArray(message.avances))
                    return "avances: array expected";
                for (let i = 0; i < message.avances.length; ++i) {
                    let error = $root.mirana.AvanceAnual.verify(message.avances[i]);
                    if (error)
                        return "avances." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AvanceAnualRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvanceAnualRequest} AvanceAnualRequest
         */
        AvanceAnualRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvanceAnualRequest)
                return object;
            let message = new $root.mirana.AvanceAnualRequest();
            if (object.anho != null)
                message.anho = String(object.anho);
            if (object.avances) {
                if (!Array.isArray(object.avances))
                    throw TypeError(".mirana.AvanceAnualRequest.avances: array expected");
                message.avances = [];
                for (let i = 0; i < object.avances.length; ++i) {
                    if (typeof object.avances[i] !== "object")
                        throw TypeError(".mirana.AvanceAnualRequest.avances: object expected");
                    message.avances[i] = $root.mirana.AvanceAnual.fromObject(object.avances[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AvanceAnualRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvanceAnualRequest
         * @static
         * @param {mirana.AvanceAnualRequest} message AvanceAnualRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvanceAnualRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.avances = [];
            if (options.defaults)
                object.anho = "";
            if (message.anho != null && message.hasOwnProperty("anho"))
                object.anho = message.anho;
            if (message.avances && message.avances.length) {
                object.avances = [];
                for (let j = 0; j < message.avances.length; ++j)
                    object.avances[j] = $root.mirana.AvanceAnual.toObject(message.avances[j], options);
            }
            return object;
        };

        /**
         * Converts this AvanceAnualRequest to JSON.
         * @function toJSON
         * @memberof mirana.AvanceAnualRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvanceAnualRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvanceAnualRequest;
    })();

    mirana.AvancePeriodo = (function() {

        /**
         * Properties of an AvancePeriodo.
         * @memberof mirana
         * @interface IAvancePeriodo
         * @property {string|null} [periodo] AvancePeriodo periodo
         * @property {string|null} [rutaId] AvancePeriodo rutaId
         * @property {string|null} [vendedorId] AvancePeriodo vendedorId
         * @property {string|null} [vendedor] AvancePeriodo vendedor
         * @property {string|null} [linea] AvancePeriodo linea
         * @property {number|null} [avance] AvancePeriodo avance
         * @property {number|null} [volumen] AvancePeriodo volumen
         * @property {number|null} [monto] AvancePeriodo monto
         * @property {number|null} [cobertura] AvancePeriodo cobertura
         */

        /**
         * Constructs a new AvancePeriodo.
         * @memberof mirana
         * @classdesc Represents an AvancePeriodo.
         * @implements IAvancePeriodo
         * @constructor
         * @param {mirana.IAvancePeriodo=} [properties] Properties to set
         */
        function AvancePeriodo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvancePeriodo periodo.
         * @member {string} periodo
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.periodo = "";

        /**
         * AvancePeriodo rutaId.
         * @member {string} rutaId
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.rutaId = "";

        /**
         * AvancePeriodo vendedorId.
         * @member {string} vendedorId
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.vendedorId = "";

        /**
         * AvancePeriodo vendedor.
         * @member {string} vendedor
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.vendedor = "";

        /**
         * AvancePeriodo linea.
         * @member {string} linea
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.linea = "";

        /**
         * AvancePeriodo avance.
         * @member {number} avance
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.avance = 0;

        /**
         * AvancePeriodo volumen.
         * @member {number} volumen
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.volumen = 0;

        /**
         * AvancePeriodo monto.
         * @member {number} monto
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.monto = 0;

        /**
         * AvancePeriodo cobertura.
         * @member {number} cobertura
         * @memberof mirana.AvancePeriodo
         * @instance
         */
        AvancePeriodo.prototype.cobertura = 0;

        /**
         * Creates a new AvancePeriodo instance using the specified properties.
         * @function create
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {mirana.IAvancePeriodo=} [properties] Properties to set
         * @returns {mirana.AvancePeriodo} AvancePeriodo instance
         */
        AvancePeriodo.create = function create(properties) {
            return new AvancePeriodo(properties);
        };

        /**
         * Encodes the specified AvancePeriodo message. Does not implicitly {@link mirana.AvancePeriodo.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {mirana.IAvancePeriodo} message AvancePeriodo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvancePeriodo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.periodo);
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rutaId);
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.vendedorId);
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.vendedor);
            if (message.linea != null && message.hasOwnProperty("linea"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.linea);
            if (message.avance != null && message.hasOwnProperty("avance"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.avance);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.volumen);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.monto);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.cobertura);
            return writer;
        };

        /**
         * Encodes the specified AvancePeriodo message, length delimited. Does not implicitly {@link mirana.AvancePeriodo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {mirana.IAvancePeriodo} message AvancePeriodo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvancePeriodo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvancePeriodo message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvancePeriodo} AvancePeriodo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvancePeriodo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvancePeriodo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.periodo = reader.string();
                    break;
                case 2:
                    message.rutaId = reader.string();
                    break;
                case 3:
                    message.vendedorId = reader.string();
                    break;
                case 4:
                    message.vendedor = reader.string();
                    break;
                case 5:
                    message.linea = reader.string();
                    break;
                case 6:
                    message.avance = reader.double();
                    break;
                case 7:
                    message.volumen = reader.double();
                    break;
                case 8:
                    message.monto = reader.double();
                    break;
                case 9:
                    message.cobertura = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvancePeriodo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvancePeriodo} AvancePeriodo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvancePeriodo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvancePeriodo message.
         * @function verify
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvancePeriodo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                if (!$util.isString(message.periodo))
                    return "periodo: string expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                if (!$util.isString(message.vendedorId))
                    return "vendedorId: string expected";
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                if (!$util.isString(message.vendedor))
                    return "vendedor: string expected";
            if (message.linea != null && message.hasOwnProperty("linea"))
                if (!$util.isString(message.linea))
                    return "linea: string expected";
            if (message.avance != null && message.hasOwnProperty("avance"))
                if (typeof message.avance !== "number")
                    return "avance: number expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            return null;
        };

        /**
         * Creates an AvancePeriodo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvancePeriodo} AvancePeriodo
         */
        AvancePeriodo.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvancePeriodo)
                return object;
            let message = new $root.mirana.AvancePeriodo();
            if (object.periodo != null)
                message.periodo = String(object.periodo);
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.vendedorId != null)
                message.vendedorId = String(object.vendedorId);
            if (object.vendedor != null)
                message.vendedor = String(object.vendedor);
            if (object.linea != null)
                message.linea = String(object.linea);
            if (object.avance != null)
                message.avance = Number(object.avance);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            return message;
        };

        /**
         * Creates a plain object from an AvancePeriodo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvancePeriodo
         * @static
         * @param {mirana.AvancePeriodo} message AvancePeriodo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvancePeriodo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.periodo = "";
                object.rutaId = "";
                object.vendedorId = "";
                object.vendedor = "";
                object.linea = "";
                object.avance = 0;
                object.volumen = 0;
                object.monto = 0;
                object.cobertura = 0;
            }
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                object.periodo = message.periodo;
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                object.vendedorId = message.vendedorId;
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                object.vendedor = message.vendedor;
            if (message.linea != null && message.hasOwnProperty("linea"))
                object.linea = message.linea;
            if (message.avance != null && message.hasOwnProperty("avance"))
                object.avance = options.json && !isFinite(message.avance) ? String(message.avance) : message.avance;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            return object;
        };

        /**
         * Converts this AvancePeriodo to JSON.
         * @function toJSON
         * @memberof mirana.AvancePeriodo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvancePeriodo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvancePeriodo;
    })();

    mirana.AvancePeriodoRequest = (function() {

        /**
         * Properties of an AvancePeriodoRequest.
         * @memberof mirana
         * @interface IAvancePeriodoRequest
         * @property {string|null} [periodo] AvancePeriodoRequest periodo
         * @property {Array.<mirana.IAvancePeriodo>|null} [avances] AvancePeriodoRequest avances
         */

        /**
         * Constructs a new AvancePeriodoRequest.
         * @memberof mirana
         * @classdesc Represents an AvancePeriodoRequest.
         * @implements IAvancePeriodoRequest
         * @constructor
         * @param {mirana.IAvancePeriodoRequest=} [properties] Properties to set
         */
        function AvancePeriodoRequest(properties) {
            this.avances = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvancePeriodoRequest periodo.
         * @member {string} periodo
         * @memberof mirana.AvancePeriodoRequest
         * @instance
         */
        AvancePeriodoRequest.prototype.periodo = "";

        /**
         * AvancePeriodoRequest avances.
         * @member {Array.<mirana.IAvancePeriodo>} avances
         * @memberof mirana.AvancePeriodoRequest
         * @instance
         */
        AvancePeriodoRequest.prototype.avances = $util.emptyArray;

        /**
         * Creates a new AvancePeriodoRequest instance using the specified properties.
         * @function create
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {mirana.IAvancePeriodoRequest=} [properties] Properties to set
         * @returns {mirana.AvancePeriodoRequest} AvancePeriodoRequest instance
         */
        AvancePeriodoRequest.create = function create(properties) {
            return new AvancePeriodoRequest(properties);
        };

        /**
         * Encodes the specified AvancePeriodoRequest message. Does not implicitly {@link mirana.AvancePeriodoRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {mirana.IAvancePeriodoRequest} message AvancePeriodoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvancePeriodoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.periodo);
            if (message.avances != null && message.avances.length)
                for (let i = 0; i < message.avances.length; ++i)
                    $root.mirana.AvancePeriodo.encode(message.avances[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AvancePeriodoRequest message, length delimited. Does not implicitly {@link mirana.AvancePeriodoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {mirana.IAvancePeriodoRequest} message AvancePeriodoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvancePeriodoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvancePeriodoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.AvancePeriodoRequest} AvancePeriodoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvancePeriodoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.AvancePeriodoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.periodo = reader.string();
                    break;
                case 2:
                    if (!(message.avances && message.avances.length))
                        message.avances = [];
                    message.avances.push($root.mirana.AvancePeriodo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AvancePeriodoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.AvancePeriodoRequest} AvancePeriodoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvancePeriodoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvancePeriodoRequest message.
         * @function verify
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvancePeriodoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                if (!$util.isString(message.periodo))
                    return "periodo: string expected";
            if (message.avances != null && message.hasOwnProperty("avances")) {
                if (!Array.isArray(message.avances))
                    return "avances: array expected";
                for (let i = 0; i < message.avances.length; ++i) {
                    let error = $root.mirana.AvancePeriodo.verify(message.avances[i]);
                    if (error)
                        return "avances." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AvancePeriodoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.AvancePeriodoRequest} AvancePeriodoRequest
         */
        AvancePeriodoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.AvancePeriodoRequest)
                return object;
            let message = new $root.mirana.AvancePeriodoRequest();
            if (object.periodo != null)
                message.periodo = String(object.periodo);
            if (object.avances) {
                if (!Array.isArray(object.avances))
                    throw TypeError(".mirana.AvancePeriodoRequest.avances: array expected");
                message.avances = [];
                for (let i = 0; i < object.avances.length; ++i) {
                    if (typeof object.avances[i] !== "object")
                        throw TypeError(".mirana.AvancePeriodoRequest.avances: object expected");
                    message.avances[i] = $root.mirana.AvancePeriodo.fromObject(object.avances[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AvancePeriodoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.AvancePeriodoRequest
         * @static
         * @param {mirana.AvancePeriodoRequest} message AvancePeriodoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvancePeriodoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.avances = [];
            if (options.defaults)
                object.periodo = "";
            if (message.periodo != null && message.hasOwnProperty("periodo"))
                object.periodo = message.periodo;
            if (message.avances && message.avances.length) {
                object.avances = [];
                for (let j = 0; j < message.avances.length; ++j)
                    object.avances[j] = $root.mirana.AvancePeriodo.toObject(message.avances[j], options);
            }
            return object;
        };

        /**
         * Converts this AvancePeriodoRequest to JSON.
         * @function toJSON
         * @memberof mirana.AvancePeriodoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvancePeriodoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvancePeriodoRequest;
    })();

    mirana.AvanceService = (function() {

        /**
         * Constructs a new AvanceService service.
         * @memberof mirana
         * @classdesc Represents an AvanceService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function AvanceService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (AvanceService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AvanceService;

        /**
         * Creates new AvanceService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.AvanceService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {AvanceService} RPC service. Useful where requests and/or responses are streamed.
         */
        AvanceService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.AvanceService#syncAvanceAnual}.
         * @memberof mirana.AvanceService
         * @typedef syncAvanceAnualCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncAvanceAnual.
         * @function syncAvanceAnual
         * @memberof mirana.AvanceService
         * @instance
         * @param {mirana.IAvanceAnualRequest} request AvanceAnualRequest message or plain object
         * @param {mirana.AvanceService.syncAvanceAnualCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        AvanceService.prototype.syncAvanceAnual = function syncAvanceAnual(request, callback) {
            return this.rpcCall(syncAvanceAnual, $root.mirana.AvanceAnualRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncAvanceAnual.
         * @function syncAvanceAnual
         * @memberof mirana.AvanceService
         * @instance
         * @param {mirana.IAvanceAnualRequest} request AvanceAnualRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.AvanceService#syncAvancePeriodo}.
         * @memberof mirana.AvanceService
         * @typedef syncAvancePeriodoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncAvancePeriodo.
         * @function syncAvancePeriodo
         * @memberof mirana.AvanceService
         * @instance
         * @param {mirana.IAvancePeriodoRequest} request AvancePeriodoRequest message or plain object
         * @param {mirana.AvanceService.syncAvancePeriodoCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        AvanceService.prototype.syncAvancePeriodo = function syncAvancePeriodo(request, callback) {
            return this.rpcCall(syncAvancePeriodo, $root.mirana.AvancePeriodoRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncAvancePeriodo.
         * @function syncAvancePeriodo
         * @memberof mirana.AvanceService
         * @instance
         * @param {mirana.IAvancePeriodoRequest} request AvancePeriodoRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return AvanceService;
    })();

    mirana.Prioritario = (function() {

        /**
         * Properties of a Prioritario.
         * @memberof mirana
         * @interface IPrioritario
         * @property {string|null} [rutaId] Prioritario rutaId
         * @property {string|null} [moduloId] Prioritario moduloId
         * @property {string|null} [diaVisita] Prioritario diaVisita
         * @property {string|null} [clienteId] Prioritario clienteId
         * @property {string|null} [clienteRazonSocial] Prioritario clienteRazonSocial
         * @property {number|null} [monto] Prioritario monto
         * @property {string|null} [fechaConsulta] Prioritario fechaConsulta
         * @property {string|null} [mesaId] Prioritario mesaId
         * @property {string|null} [fuerzaVentaId] Prioritario fuerzaVentaId
         * @property {string|null} [tpNomenclatura] Prioritario tpNomenclatura
         * @property {number|null} [tpMonto] Prioritario tpMonto
         * @property {string|null} [cluster] Prioritario cluster
         * @property {string|null} [giro] Prioritario giro
         * @property {string|null} [eeff] Prioritario eeff
         */

        /**
         * Constructs a new Prioritario.
         * @memberof mirana
         * @classdesc Represents a Prioritario.
         * @implements IPrioritario
         * @constructor
         * @param {mirana.IPrioritario=} [properties] Properties to set
         */
        function Prioritario(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Prioritario rutaId.
         * @member {string} rutaId
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.rutaId = "";

        /**
         * Prioritario moduloId.
         * @member {string} moduloId
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.moduloId = "";

        /**
         * Prioritario diaVisita.
         * @member {string} diaVisita
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.diaVisita = "";

        /**
         * Prioritario clienteId.
         * @member {string} clienteId
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.clienteId = "";

        /**
         * Prioritario clienteRazonSocial.
         * @member {string} clienteRazonSocial
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.clienteRazonSocial = "";

        /**
         * Prioritario monto.
         * @member {number} monto
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.monto = 0;

        /**
         * Prioritario fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.fechaConsulta = "";

        /**
         * Prioritario mesaId.
         * @member {string} mesaId
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.mesaId = "";

        /**
         * Prioritario fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.fuerzaVentaId = "";

        /**
         * Prioritario tpNomenclatura.
         * @member {string} tpNomenclatura
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.tpNomenclatura = "";

        /**
         * Prioritario tpMonto.
         * @member {number} tpMonto
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.tpMonto = 0;

        /**
         * Prioritario cluster.
         * @member {string} cluster
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.cluster = "";

        /**
         * Prioritario giro.
         * @member {string} giro
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.giro = "";

        /**
         * Prioritario eeff.
         * @member {string} eeff
         * @memberof mirana.Prioritario
         * @instance
         */
        Prioritario.prototype.eeff = "";

        /**
         * Creates a new Prioritario instance using the specified properties.
         * @function create
         * @memberof mirana.Prioritario
         * @static
         * @param {mirana.IPrioritario=} [properties] Properties to set
         * @returns {mirana.Prioritario} Prioritario instance
         */
        Prioritario.create = function create(properties) {
            return new Prioritario(properties);
        };

        /**
         * Encodes the specified Prioritario message. Does not implicitly {@link mirana.Prioritario.verify|verify} messages.
         * @function encode
         * @memberof mirana.Prioritario
         * @static
         * @param {mirana.IPrioritario} message Prioritario message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Prioritario.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.rutaId);
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.moduloId);
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.diaVisita);
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.clienteId);
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.clienteRazonSocial);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.monto);
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.fechaConsulta);
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.mesaId);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.fuerzaVentaId);
            if (message.tpNomenclatura != null && message.hasOwnProperty("tpNomenclatura"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.tpNomenclatura);
            if (message.tpMonto != null && message.hasOwnProperty("tpMonto"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.tpMonto);
            if (message.cluster != null && message.hasOwnProperty("cluster"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.cluster);
            if (message.giro != null && message.hasOwnProperty("giro"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.giro);
            if (message.eeff != null && message.hasOwnProperty("eeff"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.eeff);
            return writer;
        };

        /**
         * Encodes the specified Prioritario message, length delimited. Does not implicitly {@link mirana.Prioritario.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Prioritario
         * @static
         * @param {mirana.IPrioritario} message Prioritario message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Prioritario.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Prioritario message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Prioritario
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Prioritario} Prioritario
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Prioritario.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Prioritario();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.rutaId = reader.string();
                    break;
                case 2:
                    message.moduloId = reader.string();
                    break;
                case 3:
                    message.diaVisita = reader.string();
                    break;
                case 4:
                    message.clienteId = reader.string();
                    break;
                case 6:
                    message.clienteRazonSocial = reader.string();
                    break;
                case 7:
                    message.monto = reader.double();
                    break;
                case 8:
                    message.fechaConsulta = reader.string();
                    break;
                case 9:
                    message.mesaId = reader.string();
                    break;
                case 10:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 11:
                    message.tpNomenclatura = reader.string();
                    break;
                case 12:
                    message.tpMonto = reader.double();
                    break;
                case 13:
                    message.cluster = reader.string();
                    break;
                case 14:
                    message.giro = reader.string();
                    break;
                case 15:
                    message.eeff = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Prioritario message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Prioritario
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Prioritario} Prioritario
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Prioritario.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Prioritario message.
         * @function verify
         * @memberof mirana.Prioritario
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Prioritario.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                if (!$util.isString(message.moduloId))
                    return "moduloId: string expected";
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                if (!$util.isString(message.diaVisita))
                    return "diaVisita: string expected";
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                if (!$util.isString(message.clienteId))
                    return "clienteId: string expected";
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                if (!$util.isString(message.clienteRazonSocial))
                    return "clienteRazonSocial: string expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.tpNomenclatura != null && message.hasOwnProperty("tpNomenclatura"))
                if (!$util.isString(message.tpNomenclatura))
                    return "tpNomenclatura: string expected";
            if (message.tpMonto != null && message.hasOwnProperty("tpMonto"))
                if (typeof message.tpMonto !== "number")
                    return "tpMonto: number expected";
            if (message.cluster != null && message.hasOwnProperty("cluster"))
                if (!$util.isString(message.cluster))
                    return "cluster: string expected";
            if (message.giro != null && message.hasOwnProperty("giro"))
                if (!$util.isString(message.giro))
                    return "giro: string expected";
            if (message.eeff != null && message.hasOwnProperty("eeff"))
                if (!$util.isString(message.eeff))
                    return "eeff: string expected";
            return null;
        };

        /**
         * Creates a Prioritario message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Prioritario
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Prioritario} Prioritario
         */
        Prioritario.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Prioritario)
                return object;
            let message = new $root.mirana.Prioritario();
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.moduloId != null)
                message.moduloId = String(object.moduloId);
            if (object.diaVisita != null)
                message.diaVisita = String(object.diaVisita);
            if (object.clienteId != null)
                message.clienteId = String(object.clienteId);
            if (object.clienteRazonSocial != null)
                message.clienteRazonSocial = String(object.clienteRazonSocial);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.tpNomenclatura != null)
                message.tpNomenclatura = String(object.tpNomenclatura);
            if (object.tpMonto != null)
                message.tpMonto = Number(object.tpMonto);
            if (object.cluster != null)
                message.cluster = String(object.cluster);
            if (object.giro != null)
                message.giro = String(object.giro);
            if (object.eeff != null)
                message.eeff = String(object.eeff);
            return message;
        };

        /**
         * Creates a plain object from a Prioritario message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Prioritario
         * @static
         * @param {mirana.Prioritario} message Prioritario
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Prioritario.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.rutaId = "";
                object.moduloId = "";
                object.diaVisita = "";
                object.clienteId = "";
                object.clienteRazonSocial = "";
                object.monto = 0;
                object.fechaConsulta = "";
                object.mesaId = "";
                object.fuerzaVentaId = "";
                object.tpNomenclatura = "";
                object.tpMonto = 0;
                object.cluster = "";
                object.giro = "";
                object.eeff = "";
            }
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.moduloId != null && message.hasOwnProperty("moduloId"))
                object.moduloId = message.moduloId;
            if (message.diaVisita != null && message.hasOwnProperty("diaVisita"))
                object.diaVisita = message.diaVisita;
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                object.clienteId = message.clienteId;
            if (message.clienteRazonSocial != null && message.hasOwnProperty("clienteRazonSocial"))
                object.clienteRazonSocial = message.clienteRazonSocial;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.tpNomenclatura != null && message.hasOwnProperty("tpNomenclatura"))
                object.tpNomenclatura = message.tpNomenclatura;
            if (message.tpMonto != null && message.hasOwnProperty("tpMonto"))
                object.tpMonto = options.json && !isFinite(message.tpMonto) ? String(message.tpMonto) : message.tpMonto;
            if (message.cluster != null && message.hasOwnProperty("cluster"))
                object.cluster = message.cluster;
            if (message.giro != null && message.hasOwnProperty("giro"))
                object.giro = message.giro;
            if (message.eeff != null && message.hasOwnProperty("eeff"))
                object.eeff = message.eeff;
            return object;
        };

        /**
         * Converts this Prioritario to JSON.
         * @function toJSON
         * @memberof mirana.Prioritario
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Prioritario.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Prioritario;
    })();

    mirana.UIPrioritarioDetalle = (function() {

        /**
         * Properties of a UIPrioritarioDetalle.
         * @memberof mirana
         * @interface IUIPrioritarioDetalle
         * @property {string|null} [prioridad] UIPrioritarioDetalle prioridad
         * @property {Array.<number>|null} [monto] UIPrioritarioDetalle monto
         */

        /**
         * Constructs a new UIPrioritarioDetalle.
         * @memberof mirana
         * @classdesc Represents a UIPrioritarioDetalle.
         * @implements IUIPrioritarioDetalle
         * @constructor
         * @param {mirana.IUIPrioritarioDetalle=} [properties] Properties to set
         */
        function UIPrioritarioDetalle(properties) {
            this.monto = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UIPrioritarioDetalle prioridad.
         * @member {string} prioridad
         * @memberof mirana.UIPrioritarioDetalle
         * @instance
         */
        UIPrioritarioDetalle.prototype.prioridad = "";

        /**
         * UIPrioritarioDetalle monto.
         * @member {Array.<number>} monto
         * @memberof mirana.UIPrioritarioDetalle
         * @instance
         */
        UIPrioritarioDetalle.prototype.monto = $util.emptyArray;

        /**
         * Creates a new UIPrioritarioDetalle instance using the specified properties.
         * @function create
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {mirana.IUIPrioritarioDetalle=} [properties] Properties to set
         * @returns {mirana.UIPrioritarioDetalle} UIPrioritarioDetalle instance
         */
        UIPrioritarioDetalle.create = function create(properties) {
            return new UIPrioritarioDetalle(properties);
        };

        /**
         * Encodes the specified UIPrioritarioDetalle message. Does not implicitly {@link mirana.UIPrioritarioDetalle.verify|verify} messages.
         * @function encode
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {mirana.IUIPrioritarioDetalle} message UIPrioritarioDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIPrioritarioDetalle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.prioridad);
            if (message.monto != null && message.monto.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (let i = 0; i < message.monto.length; ++i)
                    writer.double(message.monto[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified UIPrioritarioDetalle message, length delimited. Does not implicitly {@link mirana.UIPrioritarioDetalle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {mirana.IUIPrioritarioDetalle} message UIPrioritarioDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIPrioritarioDetalle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UIPrioritarioDetalle message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UIPrioritarioDetalle} UIPrioritarioDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIPrioritarioDetalle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UIPrioritarioDetalle();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.prioridad = reader.string();
                    break;
                case 2:
                    if (!(message.monto && message.monto.length))
                        message.monto = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.monto.push(reader.double());
                    } else
                        message.monto.push(reader.double());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UIPrioritarioDetalle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UIPrioritarioDetalle} UIPrioritarioDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIPrioritarioDetalle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UIPrioritarioDetalle message.
         * @function verify
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UIPrioritarioDetalle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                if (!$util.isString(message.prioridad))
                    return "prioridad: string expected";
            if (message.monto != null && message.hasOwnProperty("monto")) {
                if (!Array.isArray(message.monto))
                    return "monto: array expected";
                for (let i = 0; i < message.monto.length; ++i)
                    if (typeof message.monto[i] !== "number")
                        return "monto: number[] expected";
            }
            return null;
        };

        /**
         * Creates a UIPrioritarioDetalle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UIPrioritarioDetalle} UIPrioritarioDetalle
         */
        UIPrioritarioDetalle.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UIPrioritarioDetalle)
                return object;
            let message = new $root.mirana.UIPrioritarioDetalle();
            if (object.prioridad != null)
                message.prioridad = String(object.prioridad);
            if (object.monto) {
                if (!Array.isArray(object.monto))
                    throw TypeError(".mirana.UIPrioritarioDetalle.monto: array expected");
                message.monto = [];
                for (let i = 0; i < object.monto.length; ++i)
                    message.monto[i] = Number(object.monto[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a UIPrioritarioDetalle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UIPrioritarioDetalle
         * @static
         * @param {mirana.UIPrioritarioDetalle} message UIPrioritarioDetalle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UIPrioritarioDetalle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.monto = [];
            if (options.defaults)
                object.prioridad = "";
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                object.prioridad = message.prioridad;
            if (message.monto && message.monto.length) {
                object.monto = [];
                for (let j = 0; j < message.monto.length; ++j)
                    object.monto[j] = options.json && !isFinite(message.monto[j]) ? String(message.monto[j]) : message.monto[j];
            }
            return object;
        };

        /**
         * Converts this UIPrioritarioDetalle to JSON.
         * @function toJSON
         * @memberof mirana.UIPrioritarioDetalle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UIPrioritarioDetalle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UIPrioritarioDetalle;
    })();

    mirana.PrioritarioLinea = (function() {

        /**
         * Properties of a PrioritarioLinea.
         * @memberof mirana
         * @interface IPrioritarioLinea
         * @property {string|null} [prioridad] PrioritarioLinea prioridad
         * @property {number|null} [orden] PrioritarioLinea orden
         */

        /**
         * Constructs a new PrioritarioLinea.
         * @memberof mirana
         * @classdesc Represents a PrioritarioLinea.
         * @implements IPrioritarioLinea
         * @constructor
         * @param {mirana.IPrioritarioLinea=} [properties] Properties to set
         */
        function PrioritarioLinea(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrioritarioLinea prioridad.
         * @member {string} prioridad
         * @memberof mirana.PrioritarioLinea
         * @instance
         */
        PrioritarioLinea.prototype.prioridad = "";

        /**
         * PrioritarioLinea orden.
         * @member {number} orden
         * @memberof mirana.PrioritarioLinea
         * @instance
         */
        PrioritarioLinea.prototype.orden = 0;

        /**
         * Creates a new PrioritarioLinea instance using the specified properties.
         * @function create
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {mirana.IPrioritarioLinea=} [properties] Properties to set
         * @returns {mirana.PrioritarioLinea} PrioritarioLinea instance
         */
        PrioritarioLinea.create = function create(properties) {
            return new PrioritarioLinea(properties);
        };

        /**
         * Encodes the specified PrioritarioLinea message. Does not implicitly {@link mirana.PrioritarioLinea.verify|verify} messages.
         * @function encode
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {mirana.IPrioritarioLinea} message PrioritarioLinea message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioLinea.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.prioridad);
            if (message.orden != null && message.hasOwnProperty("orden"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.orden);
            return writer;
        };

        /**
         * Encodes the specified PrioritarioLinea message, length delimited. Does not implicitly {@link mirana.PrioritarioLinea.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {mirana.IPrioritarioLinea} message PrioritarioLinea message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioLinea.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrioritarioLinea message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PrioritarioLinea} PrioritarioLinea
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioLinea.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PrioritarioLinea();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.prioridad = reader.string();
                    break;
                case 2:
                    message.orden = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrioritarioLinea message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PrioritarioLinea} PrioritarioLinea
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioLinea.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrioritarioLinea message.
         * @function verify
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrioritarioLinea.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                if (!$util.isString(message.prioridad))
                    return "prioridad: string expected";
            if (message.orden != null && message.hasOwnProperty("orden"))
                if (!$util.isInteger(message.orden))
                    return "orden: integer expected";
            return null;
        };

        /**
         * Creates a PrioritarioLinea message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PrioritarioLinea} PrioritarioLinea
         */
        PrioritarioLinea.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PrioritarioLinea)
                return object;
            let message = new $root.mirana.PrioritarioLinea();
            if (object.prioridad != null)
                message.prioridad = String(object.prioridad);
            if (object.orden != null)
                message.orden = object.orden | 0;
            return message;
        };

        /**
         * Creates a plain object from a PrioritarioLinea message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PrioritarioLinea
         * @static
         * @param {mirana.PrioritarioLinea} message PrioritarioLinea
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrioritarioLinea.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.prioridad = "";
                object.orden = 0;
            }
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                object.prioridad = message.prioridad;
            if (message.orden != null && message.hasOwnProperty("orden"))
                object.orden = message.orden;
            return object;
        };

        /**
         * Converts this PrioritarioLinea to JSON.
         * @function toJSON
         * @memberof mirana.PrioritarioLinea
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrioritarioLinea.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PrioritarioLinea;
    })();

    mirana.PrioritarioLineaList = (function() {

        /**
         * Properties of a PrioritarioLineaList.
         * @memberof mirana
         * @interface IPrioritarioLineaList
         * @property {Array.<mirana.IPrioritarioLinea>|null} [lineas] PrioritarioLineaList lineas
         * @property {number|null} [totalLineas] PrioritarioLineaList totalLineas
         */

        /**
         * Constructs a new PrioritarioLineaList.
         * @memberof mirana
         * @classdesc Represents a PrioritarioLineaList.
         * @implements IPrioritarioLineaList
         * @constructor
         * @param {mirana.IPrioritarioLineaList=} [properties] Properties to set
         */
        function PrioritarioLineaList(properties) {
            this.lineas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrioritarioLineaList lineas.
         * @member {Array.<mirana.IPrioritarioLinea>} lineas
         * @memberof mirana.PrioritarioLineaList
         * @instance
         */
        PrioritarioLineaList.prototype.lineas = $util.emptyArray;

        /**
         * PrioritarioLineaList totalLineas.
         * @member {number} totalLineas
         * @memberof mirana.PrioritarioLineaList
         * @instance
         */
        PrioritarioLineaList.prototype.totalLineas = 0;

        /**
         * Creates a new PrioritarioLineaList instance using the specified properties.
         * @function create
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {mirana.IPrioritarioLineaList=} [properties] Properties to set
         * @returns {mirana.PrioritarioLineaList} PrioritarioLineaList instance
         */
        PrioritarioLineaList.create = function create(properties) {
            return new PrioritarioLineaList(properties);
        };

        /**
         * Encodes the specified PrioritarioLineaList message. Does not implicitly {@link mirana.PrioritarioLineaList.verify|verify} messages.
         * @function encode
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {mirana.IPrioritarioLineaList} message PrioritarioLineaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioLineaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lineas != null && message.lineas.length)
                for (let i = 0; i < message.lineas.length; ++i)
                    $root.mirana.PrioritarioLinea.encode(message.lineas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.totalLineas != null && message.hasOwnProperty("totalLineas"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalLineas);
            return writer;
        };

        /**
         * Encodes the specified PrioritarioLineaList message, length delimited. Does not implicitly {@link mirana.PrioritarioLineaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {mirana.IPrioritarioLineaList} message PrioritarioLineaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioLineaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrioritarioLineaList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PrioritarioLineaList} PrioritarioLineaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioLineaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PrioritarioLineaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.lineas && message.lineas.length))
                        message.lineas = [];
                    message.lineas.push($root.mirana.PrioritarioLinea.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.totalLineas = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrioritarioLineaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PrioritarioLineaList} PrioritarioLineaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioLineaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrioritarioLineaList message.
         * @function verify
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrioritarioLineaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lineas != null && message.hasOwnProperty("lineas")) {
                if (!Array.isArray(message.lineas))
                    return "lineas: array expected";
                for (let i = 0; i < message.lineas.length; ++i) {
                    let error = $root.mirana.PrioritarioLinea.verify(message.lineas[i]);
                    if (error)
                        return "lineas." + error;
                }
            }
            if (message.totalLineas != null && message.hasOwnProperty("totalLineas"))
                if (!$util.isInteger(message.totalLineas))
                    return "totalLineas: integer expected";
            return null;
        };

        /**
         * Creates a PrioritarioLineaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PrioritarioLineaList} PrioritarioLineaList
         */
        PrioritarioLineaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PrioritarioLineaList)
                return object;
            let message = new $root.mirana.PrioritarioLineaList();
            if (object.lineas) {
                if (!Array.isArray(object.lineas))
                    throw TypeError(".mirana.PrioritarioLineaList.lineas: array expected");
                message.lineas = [];
                for (let i = 0; i < object.lineas.length; ++i) {
                    if (typeof object.lineas[i] !== "object")
                        throw TypeError(".mirana.PrioritarioLineaList.lineas: object expected");
                    message.lineas[i] = $root.mirana.PrioritarioLinea.fromObject(object.lineas[i]);
                }
            }
            if (object.totalLineas != null)
                message.totalLineas = object.totalLineas | 0;
            return message;
        };

        /**
         * Creates a plain object from a PrioritarioLineaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PrioritarioLineaList
         * @static
         * @param {mirana.PrioritarioLineaList} message PrioritarioLineaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrioritarioLineaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.lineas = [];
            if (options.defaults)
                object.totalLineas = 0;
            if (message.lineas && message.lineas.length) {
                object.lineas = [];
                for (let j = 0; j < message.lineas.length; ++j)
                    object.lineas[j] = $root.mirana.PrioritarioLinea.toObject(message.lineas[j], options);
            }
            if (message.totalLineas != null && message.hasOwnProperty("totalLineas"))
                object.totalLineas = message.totalLineas;
            return object;
        };

        /**
         * Converts this PrioritarioLineaList to JSON.
         * @function toJSON
         * @memberof mirana.PrioritarioLineaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrioritarioLineaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PrioritarioLineaList;
    })();

    mirana.FiltrarPrioritariosResponse = (function() {

        /**
         * Properties of a FiltrarPrioritariosResponse.
         * @memberof mirana
         * @interface IFiltrarPrioritariosResponse
         * @property {Array.<mirana.IPrioritario>|null} [prioritarios] FiltrarPrioritariosResponse prioritarios
         */

        /**
         * Constructs a new FiltrarPrioritariosResponse.
         * @memberof mirana
         * @classdesc Represents a FiltrarPrioritariosResponse.
         * @implements IFiltrarPrioritariosResponse
         * @constructor
         * @param {mirana.IFiltrarPrioritariosResponse=} [properties] Properties to set
         */
        function FiltrarPrioritariosResponse(properties) {
            this.prioritarios = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FiltrarPrioritariosResponse prioritarios.
         * @member {Array.<mirana.IPrioritario>} prioritarios
         * @memberof mirana.FiltrarPrioritariosResponse
         * @instance
         */
        FiltrarPrioritariosResponse.prototype.prioritarios = $util.emptyArray;

        /**
         * Creates a new FiltrarPrioritariosResponse instance using the specified properties.
         * @function create
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {mirana.IFiltrarPrioritariosResponse=} [properties] Properties to set
         * @returns {mirana.FiltrarPrioritariosResponse} FiltrarPrioritariosResponse instance
         */
        FiltrarPrioritariosResponse.create = function create(properties) {
            return new FiltrarPrioritariosResponse(properties);
        };

        /**
         * Encodes the specified FiltrarPrioritariosResponse message. Does not implicitly {@link mirana.FiltrarPrioritariosResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {mirana.IFiltrarPrioritariosResponse} message FiltrarPrioritariosResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarPrioritariosResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.prioritarios != null && message.prioritarios.length)
                for (let i = 0; i < message.prioritarios.length; ++i)
                    $root.mirana.Prioritario.encode(message.prioritarios[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FiltrarPrioritariosResponse message, length delimited. Does not implicitly {@link mirana.FiltrarPrioritariosResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {mirana.IFiltrarPrioritariosResponse} message FiltrarPrioritariosResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarPrioritariosResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FiltrarPrioritariosResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FiltrarPrioritariosResponse} FiltrarPrioritariosResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarPrioritariosResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FiltrarPrioritariosResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.prioritarios && message.prioritarios.length))
                        message.prioritarios = [];
                    message.prioritarios.push($root.mirana.Prioritario.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FiltrarPrioritariosResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FiltrarPrioritariosResponse} FiltrarPrioritariosResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarPrioritariosResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FiltrarPrioritariosResponse message.
         * @function verify
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FiltrarPrioritariosResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.prioritarios != null && message.hasOwnProperty("prioritarios")) {
                if (!Array.isArray(message.prioritarios))
                    return "prioritarios: array expected";
                for (let i = 0; i < message.prioritarios.length; ++i) {
                    let error = $root.mirana.Prioritario.verify(message.prioritarios[i]);
                    if (error)
                        return "prioritarios." + error;
                }
            }
            return null;
        };

        /**
         * Creates a FiltrarPrioritariosResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FiltrarPrioritariosResponse} FiltrarPrioritariosResponse
         */
        FiltrarPrioritariosResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FiltrarPrioritariosResponse)
                return object;
            let message = new $root.mirana.FiltrarPrioritariosResponse();
            if (object.prioritarios) {
                if (!Array.isArray(object.prioritarios))
                    throw TypeError(".mirana.FiltrarPrioritariosResponse.prioritarios: array expected");
                message.prioritarios = [];
                for (let i = 0; i < object.prioritarios.length; ++i) {
                    if (typeof object.prioritarios[i] !== "object")
                        throw TypeError(".mirana.FiltrarPrioritariosResponse.prioritarios: object expected");
                    message.prioritarios[i] = $root.mirana.Prioritario.fromObject(object.prioritarios[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FiltrarPrioritariosResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FiltrarPrioritariosResponse
         * @static
         * @param {mirana.FiltrarPrioritariosResponse} message FiltrarPrioritariosResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FiltrarPrioritariosResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.prioritarios = [];
            if (message.prioritarios && message.prioritarios.length) {
                object.prioritarios = [];
                for (let j = 0; j < message.prioritarios.length; ++j)
                    object.prioritarios[j] = $root.mirana.Prioritario.toObject(message.prioritarios[j], options);
            }
            return object;
        };

        /**
         * Converts this FiltrarPrioritariosResponse to JSON.
         * @function toJSON
         * @memberof mirana.FiltrarPrioritariosResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FiltrarPrioritariosResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FiltrarPrioritariosResponse;
    })();

    mirana.PrioritarioDetalle = (function() {

        /**
         * Properties of a PrioritarioDetalle.
         * @memberof mirana
         * @interface IPrioritarioDetalle
         * @property {string|null} [clienteId] PrioritarioDetalle clienteId
         * @property {string|null} [prioridad] PrioritarioDetalle prioridad
         * @property {number|null} [avance] PrioritarioDetalle avance
         * @property {number|null} [monto] PrioritarioDetalle monto
         * @property {string|null} [fechaConsulta] PrioritarioDetalle fechaConsulta
         * @property {string|null} [fuerzaVentaId] PrioritarioDetalle fuerzaVentaId
         */

        /**
         * Constructs a new PrioritarioDetalle.
         * @memberof mirana
         * @classdesc Represents a PrioritarioDetalle.
         * @implements IPrioritarioDetalle
         * @constructor
         * @param {mirana.IPrioritarioDetalle=} [properties] Properties to set
         */
        function PrioritarioDetalle(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrioritarioDetalle clienteId.
         * @member {string} clienteId
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.clienteId = "";

        /**
         * PrioritarioDetalle prioridad.
         * @member {string} prioridad
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.prioridad = "";

        /**
         * PrioritarioDetalle avance.
         * @member {number} avance
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.avance = 0;

        /**
         * PrioritarioDetalle monto.
         * @member {number} monto
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.monto = 0;

        /**
         * PrioritarioDetalle fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.fechaConsulta = "";

        /**
         * PrioritarioDetalle fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.PrioritarioDetalle
         * @instance
         */
        PrioritarioDetalle.prototype.fuerzaVentaId = "";

        /**
         * Creates a new PrioritarioDetalle instance using the specified properties.
         * @function create
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {mirana.IPrioritarioDetalle=} [properties] Properties to set
         * @returns {mirana.PrioritarioDetalle} PrioritarioDetalle instance
         */
        PrioritarioDetalle.create = function create(properties) {
            return new PrioritarioDetalle(properties);
        };

        /**
         * Encodes the specified PrioritarioDetalle message. Does not implicitly {@link mirana.PrioritarioDetalle.verify|verify} messages.
         * @function encode
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {mirana.IPrioritarioDetalle} message PrioritarioDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioDetalle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.clienteId);
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.prioridad);
            if (message.avance != null && message.hasOwnProperty("avance"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.avance);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.monto);
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fechaConsulta);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified PrioritarioDetalle message, length delimited. Does not implicitly {@link mirana.PrioritarioDetalle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {mirana.IPrioritarioDetalle} message PrioritarioDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritarioDetalle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrioritarioDetalle message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PrioritarioDetalle} PrioritarioDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioDetalle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PrioritarioDetalle();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.clienteId = reader.string();
                    break;
                case 2:
                    message.prioridad = reader.string();
                    break;
                case 3:
                    message.avance = reader.double();
                    break;
                case 4:
                    message.monto = reader.double();
                    break;
                case 5:
                    message.fechaConsulta = reader.string();
                    break;
                case 6:
                    message.fuerzaVentaId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrioritarioDetalle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PrioritarioDetalle} PrioritarioDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritarioDetalle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrioritarioDetalle message.
         * @function verify
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrioritarioDetalle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                if (!$util.isString(message.clienteId))
                    return "clienteId: string expected";
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                if (!$util.isString(message.prioridad))
                    return "prioridad: string expected";
            if (message.avance != null && message.hasOwnProperty("avance"))
                if (typeof message.avance !== "number")
                    return "avance: number expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            return null;
        };

        /**
         * Creates a PrioritarioDetalle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PrioritarioDetalle} PrioritarioDetalle
         */
        PrioritarioDetalle.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PrioritarioDetalle)
                return object;
            let message = new $root.mirana.PrioritarioDetalle();
            if (object.clienteId != null)
                message.clienteId = String(object.clienteId);
            if (object.prioridad != null)
                message.prioridad = String(object.prioridad);
            if (object.avance != null)
                message.avance = Number(object.avance);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            return message;
        };

        /**
         * Creates a plain object from a PrioritarioDetalle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PrioritarioDetalle
         * @static
         * @param {mirana.PrioritarioDetalle} message PrioritarioDetalle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrioritarioDetalle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.clienteId = "";
                object.prioridad = "";
                object.avance = 0;
                object.monto = 0;
                object.fechaConsulta = "";
                object.fuerzaVentaId = "";
            }
            if (message.clienteId != null && message.hasOwnProperty("clienteId"))
                object.clienteId = message.clienteId;
            if (message.prioridad != null && message.hasOwnProperty("prioridad"))
                object.prioridad = message.prioridad;
            if (message.avance != null && message.hasOwnProperty("avance"))
                object.avance = options.json && !isFinite(message.avance) ? String(message.avance) : message.avance;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this PrioritarioDetalle to JSON.
         * @function toJSON
         * @memberof mirana.PrioritarioDetalle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrioritarioDetalle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PrioritarioDetalle;
    })();

    mirana.PrioritariosRequest = (function() {

        /**
         * Properties of a PrioritariosRequest.
         * @memberof mirana
         * @interface IPrioritariosRequest
         * @property {string|null} [fechaConsulta] PrioritariosRequest fechaConsulta
         * @property {Array.<mirana.IPrioritario>|null} [prioritarios] PrioritariosRequest prioritarios
         * @property {string|null} [fuerzaVentaId] PrioritariosRequest fuerzaVentaId
         */

        /**
         * Constructs a new PrioritariosRequest.
         * @memberof mirana
         * @classdesc Represents a PrioritariosRequest.
         * @implements IPrioritariosRequest
         * @constructor
         * @param {mirana.IPrioritariosRequest=} [properties] Properties to set
         */
        function PrioritariosRequest(properties) {
            this.prioritarios = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrioritariosRequest fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.PrioritariosRequest
         * @instance
         */
        PrioritariosRequest.prototype.fechaConsulta = "";

        /**
         * PrioritariosRequest prioritarios.
         * @member {Array.<mirana.IPrioritario>} prioritarios
         * @memberof mirana.PrioritariosRequest
         * @instance
         */
        PrioritariosRequest.prototype.prioritarios = $util.emptyArray;

        /**
         * PrioritariosRequest fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.PrioritariosRequest
         * @instance
         */
        PrioritariosRequest.prototype.fuerzaVentaId = "";

        /**
         * Creates a new PrioritariosRequest instance using the specified properties.
         * @function create
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {mirana.IPrioritariosRequest=} [properties] Properties to set
         * @returns {mirana.PrioritariosRequest} PrioritariosRequest instance
         */
        PrioritariosRequest.create = function create(properties) {
            return new PrioritariosRequest(properties);
        };

        /**
         * Encodes the specified PrioritariosRequest message. Does not implicitly {@link mirana.PrioritariosRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {mirana.IPrioritariosRequest} message PrioritariosRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritariosRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaConsulta);
            if (message.prioritarios != null && message.prioritarios.length)
                for (let i = 0; i < message.prioritarios.length; ++i)
                    $root.mirana.Prioritario.encode(message.prioritarios[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified PrioritariosRequest message, length delimited. Does not implicitly {@link mirana.PrioritariosRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {mirana.IPrioritariosRequest} message PrioritariosRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritariosRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrioritariosRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PrioritariosRequest} PrioritariosRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritariosRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PrioritariosRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaConsulta = reader.string();
                    break;
                case 2:
                    if (!(message.prioritarios && message.prioritarios.length))
                        message.prioritarios = [];
                    message.prioritarios.push($root.mirana.Prioritario.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.fuerzaVentaId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrioritariosRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PrioritariosRequest} PrioritariosRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritariosRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrioritariosRequest message.
         * @function verify
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrioritariosRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            if (message.prioritarios != null && message.hasOwnProperty("prioritarios")) {
                if (!Array.isArray(message.prioritarios))
                    return "prioritarios: array expected";
                for (let i = 0; i < message.prioritarios.length; ++i) {
                    let error = $root.mirana.Prioritario.verify(message.prioritarios[i]);
                    if (error)
                        return "prioritarios." + error;
                }
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            return null;
        };

        /**
         * Creates a PrioritariosRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PrioritariosRequest} PrioritariosRequest
         */
        PrioritariosRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PrioritariosRequest)
                return object;
            let message = new $root.mirana.PrioritariosRequest();
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            if (object.prioritarios) {
                if (!Array.isArray(object.prioritarios))
                    throw TypeError(".mirana.PrioritariosRequest.prioritarios: array expected");
                message.prioritarios = [];
                for (let i = 0; i < object.prioritarios.length; ++i) {
                    if (typeof object.prioritarios[i] !== "object")
                        throw TypeError(".mirana.PrioritariosRequest.prioritarios: object expected");
                    message.prioritarios[i] = $root.mirana.Prioritario.fromObject(object.prioritarios[i]);
                }
            }
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            return message;
        };

        /**
         * Creates a plain object from a PrioritariosRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PrioritariosRequest
         * @static
         * @param {mirana.PrioritariosRequest} message PrioritariosRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrioritariosRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.prioritarios = [];
            if (options.defaults) {
                object.fechaConsulta = "";
                object.fuerzaVentaId = "";
            }
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.prioritarios && message.prioritarios.length) {
                object.prioritarios = [];
                for (let j = 0; j < message.prioritarios.length; ++j)
                    object.prioritarios[j] = $root.mirana.Prioritario.toObject(message.prioritarios[j], options);
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this PrioritariosRequest to JSON.
         * @function toJSON
         * @memberof mirana.PrioritariosRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrioritariosRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PrioritariosRequest;
    })();

    mirana.CarteraDetalle = (function() {

        /**
         * Properties of a CarteraDetalle.
         * @memberof mirana
         * @interface ICarteraDetalle
         * @property {number|null} [carteraTotal] CarteraDetalle carteraTotal
         * @property {number|null} [noAtendidos] CarteraDetalle noAtendidos
         * @property {string|null} [fechaConsulta] CarteraDetalle fechaConsulta
         */

        /**
         * Constructs a new CarteraDetalle.
         * @memberof mirana
         * @classdesc Represents a CarteraDetalle.
         * @implements ICarteraDetalle
         * @constructor
         * @param {mirana.ICarteraDetalle=} [properties] Properties to set
         */
        function CarteraDetalle(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CarteraDetalle carteraTotal.
         * @member {number} carteraTotal
         * @memberof mirana.CarteraDetalle
         * @instance
         */
        CarteraDetalle.prototype.carteraTotal = 0;

        /**
         * CarteraDetalle noAtendidos.
         * @member {number} noAtendidos
         * @memberof mirana.CarteraDetalle
         * @instance
         */
        CarteraDetalle.prototype.noAtendidos = 0;

        /**
         * CarteraDetalle fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.CarteraDetalle
         * @instance
         */
        CarteraDetalle.prototype.fechaConsulta = "";

        /**
         * Creates a new CarteraDetalle instance using the specified properties.
         * @function create
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {mirana.ICarteraDetalle=} [properties] Properties to set
         * @returns {mirana.CarteraDetalle} CarteraDetalle instance
         */
        CarteraDetalle.create = function create(properties) {
            return new CarteraDetalle(properties);
        };

        /**
         * Encodes the specified CarteraDetalle message. Does not implicitly {@link mirana.CarteraDetalle.verify|verify} messages.
         * @function encode
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {mirana.ICarteraDetalle} message CarteraDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarteraDetalle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.carteraTotal);
            if (message.noAtendidos != null && message.hasOwnProperty("noAtendidos"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.noAtendidos);
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fechaConsulta);
            return writer;
        };

        /**
         * Encodes the specified CarteraDetalle message, length delimited. Does not implicitly {@link mirana.CarteraDetalle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {mirana.ICarteraDetalle} message CarteraDetalle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarteraDetalle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CarteraDetalle message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CarteraDetalle} CarteraDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarteraDetalle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CarteraDetalle();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.carteraTotal = reader.int32();
                    break;
                case 2:
                    message.noAtendidos = reader.int32();
                    break;
                case 3:
                    message.fechaConsulta = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CarteraDetalle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CarteraDetalle} CarteraDetalle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarteraDetalle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CarteraDetalle message.
         * @function verify
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CarteraDetalle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                if (!$util.isInteger(message.carteraTotal))
                    return "carteraTotal: integer expected";
            if (message.noAtendidos != null && message.hasOwnProperty("noAtendidos"))
                if (!$util.isInteger(message.noAtendidos))
                    return "noAtendidos: integer expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            return null;
        };

        /**
         * Creates a CarteraDetalle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CarteraDetalle} CarteraDetalle
         */
        CarteraDetalle.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CarteraDetalle)
                return object;
            let message = new $root.mirana.CarteraDetalle();
            if (object.carteraTotal != null)
                message.carteraTotal = object.carteraTotal | 0;
            if (object.noAtendidos != null)
                message.noAtendidos = object.noAtendidos | 0;
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            return message;
        };

        /**
         * Creates a plain object from a CarteraDetalle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CarteraDetalle
         * @static
         * @param {mirana.CarteraDetalle} message CarteraDetalle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CarteraDetalle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.carteraTotal = 0;
                object.noAtendidos = 0;
                object.fechaConsulta = "";
            }
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                object.carteraTotal = message.carteraTotal;
            if (message.noAtendidos != null && message.hasOwnProperty("noAtendidos"))
                object.noAtendidos = message.noAtendidos;
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            return object;
        };

        /**
         * Converts this CarteraDetalle to JSON.
         * @function toJSON
         * @memberof mirana.CarteraDetalle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CarteraDetalle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CarteraDetalle;
    })();

    mirana.PrioritariosDetalleRequest = (function() {

        /**
         * Properties of a PrioritariosDetalleRequest.
         * @memberof mirana
         * @interface IPrioritariosDetalleRequest
         * @property {string|null} [fechaConsulta] PrioritariosDetalleRequest fechaConsulta
         * @property {Array.<mirana.IPrioritarioDetalle>|null} [prioritarioDetalles] PrioritariosDetalleRequest prioritarioDetalles
         * @property {string|null} [fuerzaVentaId] PrioritariosDetalleRequest fuerzaVentaId
         */

        /**
         * Constructs a new PrioritariosDetalleRequest.
         * @memberof mirana
         * @classdesc Represents a PrioritariosDetalleRequest.
         * @implements IPrioritariosDetalleRequest
         * @constructor
         * @param {mirana.IPrioritariosDetalleRequest=} [properties] Properties to set
         */
        function PrioritariosDetalleRequest(properties) {
            this.prioritarioDetalles = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrioritariosDetalleRequest fechaConsulta.
         * @member {string} fechaConsulta
         * @memberof mirana.PrioritariosDetalleRequest
         * @instance
         */
        PrioritariosDetalleRequest.prototype.fechaConsulta = "";

        /**
         * PrioritariosDetalleRequest prioritarioDetalles.
         * @member {Array.<mirana.IPrioritarioDetalle>} prioritarioDetalles
         * @memberof mirana.PrioritariosDetalleRequest
         * @instance
         */
        PrioritariosDetalleRequest.prototype.prioritarioDetalles = $util.emptyArray;

        /**
         * PrioritariosDetalleRequest fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.PrioritariosDetalleRequest
         * @instance
         */
        PrioritariosDetalleRequest.prototype.fuerzaVentaId = "";

        /**
         * Creates a new PrioritariosDetalleRequest instance using the specified properties.
         * @function create
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {mirana.IPrioritariosDetalleRequest=} [properties] Properties to set
         * @returns {mirana.PrioritariosDetalleRequest} PrioritariosDetalleRequest instance
         */
        PrioritariosDetalleRequest.create = function create(properties) {
            return new PrioritariosDetalleRequest(properties);
        };

        /**
         * Encodes the specified PrioritariosDetalleRequest message. Does not implicitly {@link mirana.PrioritariosDetalleRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {mirana.IPrioritariosDetalleRequest} message PrioritariosDetalleRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritariosDetalleRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaConsulta);
            if (message.prioritarioDetalles != null && message.prioritarioDetalles.length)
                for (let i = 0; i < message.prioritarioDetalles.length; ++i)
                    $root.mirana.PrioritarioDetalle.encode(message.prioritarioDetalles[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fuerzaVentaId);
            return writer;
        };

        /**
         * Encodes the specified PrioritariosDetalleRequest message, length delimited. Does not implicitly {@link mirana.PrioritariosDetalleRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {mirana.IPrioritariosDetalleRequest} message PrioritariosDetalleRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrioritariosDetalleRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrioritariosDetalleRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PrioritariosDetalleRequest} PrioritariosDetalleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritariosDetalleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PrioritariosDetalleRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaConsulta = reader.string();
                    break;
                case 2:
                    if (!(message.prioritarioDetalles && message.prioritarioDetalles.length))
                        message.prioritarioDetalles = [];
                    message.prioritarioDetalles.push($root.mirana.PrioritarioDetalle.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.fuerzaVentaId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrioritariosDetalleRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PrioritariosDetalleRequest} PrioritariosDetalleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrioritariosDetalleRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrioritariosDetalleRequest message.
         * @function verify
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrioritariosDetalleRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                if (!$util.isString(message.fechaConsulta))
                    return "fechaConsulta: string expected";
            if (message.prioritarioDetalles != null && message.hasOwnProperty("prioritarioDetalles")) {
                if (!Array.isArray(message.prioritarioDetalles))
                    return "prioritarioDetalles: array expected";
                for (let i = 0; i < message.prioritarioDetalles.length; ++i) {
                    let error = $root.mirana.PrioritarioDetalle.verify(message.prioritarioDetalles[i]);
                    if (error)
                        return "prioritarioDetalles." + error;
                }
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            return null;
        };

        /**
         * Creates a PrioritariosDetalleRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PrioritariosDetalleRequest} PrioritariosDetalleRequest
         */
        PrioritariosDetalleRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PrioritariosDetalleRequest)
                return object;
            let message = new $root.mirana.PrioritariosDetalleRequest();
            if (object.fechaConsulta != null)
                message.fechaConsulta = String(object.fechaConsulta);
            if (object.prioritarioDetalles) {
                if (!Array.isArray(object.prioritarioDetalles))
                    throw TypeError(".mirana.PrioritariosDetalleRequest.prioritarioDetalles: array expected");
                message.prioritarioDetalles = [];
                for (let i = 0; i < object.prioritarioDetalles.length; ++i) {
                    if (typeof object.prioritarioDetalles[i] !== "object")
                        throw TypeError(".mirana.PrioritariosDetalleRequest.prioritarioDetalles: object expected");
                    message.prioritarioDetalles[i] = $root.mirana.PrioritarioDetalle.fromObject(object.prioritarioDetalles[i]);
                }
            }
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            return message;
        };

        /**
         * Creates a plain object from a PrioritariosDetalleRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PrioritariosDetalleRequest
         * @static
         * @param {mirana.PrioritariosDetalleRequest} message PrioritariosDetalleRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrioritariosDetalleRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.prioritarioDetalles = [];
            if (options.defaults) {
                object.fechaConsulta = "";
                object.fuerzaVentaId = "";
            }
            if (message.fechaConsulta != null && message.hasOwnProperty("fechaConsulta"))
                object.fechaConsulta = message.fechaConsulta;
            if (message.prioritarioDetalles && message.prioritarioDetalles.length) {
                object.prioritarioDetalles = [];
                for (let j = 0; j < message.prioritarioDetalles.length; ++j)
                    object.prioritarioDetalles[j] = $root.mirana.PrioritarioDetalle.toObject(message.prioritarioDetalles[j], options);
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            return object;
        };

        /**
         * Converts this PrioritariosDetalleRequest to JSON.
         * @function toJSON
         * @memberof mirana.PrioritariosDetalleRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrioritariosDetalleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PrioritariosDetalleRequest;
    })();

    mirana.PrioritarioService = (function() {

        /**
         * Constructs a new PrioritarioService service.
         * @memberof mirana
         * @classdesc Represents a PrioritarioService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PrioritarioService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PrioritarioService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PrioritarioService;

        /**
         * Creates new PrioritarioService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.PrioritarioService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PrioritarioService} RPC service. Useful where requests and/or responses are streamed.
         */
        PrioritarioService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.PrioritarioService#syncCabecera}.
         * @memberof mirana.PrioritarioService
         * @typedef syncCabeceraCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncCabecera.
         * @function syncCabecera
         * @memberof mirana.PrioritarioService
         * @instance
         * @param {mirana.IPrioritariosRequest} request PrioritariosRequest message or plain object
         * @param {mirana.PrioritarioService.syncCabeceraCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        PrioritarioService.prototype.syncCabecera = function syncCabecera(request, callback) {
            return this.rpcCall(syncCabecera, $root.mirana.PrioritariosRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncCabecera.
         * @function syncCabecera
         * @memberof mirana.PrioritarioService
         * @instance
         * @param {mirana.IPrioritariosRequest} request PrioritariosRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.PrioritarioService#syncDetalle}.
         * @memberof mirana.PrioritarioService
         * @typedef syncDetalleCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncDetalle.
         * @function syncDetalle
         * @memberof mirana.PrioritarioService
         * @instance
         * @param {mirana.IPrioritariosDetalleRequest} request PrioritariosDetalleRequest message or plain object
         * @param {mirana.PrioritarioService.syncDetalleCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        PrioritarioService.prototype.syncDetalle = function syncDetalle(request, callback) {
            return this.rpcCall(syncDetalle, $root.mirana.PrioritariosDetalleRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncDetalle.
         * @function syncDetalle
         * @memberof mirana.PrioritarioService
         * @instance
         * @param {mirana.IPrioritariosDetalleRequest} request PrioritariosDetalleRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return PrioritarioService;
    })();

    mirana.UICabeceraNuevoTdos = (function() {

        /**
         * Properties of a UICabeceraNuevoTdos.
         * @memberof mirana
         * @interface IUICabeceraNuevoTdos
         * @property {number|null} [carteraTotal] UICabeceraNuevoTdos carteraTotal
         * @property {number|null} [diasTranscurridos] UICabeceraNuevoTdos diasTranscurridos
         * @property {number|null} [diasHabiles] UICabeceraNuevoTdos diasHabiles
         * @property {string|null} [mesLiteral] UICabeceraNuevoTdos mesLiteral
         */

        /**
         * Constructs a new UICabeceraNuevoTdos.
         * @memberof mirana
         * @classdesc Represents a UICabeceraNuevoTdos.
         * @implements IUICabeceraNuevoTdos
         * @constructor
         * @param {mirana.IUICabeceraNuevoTdos=} [properties] Properties to set
         */
        function UICabeceraNuevoTdos(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UICabeceraNuevoTdos carteraTotal.
         * @member {number} carteraTotal
         * @memberof mirana.UICabeceraNuevoTdos
         * @instance
         */
        UICabeceraNuevoTdos.prototype.carteraTotal = 0;

        /**
         * UICabeceraNuevoTdos diasTranscurridos.
         * @member {number} diasTranscurridos
         * @memberof mirana.UICabeceraNuevoTdos
         * @instance
         */
        UICabeceraNuevoTdos.prototype.diasTranscurridos = 0;

        /**
         * UICabeceraNuevoTdos diasHabiles.
         * @member {number} diasHabiles
         * @memberof mirana.UICabeceraNuevoTdos
         * @instance
         */
        UICabeceraNuevoTdos.prototype.diasHabiles = 0;

        /**
         * UICabeceraNuevoTdos mesLiteral.
         * @member {string} mesLiteral
         * @memberof mirana.UICabeceraNuevoTdos
         * @instance
         */
        UICabeceraNuevoTdos.prototype.mesLiteral = "";

        /**
         * Creates a new UICabeceraNuevoTdos instance using the specified properties.
         * @function create
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {mirana.IUICabeceraNuevoTdos=} [properties] Properties to set
         * @returns {mirana.UICabeceraNuevoTdos} UICabeceraNuevoTdos instance
         */
        UICabeceraNuevoTdos.create = function create(properties) {
            return new UICabeceraNuevoTdos(properties);
        };

        /**
         * Encodes the specified UICabeceraNuevoTdos message. Does not implicitly {@link mirana.UICabeceraNuevoTdos.verify|verify} messages.
         * @function encode
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {mirana.IUICabeceraNuevoTdos} message UICabeceraNuevoTdos message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UICabeceraNuevoTdos.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.carteraTotal);
            if (message.diasTranscurridos != null && message.hasOwnProperty("diasTranscurridos"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.diasTranscurridos);
            if (message.diasHabiles != null && message.hasOwnProperty("diasHabiles"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.diasHabiles);
            if (message.mesLiteral != null && message.hasOwnProperty("mesLiteral"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mesLiteral);
            return writer;
        };

        /**
         * Encodes the specified UICabeceraNuevoTdos message, length delimited. Does not implicitly {@link mirana.UICabeceraNuevoTdos.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {mirana.IUICabeceraNuevoTdos} message UICabeceraNuevoTdos message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UICabeceraNuevoTdos.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UICabeceraNuevoTdos message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UICabeceraNuevoTdos} UICabeceraNuevoTdos
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UICabeceraNuevoTdos.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UICabeceraNuevoTdos();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.carteraTotal = reader.int32();
                    break;
                case 2:
                    message.diasTranscurridos = reader.int32();
                    break;
                case 3:
                    message.diasHabiles = reader.int32();
                    break;
                case 4:
                    message.mesLiteral = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UICabeceraNuevoTdos message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UICabeceraNuevoTdos} UICabeceraNuevoTdos
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UICabeceraNuevoTdos.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UICabeceraNuevoTdos message.
         * @function verify
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UICabeceraNuevoTdos.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                if (!$util.isInteger(message.carteraTotal))
                    return "carteraTotal: integer expected";
            if (message.diasTranscurridos != null && message.hasOwnProperty("diasTranscurridos"))
                if (!$util.isInteger(message.diasTranscurridos))
                    return "diasTranscurridos: integer expected";
            if (message.diasHabiles != null && message.hasOwnProperty("diasHabiles"))
                if (!$util.isInteger(message.diasHabiles))
                    return "diasHabiles: integer expected";
            if (message.mesLiteral != null && message.hasOwnProperty("mesLiteral"))
                if (!$util.isString(message.mesLiteral))
                    return "mesLiteral: string expected";
            return null;
        };

        /**
         * Creates a UICabeceraNuevoTdos message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UICabeceraNuevoTdos} UICabeceraNuevoTdos
         */
        UICabeceraNuevoTdos.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UICabeceraNuevoTdos)
                return object;
            let message = new $root.mirana.UICabeceraNuevoTdos();
            if (object.carteraTotal != null)
                message.carteraTotal = object.carteraTotal | 0;
            if (object.diasTranscurridos != null)
                message.diasTranscurridos = object.diasTranscurridos | 0;
            if (object.diasHabiles != null)
                message.diasHabiles = object.diasHabiles | 0;
            if (object.mesLiteral != null)
                message.mesLiteral = String(object.mesLiteral);
            return message;
        };

        /**
         * Creates a plain object from a UICabeceraNuevoTdos message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UICabeceraNuevoTdos
         * @static
         * @param {mirana.UICabeceraNuevoTdos} message UICabeceraNuevoTdos
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UICabeceraNuevoTdos.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.carteraTotal = 0;
                object.diasTranscurridos = 0;
                object.diasHabiles = 0;
                object.mesLiteral = "";
            }
            if (message.carteraTotal != null && message.hasOwnProperty("carteraTotal"))
                object.carteraTotal = message.carteraTotal;
            if (message.diasTranscurridos != null && message.hasOwnProperty("diasTranscurridos"))
                object.diasTranscurridos = message.diasTranscurridos;
            if (message.diasHabiles != null && message.hasOwnProperty("diasHabiles"))
                object.diasHabiles = message.diasHabiles;
            if (message.mesLiteral != null && message.hasOwnProperty("mesLiteral"))
                object.mesLiteral = message.mesLiteral;
            return object;
        };

        /**
         * Converts this UICabeceraNuevoTdos to JSON.
         * @function toJSON
         * @memberof mirana.UICabeceraNuevoTdos
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UICabeceraNuevoTdos.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UICabeceraNuevoTdos;
    })();

    mirana.NuevaCoberturaAcumulada = (function() {

        /**
         * Properties of a NuevaCoberturaAcumulada.
         * @memberof mirana
         * @interface INuevaCoberturaAcumulada
         * @property {string|null} [marca] NuevaCoberturaAcumulada marca
         * @property {string|null} [categoria] NuevaCoberturaAcumulada categoria
         * @property {number|null} [cobertura] NuevaCoberturaAcumulada cobertura
         * @property {string|null} [fechaCarga] NuevaCoberturaAcumulada fechaCarga
         * @property {Array.<mirana.NuevaCoberturaAcumulada.IResultado>|null} [resultados] NuevaCoberturaAcumulada resultados
         */

        /**
         * Constructs a new NuevaCoberturaAcumulada.
         * @memberof mirana
         * @classdesc Represents a NuevaCoberturaAcumulada.
         * @implements INuevaCoberturaAcumulada
         * @constructor
         * @param {mirana.INuevaCoberturaAcumulada=} [properties] Properties to set
         */
        function NuevaCoberturaAcumulada(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevaCoberturaAcumulada marca.
         * @member {string} marca
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         */
        NuevaCoberturaAcumulada.prototype.marca = "";

        /**
         * NuevaCoberturaAcumulada categoria.
         * @member {string} categoria
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         */
        NuevaCoberturaAcumulada.prototype.categoria = "";

        /**
         * NuevaCoberturaAcumulada cobertura.
         * @member {number} cobertura
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         */
        NuevaCoberturaAcumulada.prototype.cobertura = 0;

        /**
         * NuevaCoberturaAcumulada fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         */
        NuevaCoberturaAcumulada.prototype.fechaCarga = "";

        /**
         * NuevaCoberturaAcumulada resultados.
         * @member {Array.<mirana.NuevaCoberturaAcumulada.IResultado>} resultados
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         */
        NuevaCoberturaAcumulada.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new NuevaCoberturaAcumulada instance using the specified properties.
         * @function create
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {mirana.INuevaCoberturaAcumulada=} [properties] Properties to set
         * @returns {mirana.NuevaCoberturaAcumulada} NuevaCoberturaAcumulada instance
         */
        NuevaCoberturaAcumulada.create = function create(properties) {
            return new NuevaCoberturaAcumulada(properties);
        };

        /**
         * Encodes the specified NuevaCoberturaAcumulada message. Does not implicitly {@link mirana.NuevaCoberturaAcumulada.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {mirana.INuevaCoberturaAcumulada} message NuevaCoberturaAcumulada message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaAcumulada.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.marca != null && message.hasOwnProperty("marca"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.marca);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoria);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.cobertura);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fechaCarga);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.mirana.NuevaCoberturaAcumulada.Resultado.encode(message.resultados[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevaCoberturaAcumulada message, length delimited. Does not implicitly {@link mirana.NuevaCoberturaAcumulada.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {mirana.INuevaCoberturaAcumulada} message NuevaCoberturaAcumulada message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaAcumulada.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevaCoberturaAcumulada message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevaCoberturaAcumulada} NuevaCoberturaAcumulada
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaAcumulada.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevaCoberturaAcumulada();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.marca = reader.string();
                    break;
                case 2:
                    message.categoria = reader.string();
                    break;
                case 3:
                    message.cobertura = reader.double();
                    break;
                case 4:
                    message.fechaCarga = reader.string();
                    break;
                case 5:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.mirana.NuevaCoberturaAcumulada.Resultado.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevaCoberturaAcumulada message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevaCoberturaAcumulada} NuevaCoberturaAcumulada
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaAcumulada.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevaCoberturaAcumulada message.
         * @function verify
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevaCoberturaAcumulada.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.marca != null && message.hasOwnProperty("marca"))
                if (!$util.isString(message.marca))
                    return "marca: string expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.mirana.NuevaCoberturaAcumulada.Resultado.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevaCoberturaAcumulada message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevaCoberturaAcumulada} NuevaCoberturaAcumulada
         */
        NuevaCoberturaAcumulada.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevaCoberturaAcumulada)
                return object;
            let message = new $root.mirana.NuevaCoberturaAcumulada();
            if (object.marca != null)
                message.marca = String(object.marca);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.NuevaCoberturaAcumulada.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.NuevaCoberturaAcumulada.resultados: object expected");
                    message.resultados[i] = $root.mirana.NuevaCoberturaAcumulada.Resultado.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevaCoberturaAcumulada message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevaCoberturaAcumulada
         * @static
         * @param {mirana.NuevaCoberturaAcumulada} message NuevaCoberturaAcumulada
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevaCoberturaAcumulada.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.marca = "";
                object.categoria = "";
                object.cobertura = 0;
                object.fechaCarga = "";
            }
            if (message.marca != null && message.hasOwnProperty("marca"))
                object.marca = message.marca;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.mirana.NuevaCoberturaAcumulada.Resultado.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevaCoberturaAcumulada to JSON.
         * @function toJSON
         * @memberof mirana.NuevaCoberturaAcumulada
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevaCoberturaAcumulada.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NuevaCoberturaAcumulada.Resultado = (function() {

            /**
             * Properties of a Resultado.
             * @memberof mirana.NuevaCoberturaAcumulada
             * @interface IResultado
             * @property {string|null} [dia] Resultado dia
             * @property {string|null} [diaLiteral] Resultado diaLiteral
             * @property {number|null} [cobertura] Resultado cobertura
             */

            /**
             * Constructs a new Resultado.
             * @memberof mirana.NuevaCoberturaAcumulada
             * @classdesc Represents a Resultado.
             * @implements IResultado
             * @constructor
             * @param {mirana.NuevaCoberturaAcumulada.IResultado=} [properties] Properties to set
             */
            function Resultado(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Resultado dia.
             * @member {string} dia
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @instance
             */
            Resultado.prototype.dia = "";

            /**
             * Resultado diaLiteral.
             * @member {string} diaLiteral
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @instance
             */
            Resultado.prototype.diaLiteral = "";

            /**
             * Resultado cobertura.
             * @member {number} cobertura
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @instance
             */
            Resultado.prototype.cobertura = 0;

            /**
             * Creates a new Resultado instance using the specified properties.
             * @function create
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {mirana.NuevaCoberturaAcumulada.IResultado=} [properties] Properties to set
             * @returns {mirana.NuevaCoberturaAcumulada.Resultado} Resultado instance
             */
            Resultado.create = function create(properties) {
                return new Resultado(properties);
            };

            /**
             * Encodes the specified Resultado message. Does not implicitly {@link mirana.NuevaCoberturaAcumulada.Resultado.verify|verify} messages.
             * @function encode
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {mirana.NuevaCoberturaAcumulada.IResultado} message Resultado message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resultado.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dia != null && message.hasOwnProperty("dia"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dia);
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.diaLiteral);
                if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.cobertura);
                return writer;
            };

            /**
             * Encodes the specified Resultado message, length delimited. Does not implicitly {@link mirana.NuevaCoberturaAcumulada.Resultado.verify|verify} messages.
             * @function encodeDelimited
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {mirana.NuevaCoberturaAcumulada.IResultado} message Resultado message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resultado.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Resultado message from the specified reader or buffer.
             * @function decode
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {mirana.NuevaCoberturaAcumulada.Resultado} Resultado
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resultado.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevaCoberturaAcumulada.Resultado();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dia = reader.string();
                        break;
                    case 2:
                        message.diaLiteral = reader.string();
                        break;
                    case 3:
                        message.cobertura = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Resultado message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {mirana.NuevaCoberturaAcumulada.Resultado} Resultado
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resultado.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Resultado message.
             * @function verify
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Resultado.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dia != null && message.hasOwnProperty("dia"))
                    if (!$util.isString(message.dia))
                        return "dia: string expected";
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    if (!$util.isString(message.diaLiteral))
                        return "diaLiteral: string expected";
                if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                    if (typeof message.cobertura !== "number")
                        return "cobertura: number expected";
                return null;
            };

            /**
             * Creates a Resultado message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {mirana.NuevaCoberturaAcumulada.Resultado} Resultado
             */
            Resultado.fromObject = function fromObject(object) {
                if (object instanceof $root.mirana.NuevaCoberturaAcumulada.Resultado)
                    return object;
                let message = new $root.mirana.NuevaCoberturaAcumulada.Resultado();
                if (object.dia != null)
                    message.dia = String(object.dia);
                if (object.diaLiteral != null)
                    message.diaLiteral = String(object.diaLiteral);
                if (object.cobertura != null)
                    message.cobertura = Number(object.cobertura);
                return message;
            };

            /**
             * Creates a plain object from a Resultado message. Also converts values to other types if specified.
             * @function toObject
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @static
             * @param {mirana.NuevaCoberturaAcumulada.Resultado} message Resultado
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Resultado.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.dia = "";
                    object.diaLiteral = "";
                    object.cobertura = 0;
                }
                if (message.dia != null && message.hasOwnProperty("dia"))
                    object.dia = message.dia;
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    object.diaLiteral = message.diaLiteral;
                if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                    object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
                return object;
            };

            /**
             * Converts this Resultado to JSON.
             * @function toJSON
             * @memberof mirana.NuevaCoberturaAcumulada.Resultado
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Resultado.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Resultado;
        })();

        return NuevaCoberturaAcumulada;
    })();

    mirana.NuevoVolumen = (function() {

        /**
         * Properties of a NuevoVolumen.
         * @memberof mirana
         * @interface INuevoVolumen
         * @property {string|null} [marca] NuevoVolumen marca
         * @property {string|null} [categoria] NuevoVolumen categoria
         * @property {number|null} [volumen] NuevoVolumen volumen
         * @property {string|null} [fechaCarga] NuevoVolumen fechaCarga
         * @property {Array.<mirana.NuevoVolumen.IResultado>|null} [resultados] NuevoVolumen resultados
         */

        /**
         * Constructs a new NuevoVolumen.
         * @memberof mirana
         * @classdesc Represents a NuevoVolumen.
         * @implements INuevoVolumen
         * @constructor
         * @param {mirana.INuevoVolumen=} [properties] Properties to set
         */
        function NuevoVolumen(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevoVolumen marca.
         * @member {string} marca
         * @memberof mirana.NuevoVolumen
         * @instance
         */
        NuevoVolumen.prototype.marca = "";

        /**
         * NuevoVolumen categoria.
         * @member {string} categoria
         * @memberof mirana.NuevoVolumen
         * @instance
         */
        NuevoVolumen.prototype.categoria = "";

        /**
         * NuevoVolumen volumen.
         * @member {number} volumen
         * @memberof mirana.NuevoVolumen
         * @instance
         */
        NuevoVolumen.prototype.volumen = 0;

        /**
         * NuevoVolumen fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.NuevoVolumen
         * @instance
         */
        NuevoVolumen.prototype.fechaCarga = "";

        /**
         * NuevoVolumen resultados.
         * @member {Array.<mirana.NuevoVolumen.IResultado>} resultados
         * @memberof mirana.NuevoVolumen
         * @instance
         */
        NuevoVolumen.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new NuevoVolumen instance using the specified properties.
         * @function create
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {mirana.INuevoVolumen=} [properties] Properties to set
         * @returns {mirana.NuevoVolumen} NuevoVolumen instance
         */
        NuevoVolumen.create = function create(properties) {
            return new NuevoVolumen(properties);
        };

        /**
         * Encodes the specified NuevoVolumen message. Does not implicitly {@link mirana.NuevoVolumen.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {mirana.INuevoVolumen} message NuevoVolumen message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumen.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.marca != null && message.hasOwnProperty("marca"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.marca);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoria);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.volumen);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fechaCarga);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.mirana.NuevoVolumen.Resultado.encode(message.resultados[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevoVolumen message, length delimited. Does not implicitly {@link mirana.NuevoVolumen.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {mirana.INuevoVolumen} message NuevoVolumen message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumen.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevoVolumen message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevoVolumen} NuevoVolumen
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumen.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevoVolumen();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.marca = reader.string();
                    break;
                case 2:
                    message.categoria = reader.string();
                    break;
                case 3:
                    message.volumen = reader.double();
                    break;
                case 4:
                    message.fechaCarga = reader.string();
                    break;
                case 5:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.mirana.NuevoVolumen.Resultado.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevoVolumen message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevoVolumen} NuevoVolumen
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumen.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevoVolumen message.
         * @function verify
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevoVolumen.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.marca != null && message.hasOwnProperty("marca"))
                if (!$util.isString(message.marca))
                    return "marca: string expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.mirana.NuevoVolumen.Resultado.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevoVolumen message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevoVolumen} NuevoVolumen
         */
        NuevoVolumen.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevoVolumen)
                return object;
            let message = new $root.mirana.NuevoVolumen();
            if (object.marca != null)
                message.marca = String(object.marca);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.NuevoVolumen.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.NuevoVolumen.resultados: object expected");
                    message.resultados[i] = $root.mirana.NuevoVolumen.Resultado.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevoVolumen message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevoVolumen
         * @static
         * @param {mirana.NuevoVolumen} message NuevoVolumen
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevoVolumen.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.marca = "";
                object.categoria = "";
                object.volumen = 0;
                object.fechaCarga = "";
            }
            if (message.marca != null && message.hasOwnProperty("marca"))
                object.marca = message.marca;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.mirana.NuevoVolumen.Resultado.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevoVolumen to JSON.
         * @function toJSON
         * @memberof mirana.NuevoVolumen
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevoVolumen.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NuevoVolumen.Resultado = (function() {

            /**
             * Properties of a Resultado.
             * @memberof mirana.NuevoVolumen
             * @interface IResultado
             * @property {string|null} [dia] Resultado dia
             * @property {string|null} [diaLiteral] Resultado diaLiteral
             * @property {number|null} [volumen] Resultado volumen
             */

            /**
             * Constructs a new Resultado.
             * @memberof mirana.NuevoVolumen
             * @classdesc Represents a Resultado.
             * @implements IResultado
             * @constructor
             * @param {mirana.NuevoVolumen.IResultado=} [properties] Properties to set
             */
            function Resultado(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Resultado dia.
             * @member {string} dia
             * @memberof mirana.NuevoVolumen.Resultado
             * @instance
             */
            Resultado.prototype.dia = "";

            /**
             * Resultado diaLiteral.
             * @member {string} diaLiteral
             * @memberof mirana.NuevoVolumen.Resultado
             * @instance
             */
            Resultado.prototype.diaLiteral = "";

            /**
             * Resultado volumen.
             * @member {number} volumen
             * @memberof mirana.NuevoVolumen.Resultado
             * @instance
             */
            Resultado.prototype.volumen = 0;

            /**
             * Creates a new Resultado instance using the specified properties.
             * @function create
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {mirana.NuevoVolumen.IResultado=} [properties] Properties to set
             * @returns {mirana.NuevoVolumen.Resultado} Resultado instance
             */
            Resultado.create = function create(properties) {
                return new Resultado(properties);
            };

            /**
             * Encodes the specified Resultado message. Does not implicitly {@link mirana.NuevoVolumen.Resultado.verify|verify} messages.
             * @function encode
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {mirana.NuevoVolumen.IResultado} message Resultado message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resultado.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dia != null && message.hasOwnProperty("dia"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dia);
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.diaLiteral);
                if (message.volumen != null && message.hasOwnProperty("volumen"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.volumen);
                return writer;
            };

            /**
             * Encodes the specified Resultado message, length delimited. Does not implicitly {@link mirana.NuevoVolumen.Resultado.verify|verify} messages.
             * @function encodeDelimited
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {mirana.NuevoVolumen.IResultado} message Resultado message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resultado.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Resultado message from the specified reader or buffer.
             * @function decode
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {mirana.NuevoVolumen.Resultado} Resultado
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resultado.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevoVolumen.Resultado();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dia = reader.string();
                        break;
                    case 2:
                        message.diaLiteral = reader.string();
                        break;
                    case 3:
                        message.volumen = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Resultado message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {mirana.NuevoVolumen.Resultado} Resultado
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resultado.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Resultado message.
             * @function verify
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Resultado.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dia != null && message.hasOwnProperty("dia"))
                    if (!$util.isString(message.dia))
                        return "dia: string expected";
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    if (!$util.isString(message.diaLiteral))
                        return "diaLiteral: string expected";
                if (message.volumen != null && message.hasOwnProperty("volumen"))
                    if (typeof message.volumen !== "number")
                        return "volumen: number expected";
                return null;
            };

            /**
             * Creates a Resultado message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {mirana.NuevoVolumen.Resultado} Resultado
             */
            Resultado.fromObject = function fromObject(object) {
                if (object instanceof $root.mirana.NuevoVolumen.Resultado)
                    return object;
                let message = new $root.mirana.NuevoVolumen.Resultado();
                if (object.dia != null)
                    message.dia = String(object.dia);
                if (object.diaLiteral != null)
                    message.diaLiteral = String(object.diaLiteral);
                if (object.volumen != null)
                    message.volumen = Number(object.volumen);
                return message;
            };

            /**
             * Creates a plain object from a Resultado message. Also converts values to other types if specified.
             * @function toObject
             * @memberof mirana.NuevoVolumen.Resultado
             * @static
             * @param {mirana.NuevoVolumen.Resultado} message Resultado
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Resultado.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.dia = "";
                    object.diaLiteral = "";
                    object.volumen = 0;
                }
                if (message.dia != null && message.hasOwnProperty("dia"))
                    object.dia = message.dia;
                if (message.diaLiteral != null && message.hasOwnProperty("diaLiteral"))
                    object.diaLiteral = message.diaLiteral;
                if (message.volumen != null && message.hasOwnProperty("volumen"))
                    object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
                return object;
            };

            /**
             * Converts this Resultado to JSON.
             * @function toJSON
             * @memberof mirana.NuevoVolumen.Resultado
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Resultado.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Resultado;
        })();

        return NuevoVolumen;
    })();

    mirana.NuevoVolumenList = (function() {

        /**
         * Properties of a NuevoVolumenList.
         * @memberof mirana
         * @interface INuevoVolumenList
         * @property {Array.<mirana.INuevoVolumen>|null} [volumenes] NuevoVolumenList volumenes
         */

        /**
         * Constructs a new NuevoVolumenList.
         * @memberof mirana
         * @classdesc Represents a NuevoVolumenList.
         * @implements INuevoVolumenList
         * @constructor
         * @param {mirana.INuevoVolumenList=} [properties] Properties to set
         */
        function NuevoVolumenList(properties) {
            this.volumenes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevoVolumenList volumenes.
         * @member {Array.<mirana.INuevoVolumen>} volumenes
         * @memberof mirana.NuevoVolumenList
         * @instance
         */
        NuevoVolumenList.prototype.volumenes = $util.emptyArray;

        /**
         * Creates a new NuevoVolumenList instance using the specified properties.
         * @function create
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {mirana.INuevoVolumenList=} [properties] Properties to set
         * @returns {mirana.NuevoVolumenList} NuevoVolumenList instance
         */
        NuevoVolumenList.create = function create(properties) {
            return new NuevoVolumenList(properties);
        };

        /**
         * Encodes the specified NuevoVolumenList message. Does not implicitly {@link mirana.NuevoVolumenList.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {mirana.INuevoVolumenList} message NuevoVolumenList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumenList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.volumenes != null && message.volumenes.length)
                for (let i = 0; i < message.volumenes.length; ++i)
                    $root.mirana.NuevoVolumen.encode(message.volumenes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevoVolumenList message, length delimited. Does not implicitly {@link mirana.NuevoVolumenList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {mirana.INuevoVolumenList} message NuevoVolumenList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumenList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevoVolumenList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevoVolumenList} NuevoVolumenList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumenList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevoVolumenList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.volumenes && message.volumenes.length))
                        message.volumenes = [];
                    message.volumenes.push($root.mirana.NuevoVolumen.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevoVolumenList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevoVolumenList} NuevoVolumenList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumenList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevoVolumenList message.
         * @function verify
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevoVolumenList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.volumenes != null && message.hasOwnProperty("volumenes")) {
                if (!Array.isArray(message.volumenes))
                    return "volumenes: array expected";
                for (let i = 0; i < message.volumenes.length; ++i) {
                    let error = $root.mirana.NuevoVolumen.verify(message.volumenes[i]);
                    if (error)
                        return "volumenes." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevoVolumenList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevoVolumenList} NuevoVolumenList
         */
        NuevoVolumenList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevoVolumenList)
                return object;
            let message = new $root.mirana.NuevoVolumenList();
            if (object.volumenes) {
                if (!Array.isArray(object.volumenes))
                    throw TypeError(".mirana.NuevoVolumenList.volumenes: array expected");
                message.volumenes = [];
                for (let i = 0; i < object.volumenes.length; ++i) {
                    if (typeof object.volumenes[i] !== "object")
                        throw TypeError(".mirana.NuevoVolumenList.volumenes: object expected");
                    message.volumenes[i] = $root.mirana.NuevoVolumen.fromObject(object.volumenes[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevoVolumenList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevoVolumenList
         * @static
         * @param {mirana.NuevoVolumenList} message NuevoVolumenList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevoVolumenList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.volumenes = [];
            if (message.volumenes && message.volumenes.length) {
                object.volumenes = [];
                for (let j = 0; j < message.volumenes.length; ++j)
                    object.volumenes[j] = $root.mirana.NuevoVolumen.toObject(message.volumenes[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevoVolumenList to JSON.
         * @function toJSON
         * @memberof mirana.NuevoVolumenList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevoVolumenList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NuevoVolumenList;
    })();

    mirana.NuevaCoberturaList = (function() {

        /**
         * Properties of a NuevaCoberturaList.
         * @memberof mirana
         * @interface INuevaCoberturaList
         * @property {Array.<mirana.INuevaCoberturaAcumulada>|null} [coberturas] NuevaCoberturaList coberturas
         */

        /**
         * Constructs a new NuevaCoberturaList.
         * @memberof mirana
         * @classdesc Represents a NuevaCoberturaList.
         * @implements INuevaCoberturaList
         * @constructor
         * @param {mirana.INuevaCoberturaList=} [properties] Properties to set
         */
        function NuevaCoberturaList(properties) {
            this.coberturas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevaCoberturaList coberturas.
         * @member {Array.<mirana.INuevaCoberturaAcumulada>} coberturas
         * @memberof mirana.NuevaCoberturaList
         * @instance
         */
        NuevaCoberturaList.prototype.coberturas = $util.emptyArray;

        /**
         * Creates a new NuevaCoberturaList instance using the specified properties.
         * @function create
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {mirana.INuevaCoberturaList=} [properties] Properties to set
         * @returns {mirana.NuevaCoberturaList} NuevaCoberturaList instance
         */
        NuevaCoberturaList.create = function create(properties) {
            return new NuevaCoberturaList(properties);
        };

        /**
         * Encodes the specified NuevaCoberturaList message. Does not implicitly {@link mirana.NuevaCoberturaList.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {mirana.INuevaCoberturaList} message NuevaCoberturaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coberturas != null && message.coberturas.length)
                for (let i = 0; i < message.coberturas.length; ++i)
                    $root.mirana.NuevaCoberturaAcumulada.encode(message.coberturas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevaCoberturaList message, length delimited. Does not implicitly {@link mirana.NuevaCoberturaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {mirana.INuevaCoberturaList} message NuevaCoberturaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevaCoberturaList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevaCoberturaList} NuevaCoberturaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevaCoberturaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.coberturas && message.coberturas.length))
                        message.coberturas = [];
                    message.coberturas.push($root.mirana.NuevaCoberturaAcumulada.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevaCoberturaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevaCoberturaList} NuevaCoberturaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevaCoberturaList message.
         * @function verify
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevaCoberturaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coberturas != null && message.hasOwnProperty("coberturas")) {
                if (!Array.isArray(message.coberturas))
                    return "coberturas: array expected";
                for (let i = 0; i < message.coberturas.length; ++i) {
                    let error = $root.mirana.NuevaCoberturaAcumulada.verify(message.coberturas[i]);
                    if (error)
                        return "coberturas." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevaCoberturaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevaCoberturaList} NuevaCoberturaList
         */
        NuevaCoberturaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevaCoberturaList)
                return object;
            let message = new $root.mirana.NuevaCoberturaList();
            if (object.coberturas) {
                if (!Array.isArray(object.coberturas))
                    throw TypeError(".mirana.NuevaCoberturaList.coberturas: array expected");
                message.coberturas = [];
                for (let i = 0; i < object.coberturas.length; ++i) {
                    if (typeof object.coberturas[i] !== "object")
                        throw TypeError(".mirana.NuevaCoberturaList.coberturas: object expected");
                    message.coberturas[i] = $root.mirana.NuevaCoberturaAcumulada.fromObject(object.coberturas[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevaCoberturaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevaCoberturaList
         * @static
         * @param {mirana.NuevaCoberturaList} message NuevaCoberturaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevaCoberturaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturas = [];
            if (message.coberturas && message.coberturas.length) {
                object.coberturas = [];
                for (let j = 0; j < message.coberturas.length; ++j)
                    object.coberturas[j] = $root.mirana.NuevaCoberturaAcumulada.toObject(message.coberturas[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevaCoberturaList to JSON.
         * @function toJSON
         * @memberof mirana.NuevaCoberturaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevaCoberturaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NuevaCoberturaList;
    })();

    mirana.NuevaCoberturaAcumuladaRequest = (function() {

        /**
         * Properties of a NuevaCoberturaAcumuladaRequest.
         * @memberof mirana
         * @interface INuevaCoberturaAcumuladaRequest
         * @property {string|null} [fechaCarga] NuevaCoberturaAcumuladaRequest fechaCarga
         * @property {Array.<mirana.INuevaCoberturaAcumulada>|null} [coberturaAcumulada] NuevaCoberturaAcumuladaRequest coberturaAcumulada
         */

        /**
         * Constructs a new NuevaCoberturaAcumuladaRequest.
         * @memberof mirana
         * @classdesc Represents a NuevaCoberturaAcumuladaRequest.
         * @implements INuevaCoberturaAcumuladaRequest
         * @constructor
         * @param {mirana.INuevaCoberturaAcumuladaRequest=} [properties] Properties to set
         */
        function NuevaCoberturaAcumuladaRequest(properties) {
            this.coberturaAcumulada = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevaCoberturaAcumuladaRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @instance
         */
        NuevaCoberturaAcumuladaRequest.prototype.fechaCarga = "";

        /**
         * NuevaCoberturaAcumuladaRequest coberturaAcumulada.
         * @member {Array.<mirana.INuevaCoberturaAcumulada>} coberturaAcumulada
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @instance
         */
        NuevaCoberturaAcumuladaRequest.prototype.coberturaAcumulada = $util.emptyArray;

        /**
         * Creates a new NuevaCoberturaAcumuladaRequest instance using the specified properties.
         * @function create
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {mirana.INuevaCoberturaAcumuladaRequest=} [properties] Properties to set
         * @returns {mirana.NuevaCoberturaAcumuladaRequest} NuevaCoberturaAcumuladaRequest instance
         */
        NuevaCoberturaAcumuladaRequest.create = function create(properties) {
            return new NuevaCoberturaAcumuladaRequest(properties);
        };

        /**
         * Encodes the specified NuevaCoberturaAcumuladaRequest message. Does not implicitly {@link mirana.NuevaCoberturaAcumuladaRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {mirana.INuevaCoberturaAcumuladaRequest} message NuevaCoberturaAcumuladaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaAcumuladaRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.coberturaAcumulada != null && message.coberturaAcumulada.length)
                for (let i = 0; i < message.coberturaAcumulada.length; ++i)
                    $root.mirana.NuevaCoberturaAcumulada.encode(message.coberturaAcumulada[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevaCoberturaAcumuladaRequest message, length delimited. Does not implicitly {@link mirana.NuevaCoberturaAcumuladaRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {mirana.INuevaCoberturaAcumuladaRequest} message NuevaCoberturaAcumuladaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevaCoberturaAcumuladaRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevaCoberturaAcumuladaRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevaCoberturaAcumuladaRequest} NuevaCoberturaAcumuladaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaAcumuladaRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevaCoberturaAcumuladaRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.coberturaAcumulada && message.coberturaAcumulada.length))
                        message.coberturaAcumulada = [];
                    message.coberturaAcumulada.push($root.mirana.NuevaCoberturaAcumulada.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevaCoberturaAcumuladaRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevaCoberturaAcumuladaRequest} NuevaCoberturaAcumuladaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevaCoberturaAcumuladaRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevaCoberturaAcumuladaRequest message.
         * @function verify
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevaCoberturaAcumuladaRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.coberturaAcumulada != null && message.hasOwnProperty("coberturaAcumulada")) {
                if (!Array.isArray(message.coberturaAcumulada))
                    return "coberturaAcumulada: array expected";
                for (let i = 0; i < message.coberturaAcumulada.length; ++i) {
                    let error = $root.mirana.NuevaCoberturaAcumulada.verify(message.coberturaAcumulada[i]);
                    if (error)
                        return "coberturaAcumulada." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevaCoberturaAcumuladaRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevaCoberturaAcumuladaRequest} NuevaCoberturaAcumuladaRequest
         */
        NuevaCoberturaAcumuladaRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevaCoberturaAcumuladaRequest)
                return object;
            let message = new $root.mirana.NuevaCoberturaAcumuladaRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.coberturaAcumulada) {
                if (!Array.isArray(object.coberturaAcumulada))
                    throw TypeError(".mirana.NuevaCoberturaAcumuladaRequest.coberturaAcumulada: array expected");
                message.coberturaAcumulada = [];
                for (let i = 0; i < object.coberturaAcumulada.length; ++i) {
                    if (typeof object.coberturaAcumulada[i] !== "object")
                        throw TypeError(".mirana.NuevaCoberturaAcumuladaRequest.coberturaAcumulada: object expected");
                    message.coberturaAcumulada[i] = $root.mirana.NuevaCoberturaAcumulada.fromObject(object.coberturaAcumulada[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevaCoberturaAcumuladaRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @static
         * @param {mirana.NuevaCoberturaAcumuladaRequest} message NuevaCoberturaAcumuladaRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevaCoberturaAcumuladaRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturaAcumulada = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.coberturaAcumulada && message.coberturaAcumulada.length) {
                object.coberturaAcumulada = [];
                for (let j = 0; j < message.coberturaAcumulada.length; ++j)
                    object.coberturaAcumulada[j] = $root.mirana.NuevaCoberturaAcumulada.toObject(message.coberturaAcumulada[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevaCoberturaAcumuladaRequest to JSON.
         * @function toJSON
         * @memberof mirana.NuevaCoberturaAcumuladaRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevaCoberturaAcumuladaRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NuevaCoberturaAcumuladaRequest;
    })();

    mirana.NuevoVolumenRequest = (function() {

        /**
         * Properties of a NuevoVolumenRequest.
         * @memberof mirana
         * @interface INuevoVolumenRequest
         * @property {string|null} [fechaCarga] NuevoVolumenRequest fechaCarga
         * @property {Array.<mirana.INuevoVolumen>|null} [volumen] NuevoVolumenRequest volumen
         */

        /**
         * Constructs a new NuevoVolumenRequest.
         * @memberof mirana
         * @classdesc Represents a NuevoVolumenRequest.
         * @implements INuevoVolumenRequest
         * @constructor
         * @param {mirana.INuevoVolumenRequest=} [properties] Properties to set
         */
        function NuevoVolumenRequest(properties) {
            this.volumen = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NuevoVolumenRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.NuevoVolumenRequest
         * @instance
         */
        NuevoVolumenRequest.prototype.fechaCarga = "";

        /**
         * NuevoVolumenRequest volumen.
         * @member {Array.<mirana.INuevoVolumen>} volumen
         * @memberof mirana.NuevoVolumenRequest
         * @instance
         */
        NuevoVolumenRequest.prototype.volumen = $util.emptyArray;

        /**
         * Creates a new NuevoVolumenRequest instance using the specified properties.
         * @function create
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {mirana.INuevoVolumenRequest=} [properties] Properties to set
         * @returns {mirana.NuevoVolumenRequest} NuevoVolumenRequest instance
         */
        NuevoVolumenRequest.create = function create(properties) {
            return new NuevoVolumenRequest(properties);
        };

        /**
         * Encodes the specified NuevoVolumenRequest message. Does not implicitly {@link mirana.NuevoVolumenRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {mirana.INuevoVolumenRequest} message NuevoVolumenRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumenRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.volumen != null && message.volumen.length)
                for (let i = 0; i < message.volumen.length; ++i)
                    $root.mirana.NuevoVolumen.encode(message.volumen[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NuevoVolumenRequest message, length delimited. Does not implicitly {@link mirana.NuevoVolumenRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {mirana.INuevoVolumenRequest} message NuevoVolumenRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NuevoVolumenRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NuevoVolumenRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.NuevoVolumenRequest} NuevoVolumenRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumenRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.NuevoVolumenRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.volumen && message.volumen.length))
                        message.volumen = [];
                    message.volumen.push($root.mirana.NuevoVolumen.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NuevoVolumenRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.NuevoVolumenRequest} NuevoVolumenRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NuevoVolumenRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NuevoVolumenRequest message.
         * @function verify
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NuevoVolumenRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen")) {
                if (!Array.isArray(message.volumen))
                    return "volumen: array expected";
                for (let i = 0; i < message.volumen.length; ++i) {
                    let error = $root.mirana.NuevoVolumen.verify(message.volumen[i]);
                    if (error)
                        return "volumen." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NuevoVolumenRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.NuevoVolumenRequest} NuevoVolumenRequest
         */
        NuevoVolumenRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.NuevoVolumenRequest)
                return object;
            let message = new $root.mirana.NuevoVolumenRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.volumen) {
                if (!Array.isArray(object.volumen))
                    throw TypeError(".mirana.NuevoVolumenRequest.volumen: array expected");
                message.volumen = [];
                for (let i = 0; i < object.volumen.length; ++i) {
                    if (typeof object.volumen[i] !== "object")
                        throw TypeError(".mirana.NuevoVolumenRequest.volumen: object expected");
                    message.volumen[i] = $root.mirana.NuevoVolumen.fromObject(object.volumen[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NuevoVolumenRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.NuevoVolumenRequest
         * @static
         * @param {mirana.NuevoVolumenRequest} message NuevoVolumenRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NuevoVolumenRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.volumen = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.volumen && message.volumen.length) {
                object.volumen = [];
                for (let j = 0; j < message.volumen.length; ++j)
                    object.volumen[j] = $root.mirana.NuevoVolumen.toObject(message.volumen[j], options);
            }
            return object;
        };

        /**
         * Converts this NuevoVolumenRequest to JSON.
         * @function toJSON
         * @memberof mirana.NuevoVolumenRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NuevoVolumenRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NuevoVolumenRequest;
    })();

    mirana.NuevoTdosService = (function() {

        /**
         * Constructs a new NuevoTdosService service.
         * @memberof mirana
         * @classdesc Represents a NuevoTdosService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function NuevoTdosService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (NuevoTdosService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NuevoTdosService;

        /**
         * Creates new NuevoTdosService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.NuevoTdosService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {NuevoTdosService} RPC service. Useful where requests and/or responses are streamed.
         */
        NuevoTdosService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.NuevoTdosService#syncCoberturaAcumulada}.
         * @memberof mirana.NuevoTdosService
         * @typedef syncCoberturaAcumuladaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncCoberturaAcumulada.
         * @function syncCoberturaAcumulada
         * @memberof mirana.NuevoTdosService
         * @instance
         * @param {mirana.INuevaCoberturaAcumuladaRequest} request NuevaCoberturaAcumuladaRequest message or plain object
         * @param {mirana.NuevoTdosService.syncCoberturaAcumuladaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        NuevoTdosService.prototype.syncCoberturaAcumulada = function syncCoberturaAcumulada(request, callback) {
            return this.rpcCall(syncCoberturaAcumulada, $root.mirana.NuevaCoberturaAcumuladaRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncCoberturaAcumulada.
         * @function syncCoberturaAcumulada
         * @memberof mirana.NuevoTdosService
         * @instance
         * @param {mirana.INuevaCoberturaAcumuladaRequest} request NuevaCoberturaAcumuladaRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.NuevoTdosService#syncVolumen}.
         * @memberof mirana.NuevoTdosService
         * @typedef syncVolumenCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncVolumen.
         * @function syncVolumen
         * @memberof mirana.NuevoTdosService
         * @instance
         * @param {mirana.INuevoVolumenRequest} request NuevoVolumenRequest message or plain object
         * @param {mirana.NuevoTdosService.syncVolumenCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        NuevoTdosService.prototype.syncVolumen = function syncVolumen(request, callback) {
            return this.rpcCall(syncVolumen, $root.mirana.NuevoVolumenRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncVolumen.
         * @function syncVolumen
         * @memberof mirana.NuevoTdosService
         * @instance
         * @param {mirana.INuevoVolumenRequest} request NuevoVolumenRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return NuevoTdosService;
    })();

    mirana.Indicador = (function() {

        /**
         * Properties of an Indicador.
         * @memberof mirana
         * @interface IIndicador
         * @property {mirana.Indicador.TipoIndicador|null} [tipo] Indicador tipo
         * @property {string|null} [definicion] Indicador definicion
         * @property {number|null} [kpi] Indicador kpi
         * @property {string|null} [fechaCarga] Indicador fechaCarga
         * @property {Array.<util.IKeyValueDay>|null} [resultados] Indicador resultados
         */

        /**
         * Constructs a new Indicador.
         * @memberof mirana
         * @classdesc Represents an Indicador.
         * @implements IIndicador
         * @constructor
         * @param {mirana.IIndicador=} [properties] Properties to set
         */
        function Indicador(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Indicador tipo.
         * @member {mirana.Indicador.TipoIndicador} tipo
         * @memberof mirana.Indicador
         * @instance
         */
        Indicador.prototype.tipo = 0;

        /**
         * Indicador definicion.
         * @member {string} definicion
         * @memberof mirana.Indicador
         * @instance
         */
        Indicador.prototype.definicion = "";

        /**
         * Indicador kpi.
         * @member {number} kpi
         * @memberof mirana.Indicador
         * @instance
         */
        Indicador.prototype.kpi = 0;

        /**
         * Indicador fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.Indicador
         * @instance
         */
        Indicador.prototype.fechaCarga = "";

        /**
         * Indicador resultados.
         * @member {Array.<util.IKeyValueDay>} resultados
         * @memberof mirana.Indicador
         * @instance
         */
        Indicador.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new Indicador instance using the specified properties.
         * @function create
         * @memberof mirana.Indicador
         * @static
         * @param {mirana.IIndicador=} [properties] Properties to set
         * @returns {mirana.Indicador} Indicador instance
         */
        Indicador.create = function create(properties) {
            return new Indicador(properties);
        };

        /**
         * Encodes the specified Indicador message. Does not implicitly {@link mirana.Indicador.verify|verify} messages.
         * @function encode
         * @memberof mirana.Indicador
         * @static
         * @param {mirana.IIndicador} message Indicador message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Indicador.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tipo != null && message.hasOwnProperty("tipo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.tipo);
            if (message.definicion != null && message.hasOwnProperty("definicion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.definicion);
            if (message.kpi != null && message.hasOwnProperty("kpi"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.kpi);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fechaCarga);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.util.KeyValueDay.encode(message.resultados[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Indicador message, length delimited. Does not implicitly {@link mirana.Indicador.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Indicador
         * @static
         * @param {mirana.IIndicador} message Indicador message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Indicador.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Indicador message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Indicador
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Indicador} Indicador
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Indicador.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Indicador();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tipo = reader.int32();
                    break;
                case 2:
                    message.definicion = reader.string();
                    break;
                case 3:
                    message.kpi = reader.double();
                    break;
                case 4:
                    message.fechaCarga = reader.string();
                    break;
                case 5:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.util.KeyValueDay.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Indicador message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Indicador
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Indicador} Indicador
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Indicador.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Indicador message.
         * @function verify
         * @memberof mirana.Indicador
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Indicador.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tipo != null && message.hasOwnProperty("tipo"))
                switch (message.tipo) {
                default:
                    return "tipo: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.definicion != null && message.hasOwnProperty("definicion"))
                if (!$util.isString(message.definicion))
                    return "definicion: string expected";
            if (message.kpi != null && message.hasOwnProperty("kpi"))
                if (typeof message.kpi !== "number")
                    return "kpi: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.util.KeyValueDay.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates an Indicador message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Indicador
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Indicador} Indicador
         */
        Indicador.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Indicador)
                return object;
            let message = new $root.mirana.Indicador();
            switch (object.tipo) {
            case "VENTA_T2":
            case 0:
                message.tipo = 0;
                break;
            case "CARTERA_TOTAL":
            case 1:
                message.tipo = 1;
                break;
            case "CLIENTES_COBERTURADOS":
            case 2:
                message.tipo = 2;
                break;
            case "PROGRAMADOS_DIA":
            case 3:
                message.tipo = 3;
                break;
            case "EFECTIVIDAD_DIA":
            case 4:
                message.tipo = 4;
                break;
            case "RECHAZOS":
            case 5:
                message.tipo = 5;
                break;
            }
            if (object.definicion != null)
                message.definicion = String(object.definicion);
            if (object.kpi != null)
                message.kpi = Number(object.kpi);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.Indicador.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.Indicador.resultados: object expected");
                    message.resultados[i] = $root.util.KeyValueDay.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an Indicador message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Indicador
         * @static
         * @param {mirana.Indicador} message Indicador
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Indicador.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.tipo = options.enums === String ? "VENTA_T2" : 0;
                object.definicion = "";
                object.kpi = 0;
                object.fechaCarga = "";
            }
            if (message.tipo != null && message.hasOwnProperty("tipo"))
                object.tipo = options.enums === String ? $root.mirana.Indicador.TipoIndicador[message.tipo] : message.tipo;
            if (message.definicion != null && message.hasOwnProperty("definicion"))
                object.definicion = message.definicion;
            if (message.kpi != null && message.hasOwnProperty("kpi"))
                object.kpi = options.json && !isFinite(message.kpi) ? String(message.kpi) : message.kpi;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.util.KeyValueDay.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this Indicador to JSON.
         * @function toJSON
         * @memberof mirana.Indicador
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Indicador.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * TipoIndicador enum.
         * @name mirana.Indicador.TipoIndicador
         * @enum {string}
         * @property {number} VENTA_T2=0 VENTA_T2 value
         * @property {number} CARTERA_TOTAL=1 CARTERA_TOTAL value
         * @property {number} CLIENTES_COBERTURADOS=2 CLIENTES_COBERTURADOS value
         * @property {number} PROGRAMADOS_DIA=3 PROGRAMADOS_DIA value
         * @property {number} EFECTIVIDAD_DIA=4 EFECTIVIDAD_DIA value
         * @property {number} RECHAZOS=5 RECHAZOS value
         */
        Indicador.TipoIndicador = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "VENTA_T2"] = 0;
            values[valuesById[1] = "CARTERA_TOTAL"] = 1;
            values[valuesById[2] = "CLIENTES_COBERTURADOS"] = 2;
            values[valuesById[3] = "PROGRAMADOS_DIA"] = 3;
            values[valuesById[4] = "EFECTIVIDAD_DIA"] = 4;
            values[valuesById[5] = "RECHAZOS"] = 5;
            return values;
        })();

        return Indicador;
    })();

    mirana.Preventa = (function() {

        /**
         * Properties of a Preventa.
         * @memberof mirana
         * @interface IPreventa
         * @property {string|null} [distribuidor] Preventa distribuidor
         * @property {string|null} [categoria] Preventa categoria
         * @property {number|null} [monto] Preventa monto
         * @property {string|null} [fechaCarga] Preventa fechaCarga
         * @property {number|null} [volumen] Preventa volumen
         * @property {Array.<util.IKeyValueDay>|null} [resultados] Preventa resultados
         */

        /**
         * Constructs a new Preventa.
         * @memberof mirana
         * @classdesc Represents a Preventa.
         * @implements IPreventa
         * @constructor
         * @param {mirana.IPreventa=} [properties] Properties to set
         */
        function Preventa(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Preventa distribuidor.
         * @member {string} distribuidor
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.distribuidor = "";

        /**
         * Preventa categoria.
         * @member {string} categoria
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.categoria = "";

        /**
         * Preventa monto.
         * @member {number} monto
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.monto = 0;

        /**
         * Preventa fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.fechaCarga = "";

        /**
         * Preventa volumen.
         * @member {number} volumen
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.volumen = 0;

        /**
         * Preventa resultados.
         * @member {Array.<util.IKeyValueDay>} resultados
         * @memberof mirana.Preventa
         * @instance
         */
        Preventa.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new Preventa instance using the specified properties.
         * @function create
         * @memberof mirana.Preventa
         * @static
         * @param {mirana.IPreventa=} [properties] Properties to set
         * @returns {mirana.Preventa} Preventa instance
         */
        Preventa.create = function create(properties) {
            return new Preventa(properties);
        };

        /**
         * Encodes the specified Preventa message. Does not implicitly {@link mirana.Preventa.verify|verify} messages.
         * @function encode
         * @memberof mirana.Preventa
         * @static
         * @param {mirana.IPreventa} message Preventa message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Preventa.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.distribuidor);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoria);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.monto);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fechaCarga);
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.volumen);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.util.KeyValueDay.encode(message.resultados[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Preventa message, length delimited. Does not implicitly {@link mirana.Preventa.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Preventa
         * @static
         * @param {mirana.IPreventa} message Preventa message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Preventa.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Preventa message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Preventa
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Preventa} Preventa
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Preventa.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Preventa();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.distribuidor = reader.string();
                    break;
                case 2:
                    message.categoria = reader.string();
                    break;
                case 3:
                    message.monto = reader.double();
                    break;
                case 4:
                    message.fechaCarga = reader.string();
                    break;
                case 5:
                    message.volumen = reader.double();
                    break;
                case 6:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.util.KeyValueDay.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Preventa message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Preventa
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Preventa} Preventa
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Preventa.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Preventa message.
         * @function verify
         * @memberof mirana.Preventa
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Preventa.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                if (!$util.isString(message.distribuidor))
                    return "distribuidor: string expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                if (typeof message.volumen !== "number")
                    return "volumen: number expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.util.KeyValueDay.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Preventa message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Preventa
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Preventa} Preventa
         */
        Preventa.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Preventa)
                return object;
            let message = new $root.mirana.Preventa();
            if (object.distribuidor != null)
                message.distribuidor = String(object.distribuidor);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.volumen != null)
                message.volumen = Number(object.volumen);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.Preventa.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.Preventa.resultados: object expected");
                    message.resultados[i] = $root.util.KeyValueDay.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Preventa message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Preventa
         * @static
         * @param {mirana.Preventa} message Preventa
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Preventa.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.distribuidor = "";
                object.categoria = "";
                object.monto = 0;
                object.fechaCarga = "";
                object.volumen = 0;
            }
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                object.distribuidor = message.distribuidor;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.volumen != null && message.hasOwnProperty("volumen"))
                object.volumen = options.json && !isFinite(message.volumen) ? String(message.volumen) : message.volumen;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.util.KeyValueDay.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this Preventa to JSON.
         * @function toJSON
         * @memberof mirana.Preventa
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Preventa.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Preventa;
    })();

    mirana.PreventaRequest = (function() {

        /**
         * Properties of a PreventaRequest.
         * @memberof mirana
         * @interface IPreventaRequest
         * @property {string|null} [fechaCarga] PreventaRequest fechaCarga
         * @property {Array.<mirana.IPreventa>|null} [preventa] PreventaRequest preventa
         */

        /**
         * Constructs a new PreventaRequest.
         * @memberof mirana
         * @classdesc Represents a PreventaRequest.
         * @implements IPreventaRequest
         * @constructor
         * @param {mirana.IPreventaRequest=} [properties] Properties to set
         */
        function PreventaRequest(properties) {
            this.preventa = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PreventaRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.PreventaRequest
         * @instance
         */
        PreventaRequest.prototype.fechaCarga = "";

        /**
         * PreventaRequest preventa.
         * @member {Array.<mirana.IPreventa>} preventa
         * @memberof mirana.PreventaRequest
         * @instance
         */
        PreventaRequest.prototype.preventa = $util.emptyArray;

        /**
         * Creates a new PreventaRequest instance using the specified properties.
         * @function create
         * @memberof mirana.PreventaRequest
         * @static
         * @param {mirana.IPreventaRequest=} [properties] Properties to set
         * @returns {mirana.PreventaRequest} PreventaRequest instance
         */
        PreventaRequest.create = function create(properties) {
            return new PreventaRequest(properties);
        };

        /**
         * Encodes the specified PreventaRequest message. Does not implicitly {@link mirana.PreventaRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.PreventaRequest
         * @static
         * @param {mirana.IPreventaRequest} message PreventaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreventaRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.preventa != null && message.preventa.length)
                for (let i = 0; i < message.preventa.length; ++i)
                    $root.mirana.Preventa.encode(message.preventa[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PreventaRequest message, length delimited. Does not implicitly {@link mirana.PreventaRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PreventaRequest
         * @static
         * @param {mirana.IPreventaRequest} message PreventaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreventaRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PreventaRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PreventaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PreventaRequest} PreventaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreventaRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PreventaRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.preventa && message.preventa.length))
                        message.preventa = [];
                    message.preventa.push($root.mirana.Preventa.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PreventaRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PreventaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PreventaRequest} PreventaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreventaRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PreventaRequest message.
         * @function verify
         * @memberof mirana.PreventaRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PreventaRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.preventa != null && message.hasOwnProperty("preventa")) {
                if (!Array.isArray(message.preventa))
                    return "preventa: array expected";
                for (let i = 0; i < message.preventa.length; ++i) {
                    let error = $root.mirana.Preventa.verify(message.preventa[i]);
                    if (error)
                        return "preventa." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PreventaRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PreventaRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PreventaRequest} PreventaRequest
         */
        PreventaRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PreventaRequest)
                return object;
            let message = new $root.mirana.PreventaRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.preventa) {
                if (!Array.isArray(object.preventa))
                    throw TypeError(".mirana.PreventaRequest.preventa: array expected");
                message.preventa = [];
                for (let i = 0; i < object.preventa.length; ++i) {
                    if (typeof object.preventa[i] !== "object")
                        throw TypeError(".mirana.PreventaRequest.preventa: object expected");
                    message.preventa[i] = $root.mirana.Preventa.fromObject(object.preventa[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PreventaRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PreventaRequest
         * @static
         * @param {mirana.PreventaRequest} message PreventaRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PreventaRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.preventa = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.preventa && message.preventa.length) {
                object.preventa = [];
                for (let j = 0; j < message.preventa.length; ++j)
                    object.preventa[j] = $root.mirana.Preventa.toObject(message.preventa[j], options);
            }
            return object;
        };

        /**
         * Converts this PreventaRequest to JSON.
         * @function toJSON
         * @memberof mirana.PreventaRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PreventaRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PreventaRequest;
    })();

    mirana.IndicadorRequest = (function() {

        /**
         * Properties of an IndicadorRequest.
         * @memberof mirana
         * @interface IIndicadorRequest
         * @property {string|null} [fechaCarga] IndicadorRequest fechaCarga
         * @property {Array.<mirana.IIndicador>|null} [indicador] IndicadorRequest indicador
         */

        /**
         * Constructs a new IndicadorRequest.
         * @memberof mirana
         * @classdesc Represents an IndicadorRequest.
         * @implements IIndicadorRequest
         * @constructor
         * @param {mirana.IIndicadorRequest=} [properties] Properties to set
         */
        function IndicadorRequest(properties) {
            this.indicador = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IndicadorRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.IndicadorRequest
         * @instance
         */
        IndicadorRequest.prototype.fechaCarga = "";

        /**
         * IndicadorRequest indicador.
         * @member {Array.<mirana.IIndicador>} indicador
         * @memberof mirana.IndicadorRequest
         * @instance
         */
        IndicadorRequest.prototype.indicador = $util.emptyArray;

        /**
         * Creates a new IndicadorRequest instance using the specified properties.
         * @function create
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {mirana.IIndicadorRequest=} [properties] Properties to set
         * @returns {mirana.IndicadorRequest} IndicadorRequest instance
         */
        IndicadorRequest.create = function create(properties) {
            return new IndicadorRequest(properties);
        };

        /**
         * Encodes the specified IndicadorRequest message. Does not implicitly {@link mirana.IndicadorRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {mirana.IIndicadorRequest} message IndicadorRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IndicadorRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.indicador != null && message.indicador.length)
                for (let i = 0; i < message.indicador.length; ++i)
                    $root.mirana.Indicador.encode(message.indicador[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified IndicadorRequest message, length delimited. Does not implicitly {@link mirana.IndicadorRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {mirana.IIndicadorRequest} message IndicadorRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IndicadorRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IndicadorRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.IndicadorRequest} IndicadorRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IndicadorRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.IndicadorRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.indicador && message.indicador.length))
                        message.indicador = [];
                    message.indicador.push($root.mirana.Indicador.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IndicadorRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.IndicadorRequest} IndicadorRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IndicadorRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IndicadorRequest message.
         * @function verify
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IndicadorRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.indicador != null && message.hasOwnProperty("indicador")) {
                if (!Array.isArray(message.indicador))
                    return "indicador: array expected";
                for (let i = 0; i < message.indicador.length; ++i) {
                    let error = $root.mirana.Indicador.verify(message.indicador[i]);
                    if (error)
                        return "indicador." + error;
                }
            }
            return null;
        };

        /**
         * Creates an IndicadorRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.IndicadorRequest} IndicadorRequest
         */
        IndicadorRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.IndicadorRequest)
                return object;
            let message = new $root.mirana.IndicadorRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.indicador) {
                if (!Array.isArray(object.indicador))
                    throw TypeError(".mirana.IndicadorRequest.indicador: array expected");
                message.indicador = [];
                for (let i = 0; i < object.indicador.length; ++i) {
                    if (typeof object.indicador[i] !== "object")
                        throw TypeError(".mirana.IndicadorRequest.indicador: object expected");
                    message.indicador[i] = $root.mirana.Indicador.fromObject(object.indicador[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an IndicadorRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.IndicadorRequest
         * @static
         * @param {mirana.IndicadorRequest} message IndicadorRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IndicadorRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.indicador = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.indicador && message.indicador.length) {
                object.indicador = [];
                for (let j = 0; j < message.indicador.length; ++j)
                    object.indicador[j] = $root.mirana.Indicador.toObject(message.indicador[j], options);
            }
            return object;
        };

        /**
         * Converts this IndicadorRequest to JSON.
         * @function toJSON
         * @memberof mirana.IndicadorRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IndicadorRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IndicadorRequest;
    })();

    mirana.CoberturaAcumulada = (function() {

        /**
         * Properties of a CoberturaAcumulada.
         * @memberof mirana
         * @interface ICoberturaAcumulada
         * @property {string|null} [distribuidor] CoberturaAcumulada distribuidor
         * @property {string|null} [categoria] CoberturaAcumulada categoria
         * @property {number|null} [cobertura] CoberturaAcumulada cobertura
         * @property {string|null} [fechaCarga] CoberturaAcumulada fechaCarga
         * @property {Array.<util.IKeyValueDay>|null} [resultados] CoberturaAcumulada resultados
         */

        /**
         * Constructs a new CoberturaAcumulada.
         * @memberof mirana
         * @classdesc Represents a CoberturaAcumulada.
         * @implements ICoberturaAcumulada
         * @constructor
         * @param {mirana.ICoberturaAcumulada=} [properties] Properties to set
         */
        function CoberturaAcumulada(properties) {
            this.resultados = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturaAcumulada distribuidor.
         * @member {string} distribuidor
         * @memberof mirana.CoberturaAcumulada
         * @instance
         */
        CoberturaAcumulada.prototype.distribuidor = "";

        /**
         * CoberturaAcumulada categoria.
         * @member {string} categoria
         * @memberof mirana.CoberturaAcumulada
         * @instance
         */
        CoberturaAcumulada.prototype.categoria = "";

        /**
         * CoberturaAcumulada cobertura.
         * @member {number} cobertura
         * @memberof mirana.CoberturaAcumulada
         * @instance
         */
        CoberturaAcumulada.prototype.cobertura = 0;

        /**
         * CoberturaAcumulada fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.CoberturaAcumulada
         * @instance
         */
        CoberturaAcumulada.prototype.fechaCarga = "";

        /**
         * CoberturaAcumulada resultados.
         * @member {Array.<util.IKeyValueDay>} resultados
         * @memberof mirana.CoberturaAcumulada
         * @instance
         */
        CoberturaAcumulada.prototype.resultados = $util.emptyArray;

        /**
         * Creates a new CoberturaAcumulada instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {mirana.ICoberturaAcumulada=} [properties] Properties to set
         * @returns {mirana.CoberturaAcumulada} CoberturaAcumulada instance
         */
        CoberturaAcumulada.create = function create(properties) {
            return new CoberturaAcumulada(properties);
        };

        /**
         * Encodes the specified CoberturaAcumulada message. Does not implicitly {@link mirana.CoberturaAcumulada.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {mirana.ICoberturaAcumulada} message CoberturaAcumulada message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAcumulada.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.distribuidor);
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoria);
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.cobertura);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fechaCarga);
            if (message.resultados != null && message.resultados.length)
                for (let i = 0; i < message.resultados.length; ++i)
                    $root.util.KeyValueDay.encode(message.resultados[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CoberturaAcumulada message, length delimited. Does not implicitly {@link mirana.CoberturaAcumulada.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {mirana.ICoberturaAcumulada} message CoberturaAcumulada message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAcumulada.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturaAcumulada message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturaAcumulada} CoberturaAcumulada
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAcumulada.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturaAcumulada();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.distribuidor = reader.string();
                    break;
                case 2:
                    message.categoria = reader.string();
                    break;
                case 3:
                    message.cobertura = reader.double();
                    break;
                case 4:
                    message.fechaCarga = reader.string();
                    break;
                case 5:
                    if (!(message.resultados && message.resultados.length))
                        message.resultados = [];
                    message.resultados.push($root.util.KeyValueDay.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturaAcumulada message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturaAcumulada} CoberturaAcumulada
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAcumulada.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturaAcumulada message.
         * @function verify
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturaAcumulada.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                if (!$util.isString(message.distribuidor))
                    return "distribuidor: string expected";
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                if (!$util.isString(message.categoria))
                    return "categoria: string expected";
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                if (typeof message.cobertura !== "number")
                    return "cobertura: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.resultados != null && message.hasOwnProperty("resultados")) {
                if (!Array.isArray(message.resultados))
                    return "resultados: array expected";
                for (let i = 0; i < message.resultados.length; ++i) {
                    let error = $root.util.KeyValueDay.verify(message.resultados[i]);
                    if (error)
                        return "resultados." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CoberturaAcumulada message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturaAcumulada} CoberturaAcumulada
         */
        CoberturaAcumulada.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturaAcumulada)
                return object;
            let message = new $root.mirana.CoberturaAcumulada();
            if (object.distribuidor != null)
                message.distribuidor = String(object.distribuidor);
            if (object.categoria != null)
                message.categoria = String(object.categoria);
            if (object.cobertura != null)
                message.cobertura = Number(object.cobertura);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.resultados) {
                if (!Array.isArray(object.resultados))
                    throw TypeError(".mirana.CoberturaAcumulada.resultados: array expected");
                message.resultados = [];
                for (let i = 0; i < object.resultados.length; ++i) {
                    if (typeof object.resultados[i] !== "object")
                        throw TypeError(".mirana.CoberturaAcumulada.resultados: object expected");
                    message.resultados[i] = $root.util.KeyValueDay.fromObject(object.resultados[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CoberturaAcumulada message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturaAcumulada
         * @static
         * @param {mirana.CoberturaAcumulada} message CoberturaAcumulada
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturaAcumulada.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.resultados = [];
            if (options.defaults) {
                object.distribuidor = "";
                object.categoria = "";
                object.cobertura = 0;
                object.fechaCarga = "";
            }
            if (message.distribuidor != null && message.hasOwnProperty("distribuidor"))
                object.distribuidor = message.distribuidor;
            if (message.categoria != null && message.hasOwnProperty("categoria"))
                object.categoria = message.categoria;
            if (message.cobertura != null && message.hasOwnProperty("cobertura"))
                object.cobertura = options.json && !isFinite(message.cobertura) ? String(message.cobertura) : message.cobertura;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.resultados && message.resultados.length) {
                object.resultados = [];
                for (let j = 0; j < message.resultados.length; ++j)
                    object.resultados[j] = $root.util.KeyValueDay.toObject(message.resultados[j], options);
            }
            return object;
        };

        /**
         * Converts this CoberturaAcumulada to JSON.
         * @function toJSON
         * @memberof mirana.CoberturaAcumulada
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturaAcumulada.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturaAcumulada;
    })();

    mirana.CoberturaAcumuladaRequest = (function() {

        /**
         * Properties of a CoberturaAcumuladaRequest.
         * @memberof mirana
         * @interface ICoberturaAcumuladaRequest
         * @property {string|null} [fechaCarga] CoberturaAcumuladaRequest fechaCarga
         * @property {Array.<mirana.ICoberturaAcumulada>|null} [coberturaAcumulada] CoberturaAcumuladaRequest coberturaAcumulada
         */

        /**
         * Constructs a new CoberturaAcumuladaRequest.
         * @memberof mirana
         * @classdesc Represents a CoberturaAcumuladaRequest.
         * @implements ICoberturaAcumuladaRequest
         * @constructor
         * @param {mirana.ICoberturaAcumuladaRequest=} [properties] Properties to set
         */
        function CoberturaAcumuladaRequest(properties) {
            this.coberturaAcumulada = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturaAcumuladaRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.CoberturaAcumuladaRequest
         * @instance
         */
        CoberturaAcumuladaRequest.prototype.fechaCarga = "";

        /**
         * CoberturaAcumuladaRequest coberturaAcumulada.
         * @member {Array.<mirana.ICoberturaAcumulada>} coberturaAcumulada
         * @memberof mirana.CoberturaAcumuladaRequest
         * @instance
         */
        CoberturaAcumuladaRequest.prototype.coberturaAcumulada = $util.emptyArray;

        /**
         * Creates a new CoberturaAcumuladaRequest instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {mirana.ICoberturaAcumuladaRequest=} [properties] Properties to set
         * @returns {mirana.CoberturaAcumuladaRequest} CoberturaAcumuladaRequest instance
         */
        CoberturaAcumuladaRequest.create = function create(properties) {
            return new CoberturaAcumuladaRequest(properties);
        };

        /**
         * Encodes the specified CoberturaAcumuladaRequest message. Does not implicitly {@link mirana.CoberturaAcumuladaRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {mirana.ICoberturaAcumuladaRequest} message CoberturaAcumuladaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAcumuladaRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.coberturaAcumulada != null && message.coberturaAcumulada.length)
                for (let i = 0; i < message.coberturaAcumulada.length; ++i)
                    $root.mirana.CoberturaAcumulada.encode(message.coberturaAcumulada[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CoberturaAcumuladaRequest message, length delimited. Does not implicitly {@link mirana.CoberturaAcumuladaRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {mirana.ICoberturaAcumuladaRequest} message CoberturaAcumuladaRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturaAcumuladaRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturaAcumuladaRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturaAcumuladaRequest} CoberturaAcumuladaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAcumuladaRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturaAcumuladaRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.coberturaAcumulada && message.coberturaAcumulada.length))
                        message.coberturaAcumulada = [];
                    message.coberturaAcumulada.push($root.mirana.CoberturaAcumulada.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturaAcumuladaRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturaAcumuladaRequest} CoberturaAcumuladaRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturaAcumuladaRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturaAcumuladaRequest message.
         * @function verify
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturaAcumuladaRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.coberturaAcumulada != null && message.hasOwnProperty("coberturaAcumulada")) {
                if (!Array.isArray(message.coberturaAcumulada))
                    return "coberturaAcumulada: array expected";
                for (let i = 0; i < message.coberturaAcumulada.length; ++i) {
                    let error = $root.mirana.CoberturaAcumulada.verify(message.coberturaAcumulada[i]);
                    if (error)
                        return "coberturaAcumulada." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CoberturaAcumuladaRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturaAcumuladaRequest} CoberturaAcumuladaRequest
         */
        CoberturaAcumuladaRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturaAcumuladaRequest)
                return object;
            let message = new $root.mirana.CoberturaAcumuladaRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.coberturaAcumulada) {
                if (!Array.isArray(object.coberturaAcumulada))
                    throw TypeError(".mirana.CoberturaAcumuladaRequest.coberturaAcumulada: array expected");
                message.coberturaAcumulada = [];
                for (let i = 0; i < object.coberturaAcumulada.length; ++i) {
                    if (typeof object.coberturaAcumulada[i] !== "object")
                        throw TypeError(".mirana.CoberturaAcumuladaRequest.coberturaAcumulada: object expected");
                    message.coberturaAcumulada[i] = $root.mirana.CoberturaAcumulada.fromObject(object.coberturaAcumulada[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CoberturaAcumuladaRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturaAcumuladaRequest
         * @static
         * @param {mirana.CoberturaAcumuladaRequest} message CoberturaAcumuladaRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturaAcumuladaRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturaAcumulada = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.coberturaAcumulada && message.coberturaAcumulada.length) {
                object.coberturaAcumulada = [];
                for (let j = 0; j < message.coberturaAcumulada.length; ++j)
                    object.coberturaAcumulada[j] = $root.mirana.CoberturaAcumulada.toObject(message.coberturaAcumulada[j], options);
            }
            return object;
        };

        /**
         * Converts this CoberturaAcumuladaRequest to JSON.
         * @function toJSON
         * @memberof mirana.CoberturaAcumuladaRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturaAcumuladaRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturaAcumuladaRequest;
    })();

    mirana.CoberturasAcumuladasList = (function() {

        /**
         * Properties of a CoberturasAcumuladasList.
         * @memberof mirana
         * @interface ICoberturasAcumuladasList
         * @property {Array.<mirana.ICoberturaAcumulada>|null} [coberturas] CoberturasAcumuladasList coberturas
         */

        /**
         * Constructs a new CoberturasAcumuladasList.
         * @memberof mirana
         * @classdesc Represents a CoberturasAcumuladasList.
         * @implements ICoberturasAcumuladasList
         * @constructor
         * @param {mirana.ICoberturasAcumuladasList=} [properties] Properties to set
         */
        function CoberturasAcumuladasList(properties) {
            this.coberturas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoberturasAcumuladasList coberturas.
         * @member {Array.<mirana.ICoberturaAcumulada>} coberturas
         * @memberof mirana.CoberturasAcumuladasList
         * @instance
         */
        CoberturasAcumuladasList.prototype.coberturas = $util.emptyArray;

        /**
         * Creates a new CoberturasAcumuladasList instance using the specified properties.
         * @function create
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {mirana.ICoberturasAcumuladasList=} [properties] Properties to set
         * @returns {mirana.CoberturasAcumuladasList} CoberturasAcumuladasList instance
         */
        CoberturasAcumuladasList.create = function create(properties) {
            return new CoberturasAcumuladasList(properties);
        };

        /**
         * Encodes the specified CoberturasAcumuladasList message. Does not implicitly {@link mirana.CoberturasAcumuladasList.verify|verify} messages.
         * @function encode
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {mirana.ICoberturasAcumuladasList} message CoberturasAcumuladasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturasAcumuladasList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coberturas != null && message.coberturas.length)
                for (let i = 0; i < message.coberturas.length; ++i)
                    $root.mirana.CoberturaAcumulada.encode(message.coberturas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CoberturasAcumuladasList message, length delimited. Does not implicitly {@link mirana.CoberturasAcumuladasList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {mirana.ICoberturasAcumuladasList} message CoberturasAcumuladasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoberturasAcumuladasList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoberturasAcumuladasList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.CoberturasAcumuladasList} CoberturasAcumuladasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturasAcumuladasList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.CoberturasAcumuladasList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.coberturas && message.coberturas.length))
                        message.coberturas = [];
                    message.coberturas.push($root.mirana.CoberturaAcumulada.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoberturasAcumuladasList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.CoberturasAcumuladasList} CoberturasAcumuladasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoberturasAcumuladasList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoberturasAcumuladasList message.
         * @function verify
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoberturasAcumuladasList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coberturas != null && message.hasOwnProperty("coberturas")) {
                if (!Array.isArray(message.coberturas))
                    return "coberturas: array expected";
                for (let i = 0; i < message.coberturas.length; ++i) {
                    let error = $root.mirana.CoberturaAcumulada.verify(message.coberturas[i]);
                    if (error)
                        return "coberturas." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CoberturasAcumuladasList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.CoberturasAcumuladasList} CoberturasAcumuladasList
         */
        CoberturasAcumuladasList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.CoberturasAcumuladasList)
                return object;
            let message = new $root.mirana.CoberturasAcumuladasList();
            if (object.coberturas) {
                if (!Array.isArray(object.coberturas))
                    throw TypeError(".mirana.CoberturasAcumuladasList.coberturas: array expected");
                message.coberturas = [];
                for (let i = 0; i < object.coberturas.length; ++i) {
                    if (typeof object.coberturas[i] !== "object")
                        throw TypeError(".mirana.CoberturasAcumuladasList.coberturas: object expected");
                    message.coberturas[i] = $root.mirana.CoberturaAcumulada.fromObject(object.coberturas[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CoberturasAcumuladasList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.CoberturasAcumuladasList
         * @static
         * @param {mirana.CoberturasAcumuladasList} message CoberturasAcumuladasList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoberturasAcumuladasList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coberturas = [];
            if (message.coberturas && message.coberturas.length) {
                object.coberturas = [];
                for (let j = 0; j < message.coberturas.length; ++j)
                    object.coberturas[j] = $root.mirana.CoberturaAcumulada.toObject(message.coberturas[j], options);
            }
            return object;
        };

        /**
         * Converts this CoberturasAcumuladasList to JSON.
         * @function toJSON
         * @memberof mirana.CoberturasAcumuladasList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoberturasAcumuladasList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoberturasAcumuladasList;
    })();

    mirana.PreventasList = (function() {

        /**
         * Properties of a PreventasList.
         * @memberof mirana
         * @interface IPreventasList
         * @property {Array.<mirana.IPreventa>|null} [preventas] PreventasList preventas
         */

        /**
         * Constructs a new PreventasList.
         * @memberof mirana
         * @classdesc Represents a PreventasList.
         * @implements IPreventasList
         * @constructor
         * @param {mirana.IPreventasList=} [properties] Properties to set
         */
        function PreventasList(properties) {
            this.preventas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PreventasList preventas.
         * @member {Array.<mirana.IPreventa>} preventas
         * @memberof mirana.PreventasList
         * @instance
         */
        PreventasList.prototype.preventas = $util.emptyArray;

        /**
         * Creates a new PreventasList instance using the specified properties.
         * @function create
         * @memberof mirana.PreventasList
         * @static
         * @param {mirana.IPreventasList=} [properties] Properties to set
         * @returns {mirana.PreventasList} PreventasList instance
         */
        PreventasList.create = function create(properties) {
            return new PreventasList(properties);
        };

        /**
         * Encodes the specified PreventasList message. Does not implicitly {@link mirana.PreventasList.verify|verify} messages.
         * @function encode
         * @memberof mirana.PreventasList
         * @static
         * @param {mirana.IPreventasList} message PreventasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreventasList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.preventas != null && message.preventas.length)
                for (let i = 0; i < message.preventas.length; ++i)
                    $root.mirana.Preventa.encode(message.preventas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PreventasList message, length delimited. Does not implicitly {@link mirana.PreventasList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.PreventasList
         * @static
         * @param {mirana.IPreventasList} message PreventasList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreventasList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PreventasList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.PreventasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.PreventasList} PreventasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreventasList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.PreventasList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.preventas && message.preventas.length))
                        message.preventas = [];
                    message.preventas.push($root.mirana.Preventa.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PreventasList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.PreventasList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.PreventasList} PreventasList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreventasList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PreventasList message.
         * @function verify
         * @memberof mirana.PreventasList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PreventasList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.preventas != null && message.hasOwnProperty("preventas")) {
                if (!Array.isArray(message.preventas))
                    return "preventas: array expected";
                for (let i = 0; i < message.preventas.length; ++i) {
                    let error = $root.mirana.Preventa.verify(message.preventas[i]);
                    if (error)
                        return "preventas." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PreventasList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.PreventasList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.PreventasList} PreventasList
         */
        PreventasList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.PreventasList)
                return object;
            let message = new $root.mirana.PreventasList();
            if (object.preventas) {
                if (!Array.isArray(object.preventas))
                    throw TypeError(".mirana.PreventasList.preventas: array expected");
                message.preventas = [];
                for (let i = 0; i < object.preventas.length; ++i) {
                    if (typeof object.preventas[i] !== "object")
                        throw TypeError(".mirana.PreventasList.preventas: object expected");
                    message.preventas[i] = $root.mirana.Preventa.fromObject(object.preventas[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PreventasList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.PreventasList
         * @static
         * @param {mirana.PreventasList} message PreventasList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PreventasList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.preventas = [];
            if (message.preventas && message.preventas.length) {
                object.preventas = [];
                for (let j = 0; j < message.preventas.length; ++j)
                    object.preventas[j] = $root.mirana.Preventa.toObject(message.preventas[j], options);
            }
            return object;
        };

        /**
         * Converts this PreventasList to JSON.
         * @function toJSON
         * @memberof mirana.PreventasList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PreventasList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PreventasList;
    })();

    mirana.IndicadoresList = (function() {

        /**
         * Properties of an IndicadoresList.
         * @memberof mirana
         * @interface IIndicadoresList
         * @property {Array.<mirana.IIndicador>|null} [indicadores] IndicadoresList indicadores
         */

        /**
         * Constructs a new IndicadoresList.
         * @memberof mirana
         * @classdesc Represents an IndicadoresList.
         * @implements IIndicadoresList
         * @constructor
         * @param {mirana.IIndicadoresList=} [properties] Properties to set
         */
        function IndicadoresList(properties) {
            this.indicadores = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IndicadoresList indicadores.
         * @member {Array.<mirana.IIndicador>} indicadores
         * @memberof mirana.IndicadoresList
         * @instance
         */
        IndicadoresList.prototype.indicadores = $util.emptyArray;

        /**
         * Creates a new IndicadoresList instance using the specified properties.
         * @function create
         * @memberof mirana.IndicadoresList
         * @static
         * @param {mirana.IIndicadoresList=} [properties] Properties to set
         * @returns {mirana.IndicadoresList} IndicadoresList instance
         */
        IndicadoresList.create = function create(properties) {
            return new IndicadoresList(properties);
        };

        /**
         * Encodes the specified IndicadoresList message. Does not implicitly {@link mirana.IndicadoresList.verify|verify} messages.
         * @function encode
         * @memberof mirana.IndicadoresList
         * @static
         * @param {mirana.IIndicadoresList} message IndicadoresList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IndicadoresList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.indicadores != null && message.indicadores.length)
                for (let i = 0; i < message.indicadores.length; ++i)
                    $root.mirana.Indicador.encode(message.indicadores[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified IndicadoresList message, length delimited. Does not implicitly {@link mirana.IndicadoresList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.IndicadoresList
         * @static
         * @param {mirana.IIndicadoresList} message IndicadoresList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IndicadoresList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IndicadoresList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.IndicadoresList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.IndicadoresList} IndicadoresList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IndicadoresList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.IndicadoresList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.indicadores && message.indicadores.length))
                        message.indicadores = [];
                    message.indicadores.push($root.mirana.Indicador.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IndicadoresList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.IndicadoresList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.IndicadoresList} IndicadoresList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IndicadoresList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IndicadoresList message.
         * @function verify
         * @memberof mirana.IndicadoresList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IndicadoresList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.indicadores != null && message.hasOwnProperty("indicadores")) {
                if (!Array.isArray(message.indicadores))
                    return "indicadores: array expected";
                for (let i = 0; i < message.indicadores.length; ++i) {
                    let error = $root.mirana.Indicador.verify(message.indicadores[i]);
                    if (error)
                        return "indicadores." + error;
                }
            }
            return null;
        };

        /**
         * Creates an IndicadoresList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.IndicadoresList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.IndicadoresList} IndicadoresList
         */
        IndicadoresList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.IndicadoresList)
                return object;
            let message = new $root.mirana.IndicadoresList();
            if (object.indicadores) {
                if (!Array.isArray(object.indicadores))
                    throw TypeError(".mirana.IndicadoresList.indicadores: array expected");
                message.indicadores = [];
                for (let i = 0; i < object.indicadores.length; ++i) {
                    if (typeof object.indicadores[i] !== "object")
                        throw TypeError(".mirana.IndicadoresList.indicadores: object expected");
                    message.indicadores[i] = $root.mirana.Indicador.fromObject(object.indicadores[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an IndicadoresList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.IndicadoresList
         * @static
         * @param {mirana.IndicadoresList} message IndicadoresList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IndicadoresList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.indicadores = [];
            if (message.indicadores && message.indicadores.length) {
                object.indicadores = [];
                for (let j = 0; j < message.indicadores.length; ++j)
                    object.indicadores[j] = $root.mirana.Indicador.toObject(message.indicadores[j], options);
            }
            return object;
        };

        /**
         * Converts this IndicadoresList to JSON.
         * @function toJSON
         * @memberof mirana.IndicadoresList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IndicadoresList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IndicadoresList;
    })();

    mirana.TdosService = (function() {

        /**
         * Constructs a new TdosService service.
         * @memberof mirana
         * @classdesc Represents a TdosService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function TdosService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (TdosService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = TdosService;

        /**
         * Creates new TdosService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.TdosService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {TdosService} RPC service. Useful where requests and/or responses are streamed.
         */
        TdosService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.TdosService#syncPreventa}.
         * @memberof mirana.TdosService
         * @typedef syncPreventaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncPreventa.
         * @function syncPreventa
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.IPreventaRequest} request PreventaRequest message or plain object
         * @param {mirana.TdosService.syncPreventaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        TdosService.prototype.syncPreventa = function syncPreventa(request, callback) {
            return this.rpcCall(syncPreventa, $root.mirana.PreventaRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncPreventa.
         * @function syncPreventa
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.IPreventaRequest} request PreventaRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.TdosService#syncCoberturaAcumulada}.
         * @memberof mirana.TdosService
         * @typedef syncCoberturaAcumuladaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncCoberturaAcumulada.
         * @function syncCoberturaAcumulada
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.ICoberturaAcumuladaRequest} request CoberturaAcumuladaRequest message or plain object
         * @param {mirana.TdosService.syncCoberturaAcumuladaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        TdosService.prototype.syncCoberturaAcumulada = function syncCoberturaAcumulada(request, callback) {
            return this.rpcCall(syncCoberturaAcumulada, $root.mirana.CoberturaAcumuladaRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncCoberturaAcumulada.
         * @function syncCoberturaAcumulada
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.ICoberturaAcumuladaRequest} request CoberturaAcumuladaRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.TdosService#syncIndicadores}.
         * @memberof mirana.TdosService
         * @typedef syncIndicadoresCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncIndicadores.
         * @function syncIndicadores
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.IIndicadorRequest} request IndicadorRequest message or plain object
         * @param {mirana.TdosService.syncIndicadoresCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        TdosService.prototype.syncIndicadores = function syncIndicadores(request, callback) {
            return this.rpcCall(syncIndicadores, $root.mirana.IndicadorRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncIndicadores.
         * @function syncIndicadores
         * @memberof mirana.TdosService
         * @instance
         * @param {mirana.IIndicadorRequest} request IndicadorRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return TdosService;
    })();

    mirana.Rechazo = (function() {

        /**
         * Properties of a Rechazo.
         * @memberof mirana
         * @interface IRechazo
         * @property {string|null} [fuerzaVentaId] Rechazo fuerzaVentaId
         * @property {string|null} [mesaId] Rechazo mesaId
         * @property {string|null} [vendedorId] Rechazo vendedorId
         * @property {string|null} [rutaId] Rechazo rutaId
         * @property {string|null} [rutaDespachoId] Rechazo rutaDespachoId
         * @property {string|null} [motivoAnulacionId] Rechazo motivoAnulacionId
         * @property {string|null} [fechaRechazo] Rechazo fechaRechazo
         * @property {string|null} [numeroDocumento] Rechazo numeroDocumento
         * @property {string|null} [codigo] Rechazo codigo
         * @property {string|null} [razonSocial] Rechazo razonSocial
         * @property {number|null} [monto] Rechazo monto
         * @property {string|null} [fechaCarga] Rechazo fechaCarga
         */

        /**
         * Constructs a new Rechazo.
         * @memberof mirana
         * @classdesc Represents a Rechazo.
         * @implements IRechazo
         * @constructor
         * @param {mirana.IRechazo=} [properties] Properties to set
         */
        function Rechazo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Rechazo fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.fuerzaVentaId = "";

        /**
         * Rechazo mesaId.
         * @member {string} mesaId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.mesaId = "";

        /**
         * Rechazo vendedorId.
         * @member {string} vendedorId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.vendedorId = "";

        /**
         * Rechazo rutaId.
         * @member {string} rutaId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.rutaId = "";

        /**
         * Rechazo rutaDespachoId.
         * @member {string} rutaDespachoId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.rutaDespachoId = "";

        /**
         * Rechazo motivoAnulacionId.
         * @member {string} motivoAnulacionId
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.motivoAnulacionId = "";

        /**
         * Rechazo fechaRechazo.
         * @member {string} fechaRechazo
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.fechaRechazo = "";

        /**
         * Rechazo numeroDocumento.
         * @member {string} numeroDocumento
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.numeroDocumento = "";

        /**
         * Rechazo codigo.
         * @member {string} codigo
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.codigo = "";

        /**
         * Rechazo razonSocial.
         * @member {string} razonSocial
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.razonSocial = "";

        /**
         * Rechazo monto.
         * @member {number} monto
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.monto = 0;

        /**
         * Rechazo fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.Rechazo
         * @instance
         */
        Rechazo.prototype.fechaCarga = "";

        /**
         * Creates a new Rechazo instance using the specified properties.
         * @function create
         * @memberof mirana.Rechazo
         * @static
         * @param {mirana.IRechazo=} [properties] Properties to set
         * @returns {mirana.Rechazo} Rechazo instance
         */
        Rechazo.create = function create(properties) {
            return new Rechazo(properties);
        };

        /**
         * Encodes the specified Rechazo message. Does not implicitly {@link mirana.Rechazo.verify|verify} messages.
         * @function encode
         * @memberof mirana.Rechazo
         * @static
         * @param {mirana.IRechazo} message Rechazo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Rechazo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fuerzaVentaId);
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mesaId);
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.vendedorId);
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.rutaId);
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.rutaDespachoId);
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.motivoAnulacionId);
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.fechaRechazo);
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.numeroDocumento);
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.codigo);
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.razonSocial);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.monto);
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.fechaCarga);
            return writer;
        };

        /**
         * Encodes the specified Rechazo message, length delimited. Does not implicitly {@link mirana.Rechazo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Rechazo
         * @static
         * @param {mirana.IRechazo} message Rechazo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Rechazo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Rechazo message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Rechazo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Rechazo} Rechazo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Rechazo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Rechazo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 2:
                    message.mesaId = reader.string();
                    break;
                case 3:
                    message.vendedorId = reader.string();
                    break;
                case 4:
                    message.rutaId = reader.string();
                    break;
                case 5:
                    message.rutaDespachoId = reader.string();
                    break;
                case 6:
                    message.motivoAnulacionId = reader.string();
                    break;
                case 7:
                    message.fechaRechazo = reader.string();
                    break;
                case 8:
                    message.numeroDocumento = reader.string();
                    break;
                case 9:
                    message.codigo = reader.string();
                    break;
                case 10:
                    message.razonSocial = reader.string();
                    break;
                case 11:
                    message.monto = reader.double();
                    break;
                case 12:
                    message.fechaCarga = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Rechazo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Rechazo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Rechazo} Rechazo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Rechazo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Rechazo message.
         * @function verify
         * @memberof mirana.Rechazo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Rechazo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                if (!$util.isString(message.vendedorId))
                    return "vendedorId: string expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                if (!$util.isString(message.rutaDespachoId))
                    return "rutaDespachoId: string expected";
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                if (!$util.isString(message.motivoAnulacionId))
                    return "motivoAnulacionId: string expected";
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                if (!$util.isString(message.fechaRechazo))
                    return "fechaRechazo: string expected";
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                if (!$util.isString(message.numeroDocumento))
                    return "numeroDocumento: string expected";
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                if (!$util.isString(message.codigo))
                    return "codigo: string expected";
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                if (!$util.isString(message.razonSocial))
                    return "razonSocial: string expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            return null;
        };

        /**
         * Creates a Rechazo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Rechazo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Rechazo} Rechazo
         */
        Rechazo.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Rechazo)
                return object;
            let message = new $root.mirana.Rechazo();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.vendedorId != null)
                message.vendedorId = String(object.vendedorId);
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.rutaDespachoId != null)
                message.rutaDespachoId = String(object.rutaDespachoId);
            if (object.motivoAnulacionId != null)
                message.motivoAnulacionId = String(object.motivoAnulacionId);
            if (object.fechaRechazo != null)
                message.fechaRechazo = String(object.fechaRechazo);
            if (object.numeroDocumento != null)
                message.numeroDocumento = String(object.numeroDocumento);
            if (object.codigo != null)
                message.codigo = String(object.codigo);
            if (object.razonSocial != null)
                message.razonSocial = String(object.razonSocial);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            return message;
        };

        /**
         * Creates a plain object from a Rechazo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Rechazo
         * @static
         * @param {mirana.Rechazo} message Rechazo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Rechazo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fuerzaVentaId = "";
                object.mesaId = "";
                object.vendedorId = "";
                object.rutaId = "";
                object.rutaDespachoId = "";
                object.motivoAnulacionId = "";
                object.fechaRechazo = "";
                object.numeroDocumento = "";
                object.codigo = "";
                object.razonSocial = "";
                object.monto = 0;
                object.fechaCarga = "";
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                object.vendedorId = message.vendedorId;
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                object.rutaDespachoId = message.rutaDespachoId;
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                object.motivoAnulacionId = message.motivoAnulacionId;
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                object.fechaRechazo = message.fechaRechazo;
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                object.numeroDocumento = message.numeroDocumento;
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                object.codigo = message.codigo;
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                object.razonSocial = message.razonSocial;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            return object;
        };

        /**
         * Converts this Rechazo to JSON.
         * @function toJSON
         * @memberof mirana.Rechazo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Rechazo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Rechazo;
    })();

    mirana.UIRechazo = (function() {

        /**
         * Properties of a UIRechazo.
         * @memberof mirana
         * @interface IUIRechazo
         * @property {string|null} [fuerzaVenta] UIRechazo fuerzaVenta
         * @property {string|null} [fechaRechazo] UIRechazo fechaRechazo
         * @property {string|null} [mesa] UIRechazo mesa
         * @property {string|null} [vendedor] UIRechazo vendedor
         * @property {string|null} [rutaDespacho] UIRechazo rutaDespacho
         * @property {string|null} [numeroDocumento] UIRechazo numeroDocumento
         * @property {string|null} [codigo] UIRechazo codigo
         * @property {string|null} [razonSocial] UIRechazo razonSocial
         * @property {number|null} [monto] UIRechazo monto
         * @property {string|null} [motivoAnulacion] UIRechazo motivoAnulacion
         * @property {string|null} [ruta] UIRechazo ruta
         */

        /**
         * Constructs a new UIRechazo.
         * @memberof mirana
         * @classdesc Represents a UIRechazo.
         * @implements IUIRechazo
         * @constructor
         * @param {mirana.IUIRechazo=} [properties] Properties to set
         */
        function UIRechazo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UIRechazo fuerzaVenta.
         * @member {string} fuerzaVenta
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.fuerzaVenta = "";

        /**
         * UIRechazo fechaRechazo.
         * @member {string} fechaRechazo
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.fechaRechazo = "";

        /**
         * UIRechazo mesa.
         * @member {string} mesa
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.mesa = "";

        /**
         * UIRechazo vendedor.
         * @member {string} vendedor
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.vendedor = "";

        /**
         * UIRechazo rutaDespacho.
         * @member {string} rutaDespacho
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.rutaDespacho = "";

        /**
         * UIRechazo numeroDocumento.
         * @member {string} numeroDocumento
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.numeroDocumento = "";

        /**
         * UIRechazo codigo.
         * @member {string} codigo
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.codigo = "";

        /**
         * UIRechazo razonSocial.
         * @member {string} razonSocial
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.razonSocial = "";

        /**
         * UIRechazo monto.
         * @member {number} monto
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.monto = 0;

        /**
         * UIRechazo motivoAnulacion.
         * @member {string} motivoAnulacion
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.motivoAnulacion = "";

        /**
         * UIRechazo ruta.
         * @member {string} ruta
         * @memberof mirana.UIRechazo
         * @instance
         */
        UIRechazo.prototype.ruta = "";

        /**
         * Creates a new UIRechazo instance using the specified properties.
         * @function create
         * @memberof mirana.UIRechazo
         * @static
         * @param {mirana.IUIRechazo=} [properties] Properties to set
         * @returns {mirana.UIRechazo} UIRechazo instance
         */
        UIRechazo.create = function create(properties) {
            return new UIRechazo(properties);
        };

        /**
         * Encodes the specified UIRechazo message. Does not implicitly {@link mirana.UIRechazo.verify|verify} messages.
         * @function encode
         * @memberof mirana.UIRechazo
         * @static
         * @param {mirana.IUIRechazo} message UIRechazo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIRechazo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fuerzaVenta);
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fechaRechazo);
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mesa);
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.vendedor);
            if (message.rutaDespacho != null && message.hasOwnProperty("rutaDespacho"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.rutaDespacho);
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.numeroDocumento);
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.codigo);
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.razonSocial);
            if (message.monto != null && message.hasOwnProperty("monto"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.monto);
            if (message.motivoAnulacion != null && message.hasOwnProperty("motivoAnulacion"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.motivoAnulacion);
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.ruta);
            return writer;
        };

        /**
         * Encodes the specified UIRechazo message, length delimited. Does not implicitly {@link mirana.UIRechazo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.UIRechazo
         * @static
         * @param {mirana.IUIRechazo} message UIRechazo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UIRechazo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UIRechazo message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.UIRechazo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.UIRechazo} UIRechazo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIRechazo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.UIRechazo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuerzaVenta = reader.string();
                    break;
                case 2:
                    message.fechaRechazo = reader.string();
                    break;
                case 3:
                    message.mesa = reader.string();
                    break;
                case 4:
                    message.vendedor = reader.string();
                    break;
                case 5:
                    message.rutaDespacho = reader.string();
                    break;
                case 6:
                    message.numeroDocumento = reader.string();
                    break;
                case 7:
                    message.codigo = reader.string();
                    break;
                case 8:
                    message.razonSocial = reader.string();
                    break;
                case 9:
                    message.monto = reader.double();
                    break;
                case 10:
                    message.motivoAnulacion = reader.string();
                    break;
                case 11:
                    message.ruta = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UIRechazo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.UIRechazo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.UIRechazo} UIRechazo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UIRechazo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UIRechazo message.
         * @function verify
         * @memberof mirana.UIRechazo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UIRechazo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                if (!$util.isString(message.fuerzaVenta))
                    return "fuerzaVenta: string expected";
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                if (!$util.isString(message.fechaRechazo))
                    return "fechaRechazo: string expected";
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                if (!$util.isString(message.mesa))
                    return "mesa: string expected";
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                if (!$util.isString(message.vendedor))
                    return "vendedor: string expected";
            if (message.rutaDespacho != null && message.hasOwnProperty("rutaDespacho"))
                if (!$util.isString(message.rutaDespacho))
                    return "rutaDespacho: string expected";
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                if (!$util.isString(message.numeroDocumento))
                    return "numeroDocumento: string expected";
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                if (!$util.isString(message.codigo))
                    return "codigo: string expected";
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                if (!$util.isString(message.razonSocial))
                    return "razonSocial: string expected";
            if (message.monto != null && message.hasOwnProperty("monto"))
                if (typeof message.monto !== "number")
                    return "monto: number expected";
            if (message.motivoAnulacion != null && message.hasOwnProperty("motivoAnulacion"))
                if (!$util.isString(message.motivoAnulacion))
                    return "motivoAnulacion: string expected";
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                if (!$util.isString(message.ruta))
                    return "ruta: string expected";
            return null;
        };

        /**
         * Creates a UIRechazo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.UIRechazo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.UIRechazo} UIRechazo
         */
        UIRechazo.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.UIRechazo)
                return object;
            let message = new $root.mirana.UIRechazo();
            if (object.fuerzaVenta != null)
                message.fuerzaVenta = String(object.fuerzaVenta);
            if (object.fechaRechazo != null)
                message.fechaRechazo = String(object.fechaRechazo);
            if (object.mesa != null)
                message.mesa = String(object.mesa);
            if (object.vendedor != null)
                message.vendedor = String(object.vendedor);
            if (object.rutaDespacho != null)
                message.rutaDespacho = String(object.rutaDespacho);
            if (object.numeroDocumento != null)
                message.numeroDocumento = String(object.numeroDocumento);
            if (object.codigo != null)
                message.codigo = String(object.codigo);
            if (object.razonSocial != null)
                message.razonSocial = String(object.razonSocial);
            if (object.monto != null)
                message.monto = Number(object.monto);
            if (object.motivoAnulacion != null)
                message.motivoAnulacion = String(object.motivoAnulacion);
            if (object.ruta != null)
                message.ruta = String(object.ruta);
            return message;
        };

        /**
         * Creates a plain object from a UIRechazo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.UIRechazo
         * @static
         * @param {mirana.UIRechazo} message UIRechazo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UIRechazo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fuerzaVenta = "";
                object.fechaRechazo = "";
                object.mesa = "";
                object.vendedor = "";
                object.rutaDespacho = "";
                object.numeroDocumento = "";
                object.codigo = "";
                object.razonSocial = "";
                object.monto = 0;
                object.motivoAnulacion = "";
                object.ruta = "";
            }
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                object.fuerzaVenta = message.fuerzaVenta;
            if (message.fechaRechazo != null && message.hasOwnProperty("fechaRechazo"))
                object.fechaRechazo = message.fechaRechazo;
            if (message.mesa != null && message.hasOwnProperty("mesa"))
                object.mesa = message.mesa;
            if (message.vendedor != null && message.hasOwnProperty("vendedor"))
                object.vendedor = message.vendedor;
            if (message.rutaDespacho != null && message.hasOwnProperty("rutaDespacho"))
                object.rutaDespacho = message.rutaDespacho;
            if (message.numeroDocumento != null && message.hasOwnProperty("numeroDocumento"))
                object.numeroDocumento = message.numeroDocumento;
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                object.codigo = message.codigo;
            if (message.razonSocial != null && message.hasOwnProperty("razonSocial"))
                object.razonSocial = message.razonSocial;
            if (message.monto != null && message.hasOwnProperty("monto"))
                object.monto = options.json && !isFinite(message.monto) ? String(message.monto) : message.monto;
            if (message.motivoAnulacion != null && message.hasOwnProperty("motivoAnulacion"))
                object.motivoAnulacion = message.motivoAnulacion;
            if (message.ruta != null && message.hasOwnProperty("ruta"))
                object.ruta = message.ruta;
            return object;
        };

        /**
         * Converts this UIRechazo to JSON.
         * @function toJSON
         * @memberof mirana.UIRechazo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UIRechazo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UIRechazo;
    })();

    mirana.FiltrarRechazoResponse = (function() {

        /**
         * Properties of a FiltrarRechazoResponse.
         * @memberof mirana
         * @interface IFiltrarRechazoResponse
         * @property {Array.<mirana.IUIRechazo>|null} [rechazos] FiltrarRechazoResponse rechazos
         * @property {string|null} [fuerzaVenta] FiltrarRechazoResponse fuerzaVenta
         * @property {number|null} [total] FiltrarRechazoResponse total
         */

        /**
         * Constructs a new FiltrarRechazoResponse.
         * @memberof mirana
         * @classdesc Represents a FiltrarRechazoResponse.
         * @implements IFiltrarRechazoResponse
         * @constructor
         * @param {mirana.IFiltrarRechazoResponse=} [properties] Properties to set
         */
        function FiltrarRechazoResponse(properties) {
            this.rechazos = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FiltrarRechazoResponse rechazos.
         * @member {Array.<mirana.IUIRechazo>} rechazos
         * @memberof mirana.FiltrarRechazoResponse
         * @instance
         */
        FiltrarRechazoResponse.prototype.rechazos = $util.emptyArray;

        /**
         * FiltrarRechazoResponse fuerzaVenta.
         * @member {string} fuerzaVenta
         * @memberof mirana.FiltrarRechazoResponse
         * @instance
         */
        FiltrarRechazoResponse.prototype.fuerzaVenta = "";

        /**
         * FiltrarRechazoResponse total.
         * @member {number} total
         * @memberof mirana.FiltrarRechazoResponse
         * @instance
         */
        FiltrarRechazoResponse.prototype.total = 0;

        /**
         * Creates a new FiltrarRechazoResponse instance using the specified properties.
         * @function create
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {mirana.IFiltrarRechazoResponse=} [properties] Properties to set
         * @returns {mirana.FiltrarRechazoResponse} FiltrarRechazoResponse instance
         */
        FiltrarRechazoResponse.create = function create(properties) {
            return new FiltrarRechazoResponse(properties);
        };

        /**
         * Encodes the specified FiltrarRechazoResponse message. Does not implicitly {@link mirana.FiltrarRechazoResponse.verify|verify} messages.
         * @function encode
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {mirana.IFiltrarRechazoResponse} message FiltrarRechazoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarRechazoResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rechazos != null && message.rechazos.length)
                for (let i = 0; i < message.rechazos.length; ++i)
                    $root.mirana.UIRechazo.encode(message.rechazos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fuerzaVenta);
            if (message.total != null && message.hasOwnProperty("total"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.total);
            return writer;
        };

        /**
         * Encodes the specified FiltrarRechazoResponse message, length delimited. Does not implicitly {@link mirana.FiltrarRechazoResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {mirana.IFiltrarRechazoResponse} message FiltrarRechazoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FiltrarRechazoResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FiltrarRechazoResponse message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FiltrarRechazoResponse} FiltrarRechazoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarRechazoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FiltrarRechazoResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.rechazos && message.rechazos.length))
                        message.rechazos = [];
                    message.rechazos.push($root.mirana.UIRechazo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fuerzaVenta = reader.string();
                    break;
                case 3:
                    message.total = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FiltrarRechazoResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FiltrarRechazoResponse} FiltrarRechazoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FiltrarRechazoResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FiltrarRechazoResponse message.
         * @function verify
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FiltrarRechazoResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rechazos != null && message.hasOwnProperty("rechazos")) {
                if (!Array.isArray(message.rechazos))
                    return "rechazos: array expected";
                for (let i = 0; i < message.rechazos.length; ++i) {
                    let error = $root.mirana.UIRechazo.verify(message.rechazos[i]);
                    if (error)
                        return "rechazos." + error;
                }
            }
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                if (!$util.isString(message.fuerzaVenta))
                    return "fuerzaVenta: string expected";
            if (message.total != null && message.hasOwnProperty("total"))
                if (typeof message.total !== "number")
                    return "total: number expected";
            return null;
        };

        /**
         * Creates a FiltrarRechazoResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FiltrarRechazoResponse} FiltrarRechazoResponse
         */
        FiltrarRechazoResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FiltrarRechazoResponse)
                return object;
            let message = new $root.mirana.FiltrarRechazoResponse();
            if (object.rechazos) {
                if (!Array.isArray(object.rechazos))
                    throw TypeError(".mirana.FiltrarRechazoResponse.rechazos: array expected");
                message.rechazos = [];
                for (let i = 0; i < object.rechazos.length; ++i) {
                    if (typeof object.rechazos[i] !== "object")
                        throw TypeError(".mirana.FiltrarRechazoResponse.rechazos: object expected");
                    message.rechazos[i] = $root.mirana.UIRechazo.fromObject(object.rechazos[i]);
                }
            }
            if (object.fuerzaVenta != null)
                message.fuerzaVenta = String(object.fuerzaVenta);
            if (object.total != null)
                message.total = Number(object.total);
            return message;
        };

        /**
         * Creates a plain object from a FiltrarRechazoResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FiltrarRechazoResponse
         * @static
         * @param {mirana.FiltrarRechazoResponse} message FiltrarRechazoResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FiltrarRechazoResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.rechazos = [];
            if (options.defaults) {
                object.fuerzaVenta = "";
                object.total = 0;
            }
            if (message.rechazos && message.rechazos.length) {
                object.rechazos = [];
                for (let j = 0; j < message.rechazos.length; ++j)
                    object.rechazos[j] = $root.mirana.UIRechazo.toObject(message.rechazos[j], options);
            }
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta"))
                object.fuerzaVenta = message.fuerzaVenta;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
            return object;
        };

        /**
         * Converts this FiltrarRechazoResponse to JSON.
         * @function toJSON
         * @memberof mirana.FiltrarRechazoResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FiltrarRechazoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FiltrarRechazoResponse;
    })();

    mirana.RechazoRequest = (function() {

        /**
         * Properties of a RechazoRequest.
         * @memberof mirana
         * @interface IRechazoRequest
         * @property {string|null} [fechaCarga] RechazoRequest fechaCarga
         * @property {Array.<mirana.IRechazo>|null} [rechazo] RechazoRequest rechazo
         */

        /**
         * Constructs a new RechazoRequest.
         * @memberof mirana
         * @classdesc Represents a RechazoRequest.
         * @implements IRechazoRequest
         * @constructor
         * @param {mirana.IRechazoRequest=} [properties] Properties to set
         */
        function RechazoRequest(properties) {
            this.rechazo = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RechazoRequest fechaCarga.
         * @member {string} fechaCarga
         * @memberof mirana.RechazoRequest
         * @instance
         */
        RechazoRequest.prototype.fechaCarga = "";

        /**
         * RechazoRequest rechazo.
         * @member {Array.<mirana.IRechazo>} rechazo
         * @memberof mirana.RechazoRequest
         * @instance
         */
        RechazoRequest.prototype.rechazo = $util.emptyArray;

        /**
         * Creates a new RechazoRequest instance using the specified properties.
         * @function create
         * @memberof mirana.RechazoRequest
         * @static
         * @param {mirana.IRechazoRequest=} [properties] Properties to set
         * @returns {mirana.RechazoRequest} RechazoRequest instance
         */
        RechazoRequest.create = function create(properties) {
            return new RechazoRequest(properties);
        };

        /**
         * Encodes the specified RechazoRequest message. Does not implicitly {@link mirana.RechazoRequest.verify|verify} messages.
         * @function encode
         * @memberof mirana.RechazoRequest
         * @static
         * @param {mirana.IRechazoRequest} message RechazoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechazoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fechaCarga);
            if (message.rechazo != null && message.rechazo.length)
                for (let i = 0; i < message.rechazo.length; ++i)
                    $root.mirana.Rechazo.encode(message.rechazo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RechazoRequest message, length delimited. Does not implicitly {@link mirana.RechazoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.RechazoRequest
         * @static
         * @param {mirana.IRechazoRequest} message RechazoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechazoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RechazoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.RechazoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.RechazoRequest} RechazoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechazoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.RechazoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fechaCarga = reader.string();
                    break;
                case 2:
                    if (!(message.rechazo && message.rechazo.length))
                        message.rechazo = [];
                    message.rechazo.push($root.mirana.Rechazo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RechazoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.RechazoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.RechazoRequest} RechazoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechazoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RechazoRequest message.
         * @function verify
         * @memberof mirana.RechazoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RechazoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                if (!$util.isString(message.fechaCarga))
                    return "fechaCarga: string expected";
            if (message.rechazo != null && message.hasOwnProperty("rechazo")) {
                if (!Array.isArray(message.rechazo))
                    return "rechazo: array expected";
                for (let i = 0; i < message.rechazo.length; ++i) {
                    let error = $root.mirana.Rechazo.verify(message.rechazo[i]);
                    if (error)
                        return "rechazo." + error;
                }
            }
            return null;
        };

        /**
         * Creates a RechazoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.RechazoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.RechazoRequest} RechazoRequest
         */
        RechazoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.RechazoRequest)
                return object;
            let message = new $root.mirana.RechazoRequest();
            if (object.fechaCarga != null)
                message.fechaCarga = String(object.fechaCarga);
            if (object.rechazo) {
                if (!Array.isArray(object.rechazo))
                    throw TypeError(".mirana.RechazoRequest.rechazo: array expected");
                message.rechazo = [];
                for (let i = 0; i < object.rechazo.length; ++i) {
                    if (typeof object.rechazo[i] !== "object")
                        throw TypeError(".mirana.RechazoRequest.rechazo: object expected");
                    message.rechazo[i] = $root.mirana.Rechazo.fromObject(object.rechazo[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a RechazoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.RechazoRequest
         * @static
         * @param {mirana.RechazoRequest} message RechazoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RechazoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.rechazo = [];
            if (options.defaults)
                object.fechaCarga = "";
            if (message.fechaCarga != null && message.hasOwnProperty("fechaCarga"))
                object.fechaCarga = message.fechaCarga;
            if (message.rechazo && message.rechazo.length) {
                object.rechazo = [];
                for (let j = 0; j < message.rechazo.length; ++j)
                    object.rechazo[j] = $root.mirana.Rechazo.toObject(message.rechazo[j], options);
            }
            return object;
        };

        /**
         * Converts this RechazoRequest to JSON.
         * @function toJSON
         * @memberof mirana.RechazoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RechazoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RechazoRequest;
    })();

    mirana.RechazoService = (function() {

        /**
         * Constructs a new RechazoService service.
         * @memberof mirana
         * @classdesc Represents a RechazoService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function RechazoService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (RechazoService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RechazoService;

        /**
         * Creates new RechazoService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.RechazoService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {RechazoService} RPC service. Useful where requests and/or responses are streamed.
         */
        RechazoService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.RechazoService#syncRechazos}.
         * @memberof mirana.RechazoService
         * @typedef syncRechazosCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncRechazos.
         * @function syncRechazos
         * @memberof mirana.RechazoService
         * @instance
         * @param {mirana.IRechazoRequest} request RechazoRequest message or plain object
         * @param {mirana.RechazoService.syncRechazosCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        RechazoService.prototype.syncRechazos = function syncRechazos(request, callback) {
            return this.rpcCall(syncRechazos, $root.mirana.RechazoRequest, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncRechazos.
         * @function syncRechazos
         * @memberof mirana.RechazoService
         * @instance
         * @param {mirana.IRechazoRequest} request RechazoRequest message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return RechazoService;
    })();

    mirana.FuerzaVenta = (function() {

        /**
         * Properties of a FuerzaVenta.
         * @memberof mirana
         * @interface IFuerzaVenta
         * @property {string|null} [fuerzaVentaId] FuerzaVenta fuerzaVentaId
         * @property {string|null} [descripcion] FuerzaVenta descripcion
         */

        /**
         * Constructs a new FuerzaVenta.
         * @memberof mirana
         * @classdesc Represents a FuerzaVenta.
         * @implements IFuerzaVenta
         * @constructor
         * @param {mirana.IFuerzaVenta=} [properties] Properties to set
         */
        function FuerzaVenta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FuerzaVenta fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.FuerzaVenta
         * @instance
         */
        FuerzaVenta.prototype.fuerzaVentaId = "";

        /**
         * FuerzaVenta descripcion.
         * @member {string} descripcion
         * @memberof mirana.FuerzaVenta
         * @instance
         */
        FuerzaVenta.prototype.descripcion = "";

        /**
         * Creates a new FuerzaVenta instance using the specified properties.
         * @function create
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {mirana.IFuerzaVenta=} [properties] Properties to set
         * @returns {mirana.FuerzaVenta} FuerzaVenta instance
         */
        FuerzaVenta.create = function create(properties) {
            return new FuerzaVenta(properties);
        };

        /**
         * Encodes the specified FuerzaVenta message. Does not implicitly {@link mirana.FuerzaVenta.verify|verify} messages.
         * @function encode
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {mirana.IFuerzaVenta} message FuerzaVenta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FuerzaVenta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fuerzaVentaId);
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.descripcion);
            return writer;
        };

        /**
         * Encodes the specified FuerzaVenta message, length delimited. Does not implicitly {@link mirana.FuerzaVenta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {mirana.IFuerzaVenta} message FuerzaVenta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FuerzaVenta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FuerzaVenta message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FuerzaVenta} FuerzaVenta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FuerzaVenta.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FuerzaVenta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 2:
                    message.descripcion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FuerzaVenta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FuerzaVenta} FuerzaVenta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FuerzaVenta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FuerzaVenta message.
         * @function verify
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FuerzaVenta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                if (!$util.isString(message.descripcion))
                    return "descripcion: string expected";
            return null;
        };

        /**
         * Creates a FuerzaVenta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FuerzaVenta} FuerzaVenta
         */
        FuerzaVenta.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FuerzaVenta)
                return object;
            let message = new $root.mirana.FuerzaVenta();
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.descripcion != null)
                message.descripcion = String(object.descripcion);
            return message;
        };

        /**
         * Creates a plain object from a FuerzaVenta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FuerzaVenta
         * @static
         * @param {mirana.FuerzaVenta} message FuerzaVenta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FuerzaVenta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fuerzaVentaId = "";
                object.descripcion = "";
            }
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                object.descripcion = message.descripcion;
            return object;
        };

        /**
         * Converts this FuerzaVenta to JSON.
         * @function toJSON
         * @memberof mirana.FuerzaVenta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FuerzaVenta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FuerzaVenta;
    })();

    mirana.Mesa = (function() {

        /**
         * Properties of a Mesa.
         * @memberof mirana
         * @interface IMesa
         * @property {string|null} [mesaId] Mesa mesaId
         * @property {string|null} [fuerzaVentaId] Mesa fuerzaVentaId
         * @property {string|null} [descripcion] Mesa descripcion
         */

        /**
         * Constructs a new Mesa.
         * @memberof mirana
         * @classdesc Represents a Mesa.
         * @implements IMesa
         * @constructor
         * @param {mirana.IMesa=} [properties] Properties to set
         */
        function Mesa(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Mesa mesaId.
         * @member {string} mesaId
         * @memberof mirana.Mesa
         * @instance
         */
        Mesa.prototype.mesaId = "";

        /**
         * Mesa fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.Mesa
         * @instance
         */
        Mesa.prototype.fuerzaVentaId = "";

        /**
         * Mesa descripcion.
         * @member {string} descripcion
         * @memberof mirana.Mesa
         * @instance
         */
        Mesa.prototype.descripcion = "";

        /**
         * Creates a new Mesa instance using the specified properties.
         * @function create
         * @memberof mirana.Mesa
         * @static
         * @param {mirana.IMesa=} [properties] Properties to set
         * @returns {mirana.Mesa} Mesa instance
         */
        Mesa.create = function create(properties) {
            return new Mesa(properties);
        };

        /**
         * Encodes the specified Mesa message. Does not implicitly {@link mirana.Mesa.verify|verify} messages.
         * @function encode
         * @memberof mirana.Mesa
         * @static
         * @param {mirana.IMesa} message Mesa message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Mesa.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mesaId);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fuerzaVentaId);
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.descripcion);
            return writer;
        };

        /**
         * Encodes the specified Mesa message, length delimited. Does not implicitly {@link mirana.Mesa.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Mesa
         * @static
         * @param {mirana.IMesa} message Mesa message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Mesa.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Mesa message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Mesa
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Mesa} Mesa
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Mesa.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Mesa();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mesaId = reader.string();
                    break;
                case 2:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 3:
                    message.descripcion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Mesa message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Mesa
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Mesa} Mesa
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Mesa.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Mesa message.
         * @function verify
         * @memberof mirana.Mesa
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Mesa.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                if (!$util.isString(message.descripcion))
                    return "descripcion: string expected";
            return null;
        };

        /**
         * Creates a Mesa message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Mesa
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Mesa} Mesa
         */
        Mesa.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Mesa)
                return object;
            let message = new $root.mirana.Mesa();
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.descripcion != null)
                message.descripcion = String(object.descripcion);
            return message;
        };

        /**
         * Creates a plain object from a Mesa message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Mesa
         * @static
         * @param {mirana.Mesa} message Mesa
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Mesa.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.mesaId = "";
                object.fuerzaVentaId = "";
                object.descripcion = "";
            }
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                object.descripcion = message.descripcion;
            return object;
        };

        /**
         * Converts this Mesa to JSON.
         * @function toJSON
         * @memberof mirana.Mesa
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Mesa.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Mesa;
    })();

    mirana.Vendedor = (function() {

        /**
         * Properties of a Vendedor.
         * @memberof mirana
         * @interface IVendedor
         * @property {string|null} [vendedorId] Vendedor vendedorId
         * @property {string|null} [nombre] Vendedor nombre
         */

        /**
         * Constructs a new Vendedor.
         * @memberof mirana
         * @classdesc Represents a Vendedor.
         * @implements IVendedor
         * @constructor
         * @param {mirana.IVendedor=} [properties] Properties to set
         */
        function Vendedor(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Vendedor vendedorId.
         * @member {string} vendedorId
         * @memberof mirana.Vendedor
         * @instance
         */
        Vendedor.prototype.vendedorId = "";

        /**
         * Vendedor nombre.
         * @member {string} nombre
         * @memberof mirana.Vendedor
         * @instance
         */
        Vendedor.prototype.nombre = "";

        /**
         * Creates a new Vendedor instance using the specified properties.
         * @function create
         * @memberof mirana.Vendedor
         * @static
         * @param {mirana.IVendedor=} [properties] Properties to set
         * @returns {mirana.Vendedor} Vendedor instance
         */
        Vendedor.create = function create(properties) {
            return new Vendedor(properties);
        };

        /**
         * Encodes the specified Vendedor message. Does not implicitly {@link mirana.Vendedor.verify|verify} messages.
         * @function encode
         * @memberof mirana.Vendedor
         * @static
         * @param {mirana.IVendedor} message Vendedor message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Vendedor.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.vendedorId);
            if (message.nombre != null && message.hasOwnProperty("nombre"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nombre);
            return writer;
        };

        /**
         * Encodes the specified Vendedor message, length delimited. Does not implicitly {@link mirana.Vendedor.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Vendedor
         * @static
         * @param {mirana.IVendedor} message Vendedor message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Vendedor.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Vendedor message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Vendedor
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Vendedor} Vendedor
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Vendedor.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Vendedor();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.vendedorId = reader.string();
                    break;
                case 2:
                    message.nombre = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Vendedor message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Vendedor
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Vendedor} Vendedor
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Vendedor.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Vendedor message.
         * @function verify
         * @memberof mirana.Vendedor
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Vendedor.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                if (!$util.isString(message.vendedorId))
                    return "vendedorId: string expected";
            if (message.nombre != null && message.hasOwnProperty("nombre"))
                if (!$util.isString(message.nombre))
                    return "nombre: string expected";
            return null;
        };

        /**
         * Creates a Vendedor message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Vendedor
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Vendedor} Vendedor
         */
        Vendedor.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Vendedor)
                return object;
            let message = new $root.mirana.Vendedor();
            if (object.vendedorId != null)
                message.vendedorId = String(object.vendedorId);
            if (object.nombre != null)
                message.nombre = String(object.nombre);
            return message;
        };

        /**
         * Creates a plain object from a Vendedor message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Vendedor
         * @static
         * @param {mirana.Vendedor} message Vendedor
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Vendedor.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.vendedorId = "";
                object.nombre = "";
            }
            if (message.vendedorId != null && message.hasOwnProperty("vendedorId"))
                object.vendedorId = message.vendedorId;
            if (message.nombre != null && message.hasOwnProperty("nombre"))
                object.nombre = message.nombre;
            return object;
        };

        /**
         * Converts this Vendedor to JSON.
         * @function toJSON
         * @memberof mirana.Vendedor
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Vendedor.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Vendedor;
    })();

    mirana.Ruta = (function() {

        /**
         * Properties of a Ruta.
         * @memberof mirana
         * @interface IRuta
         * @property {string|null} [rutaId] Ruta rutaId
         * @property {string|null} [mesaId] Ruta mesaId
         * @property {string|null} [fuerzaVentaId] Ruta fuerzaVentaId
         * @property {string|null} [codigo] Ruta codigo
         */

        /**
         * Constructs a new Ruta.
         * @memberof mirana
         * @classdesc Represents a Ruta.
         * @implements IRuta
         * @constructor
         * @param {mirana.IRuta=} [properties] Properties to set
         */
        function Ruta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Ruta rutaId.
         * @member {string} rutaId
         * @memberof mirana.Ruta
         * @instance
         */
        Ruta.prototype.rutaId = "";

        /**
         * Ruta mesaId.
         * @member {string} mesaId
         * @memberof mirana.Ruta
         * @instance
         */
        Ruta.prototype.mesaId = "";

        /**
         * Ruta fuerzaVentaId.
         * @member {string} fuerzaVentaId
         * @memberof mirana.Ruta
         * @instance
         */
        Ruta.prototype.fuerzaVentaId = "";

        /**
         * Ruta codigo.
         * @member {string} codigo
         * @memberof mirana.Ruta
         * @instance
         */
        Ruta.prototype.codigo = "";

        /**
         * Creates a new Ruta instance using the specified properties.
         * @function create
         * @memberof mirana.Ruta
         * @static
         * @param {mirana.IRuta=} [properties] Properties to set
         * @returns {mirana.Ruta} Ruta instance
         */
        Ruta.create = function create(properties) {
            return new Ruta(properties);
        };

        /**
         * Encodes the specified Ruta message. Does not implicitly {@link mirana.Ruta.verify|verify} messages.
         * @function encode
         * @memberof mirana.Ruta
         * @static
         * @param {mirana.IRuta} message Ruta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ruta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.rutaId);
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mesaId);
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fuerzaVentaId);
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.codigo);
            return writer;
        };

        /**
         * Encodes the specified Ruta message, length delimited. Does not implicitly {@link mirana.Ruta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.Ruta
         * @static
         * @param {mirana.IRuta} message Ruta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ruta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Ruta message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.Ruta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.Ruta} Ruta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ruta.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.Ruta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.rutaId = reader.string();
                    break;
                case 2:
                    message.mesaId = reader.string();
                    break;
                case 3:
                    message.fuerzaVentaId = reader.string();
                    break;
                case 4:
                    message.codigo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Ruta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.Ruta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.Ruta} Ruta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ruta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Ruta message.
         * @function verify
         * @memberof mirana.Ruta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Ruta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                if (!$util.isString(message.rutaId))
                    return "rutaId: string expected";
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                if (!$util.isString(message.mesaId))
                    return "mesaId: string expected";
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                if (!$util.isString(message.fuerzaVentaId))
                    return "fuerzaVentaId: string expected";
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                if (!$util.isString(message.codigo))
                    return "codigo: string expected";
            return null;
        };

        /**
         * Creates a Ruta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.Ruta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.Ruta} Ruta
         */
        Ruta.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.Ruta)
                return object;
            let message = new $root.mirana.Ruta();
            if (object.rutaId != null)
                message.rutaId = String(object.rutaId);
            if (object.mesaId != null)
                message.mesaId = String(object.mesaId);
            if (object.fuerzaVentaId != null)
                message.fuerzaVentaId = String(object.fuerzaVentaId);
            if (object.codigo != null)
                message.codigo = String(object.codigo);
            return message;
        };

        /**
         * Creates a plain object from a Ruta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.Ruta
         * @static
         * @param {mirana.Ruta} message Ruta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ruta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.rutaId = "";
                object.mesaId = "";
                object.fuerzaVentaId = "";
                object.codigo = "";
            }
            if (message.rutaId != null && message.hasOwnProperty("rutaId"))
                object.rutaId = message.rutaId;
            if (message.mesaId != null && message.hasOwnProperty("mesaId"))
                object.mesaId = message.mesaId;
            if (message.fuerzaVentaId != null && message.hasOwnProperty("fuerzaVentaId"))
                object.fuerzaVentaId = message.fuerzaVentaId;
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                object.codigo = message.codigo;
            return object;
        };

        /**
         * Converts this Ruta to JSON.
         * @function toJSON
         * @memberof mirana.Ruta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ruta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Ruta;
    })();

    mirana.RutaDespacho = (function() {

        /**
         * Properties of a RutaDespacho.
         * @memberof mirana
         * @interface IRutaDespacho
         * @property {string|null} [rutaDespachoId] RutaDespacho rutaDespachoId
         * @property {string|null} [codigo] RutaDespacho codigo
         */

        /**
         * Constructs a new RutaDespacho.
         * @memberof mirana
         * @classdesc Represents a RutaDespacho.
         * @implements IRutaDespacho
         * @constructor
         * @param {mirana.IRutaDespacho=} [properties] Properties to set
         */
        function RutaDespacho(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RutaDespacho rutaDespachoId.
         * @member {string} rutaDespachoId
         * @memberof mirana.RutaDespacho
         * @instance
         */
        RutaDespacho.prototype.rutaDespachoId = "";

        /**
         * RutaDespacho codigo.
         * @member {string} codigo
         * @memberof mirana.RutaDespacho
         * @instance
         */
        RutaDespacho.prototype.codigo = "";

        /**
         * Creates a new RutaDespacho instance using the specified properties.
         * @function create
         * @memberof mirana.RutaDespacho
         * @static
         * @param {mirana.IRutaDespacho=} [properties] Properties to set
         * @returns {mirana.RutaDespacho} RutaDespacho instance
         */
        RutaDespacho.create = function create(properties) {
            return new RutaDespacho(properties);
        };

        /**
         * Encodes the specified RutaDespacho message. Does not implicitly {@link mirana.RutaDespacho.verify|verify} messages.
         * @function encode
         * @memberof mirana.RutaDespacho
         * @static
         * @param {mirana.IRutaDespacho} message RutaDespacho message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaDespacho.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.rutaDespachoId);
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.codigo);
            return writer;
        };

        /**
         * Encodes the specified RutaDespacho message, length delimited. Does not implicitly {@link mirana.RutaDespacho.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.RutaDespacho
         * @static
         * @param {mirana.IRutaDespacho} message RutaDespacho message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaDespacho.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RutaDespacho message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.RutaDespacho
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.RutaDespacho} RutaDespacho
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaDespacho.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.RutaDespacho();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.rutaDespachoId = reader.string();
                    break;
                case 2:
                    message.codigo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RutaDespacho message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.RutaDespacho
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.RutaDespacho} RutaDespacho
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaDespacho.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RutaDespacho message.
         * @function verify
         * @memberof mirana.RutaDespacho
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RutaDespacho.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                if (!$util.isString(message.rutaDespachoId))
                    return "rutaDespachoId: string expected";
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                if (!$util.isString(message.codigo))
                    return "codigo: string expected";
            return null;
        };

        /**
         * Creates a RutaDespacho message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.RutaDespacho
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.RutaDespacho} RutaDespacho
         */
        RutaDespacho.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.RutaDespacho)
                return object;
            let message = new $root.mirana.RutaDespacho();
            if (object.rutaDespachoId != null)
                message.rutaDespachoId = String(object.rutaDespachoId);
            if (object.codigo != null)
                message.codigo = String(object.codigo);
            return message;
        };

        /**
         * Creates a plain object from a RutaDespacho message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.RutaDespacho
         * @static
         * @param {mirana.RutaDespacho} message RutaDespacho
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RutaDespacho.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.rutaDespachoId = "";
                object.codigo = "";
            }
            if (message.rutaDespachoId != null && message.hasOwnProperty("rutaDespachoId"))
                object.rutaDespachoId = message.rutaDespachoId;
            if (message.codigo != null && message.hasOwnProperty("codigo"))
                object.codigo = message.codigo;
            return object;
        };

        /**
         * Converts this RutaDespacho to JSON.
         * @function toJSON
         * @memberof mirana.RutaDespacho
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RutaDespacho.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RutaDespacho;
    })();

    mirana.MotivoAnulacion = (function() {

        /**
         * Properties of a MotivoAnulacion.
         * @memberof mirana
         * @interface IMotivoAnulacion
         * @property {string|null} [motivoAnulacionId] MotivoAnulacion motivoAnulacionId
         * @property {string|null} [descripcion] MotivoAnulacion descripcion
         */

        /**
         * Constructs a new MotivoAnulacion.
         * @memberof mirana
         * @classdesc Represents a MotivoAnulacion.
         * @implements IMotivoAnulacion
         * @constructor
         * @param {mirana.IMotivoAnulacion=} [properties] Properties to set
         */
        function MotivoAnulacion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MotivoAnulacion motivoAnulacionId.
         * @member {string} motivoAnulacionId
         * @memberof mirana.MotivoAnulacion
         * @instance
         */
        MotivoAnulacion.prototype.motivoAnulacionId = "";

        /**
         * MotivoAnulacion descripcion.
         * @member {string} descripcion
         * @memberof mirana.MotivoAnulacion
         * @instance
         */
        MotivoAnulacion.prototype.descripcion = "";

        /**
         * Creates a new MotivoAnulacion instance using the specified properties.
         * @function create
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {mirana.IMotivoAnulacion=} [properties] Properties to set
         * @returns {mirana.MotivoAnulacion} MotivoAnulacion instance
         */
        MotivoAnulacion.create = function create(properties) {
            return new MotivoAnulacion(properties);
        };

        /**
         * Encodes the specified MotivoAnulacion message. Does not implicitly {@link mirana.MotivoAnulacion.verify|verify} messages.
         * @function encode
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {mirana.IMotivoAnulacion} message MotivoAnulacion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotivoAnulacion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.motivoAnulacionId);
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.descripcion);
            return writer;
        };

        /**
         * Encodes the specified MotivoAnulacion message, length delimited. Does not implicitly {@link mirana.MotivoAnulacion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {mirana.IMotivoAnulacion} message MotivoAnulacion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotivoAnulacion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MotivoAnulacion message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.MotivoAnulacion} MotivoAnulacion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotivoAnulacion.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.MotivoAnulacion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.motivoAnulacionId = reader.string();
                    break;
                case 2:
                    message.descripcion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MotivoAnulacion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.MotivoAnulacion} MotivoAnulacion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotivoAnulacion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MotivoAnulacion message.
         * @function verify
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MotivoAnulacion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                if (!$util.isString(message.motivoAnulacionId))
                    return "motivoAnulacionId: string expected";
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                if (!$util.isString(message.descripcion))
                    return "descripcion: string expected";
            return null;
        };

        /**
         * Creates a MotivoAnulacion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.MotivoAnulacion} MotivoAnulacion
         */
        MotivoAnulacion.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.MotivoAnulacion)
                return object;
            let message = new $root.mirana.MotivoAnulacion();
            if (object.motivoAnulacionId != null)
                message.motivoAnulacionId = String(object.motivoAnulacionId);
            if (object.descripcion != null)
                message.descripcion = String(object.descripcion);
            return message;
        };

        /**
         * Creates a plain object from a MotivoAnulacion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.MotivoAnulacion
         * @static
         * @param {mirana.MotivoAnulacion} message MotivoAnulacion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MotivoAnulacion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.motivoAnulacionId = "";
                object.descripcion = "";
            }
            if (message.motivoAnulacionId != null && message.hasOwnProperty("motivoAnulacionId"))
                object.motivoAnulacionId = message.motivoAnulacionId;
            if (message.descripcion != null && message.hasOwnProperty("descripcion"))
                object.descripcion = message.descripcion;
            return object;
        };

        /**
         * Converts this MotivoAnulacion to JSON.
         * @function toJSON
         * @memberof mirana.MotivoAnulacion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MotivoAnulacion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MotivoAnulacion;
    })();

    mirana.FuerzaVentaList = (function() {

        /**
         * Properties of a FuerzaVentaList.
         * @memberof mirana
         * @interface IFuerzaVentaList
         * @property {Array.<mirana.IFuerzaVenta>|null} [fuerzaVenta] FuerzaVentaList fuerzaVenta
         */

        /**
         * Constructs a new FuerzaVentaList.
         * @memberof mirana
         * @classdesc Represents a FuerzaVentaList.
         * @implements IFuerzaVentaList
         * @constructor
         * @param {mirana.IFuerzaVentaList=} [properties] Properties to set
         */
        function FuerzaVentaList(properties) {
            this.fuerzaVenta = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FuerzaVentaList fuerzaVenta.
         * @member {Array.<mirana.IFuerzaVenta>} fuerzaVenta
         * @memberof mirana.FuerzaVentaList
         * @instance
         */
        FuerzaVentaList.prototype.fuerzaVenta = $util.emptyArray;

        /**
         * Creates a new FuerzaVentaList instance using the specified properties.
         * @function create
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {mirana.IFuerzaVentaList=} [properties] Properties to set
         * @returns {mirana.FuerzaVentaList} FuerzaVentaList instance
         */
        FuerzaVentaList.create = function create(properties) {
            return new FuerzaVentaList(properties);
        };

        /**
         * Encodes the specified FuerzaVentaList message. Does not implicitly {@link mirana.FuerzaVentaList.verify|verify} messages.
         * @function encode
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {mirana.IFuerzaVentaList} message FuerzaVentaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FuerzaVentaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuerzaVenta != null && message.fuerzaVenta.length)
                for (let i = 0; i < message.fuerzaVenta.length; ++i)
                    $root.mirana.FuerzaVenta.encode(message.fuerzaVenta[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FuerzaVentaList message, length delimited. Does not implicitly {@link mirana.FuerzaVentaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {mirana.IFuerzaVentaList} message FuerzaVentaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FuerzaVentaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FuerzaVentaList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.FuerzaVentaList} FuerzaVentaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FuerzaVentaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.FuerzaVentaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.fuerzaVenta && message.fuerzaVenta.length))
                        message.fuerzaVenta = [];
                    message.fuerzaVenta.push($root.mirana.FuerzaVenta.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FuerzaVentaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.FuerzaVentaList} FuerzaVentaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FuerzaVentaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FuerzaVentaList message.
         * @function verify
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FuerzaVentaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuerzaVenta != null && message.hasOwnProperty("fuerzaVenta")) {
                if (!Array.isArray(message.fuerzaVenta))
                    return "fuerzaVenta: array expected";
                for (let i = 0; i < message.fuerzaVenta.length; ++i) {
                    let error = $root.mirana.FuerzaVenta.verify(message.fuerzaVenta[i]);
                    if (error)
                        return "fuerzaVenta." + error;
                }
            }
            return null;
        };

        /**
         * Creates a FuerzaVentaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.FuerzaVentaList} FuerzaVentaList
         */
        FuerzaVentaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.FuerzaVentaList)
                return object;
            let message = new $root.mirana.FuerzaVentaList();
            if (object.fuerzaVenta) {
                if (!Array.isArray(object.fuerzaVenta))
                    throw TypeError(".mirana.FuerzaVentaList.fuerzaVenta: array expected");
                message.fuerzaVenta = [];
                for (let i = 0; i < object.fuerzaVenta.length; ++i) {
                    if (typeof object.fuerzaVenta[i] !== "object")
                        throw TypeError(".mirana.FuerzaVentaList.fuerzaVenta: object expected");
                    message.fuerzaVenta[i] = $root.mirana.FuerzaVenta.fromObject(object.fuerzaVenta[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FuerzaVentaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.FuerzaVentaList
         * @static
         * @param {mirana.FuerzaVentaList} message FuerzaVentaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FuerzaVentaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.fuerzaVenta = [];
            if (message.fuerzaVenta && message.fuerzaVenta.length) {
                object.fuerzaVenta = [];
                for (let j = 0; j < message.fuerzaVenta.length; ++j)
                    object.fuerzaVenta[j] = $root.mirana.FuerzaVenta.toObject(message.fuerzaVenta[j], options);
            }
            return object;
        };

        /**
         * Converts this FuerzaVentaList to JSON.
         * @function toJSON
         * @memberof mirana.FuerzaVentaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FuerzaVentaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FuerzaVentaList;
    })();

    mirana.MesaList = (function() {

        /**
         * Properties of a MesaList.
         * @memberof mirana
         * @interface IMesaList
         * @property {Array.<mirana.IMesa>|null} [mesa] MesaList mesa
         */

        /**
         * Constructs a new MesaList.
         * @memberof mirana
         * @classdesc Represents a MesaList.
         * @implements IMesaList
         * @constructor
         * @param {mirana.IMesaList=} [properties] Properties to set
         */
        function MesaList(properties) {
            this.mesa = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MesaList mesa.
         * @member {Array.<mirana.IMesa>} mesa
         * @memberof mirana.MesaList
         * @instance
         */
        MesaList.prototype.mesa = $util.emptyArray;

        /**
         * Creates a new MesaList instance using the specified properties.
         * @function create
         * @memberof mirana.MesaList
         * @static
         * @param {mirana.IMesaList=} [properties] Properties to set
         * @returns {mirana.MesaList} MesaList instance
         */
        MesaList.create = function create(properties) {
            return new MesaList(properties);
        };

        /**
         * Encodes the specified MesaList message. Does not implicitly {@link mirana.MesaList.verify|verify} messages.
         * @function encode
         * @memberof mirana.MesaList
         * @static
         * @param {mirana.IMesaList} message MesaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MesaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mesa != null && message.mesa.length)
                for (let i = 0; i < message.mesa.length; ++i)
                    $root.mirana.Mesa.encode(message.mesa[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MesaList message, length delimited. Does not implicitly {@link mirana.MesaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.MesaList
         * @static
         * @param {mirana.IMesaList} message MesaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MesaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MesaList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.MesaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.MesaList} MesaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MesaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.MesaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.mesa && message.mesa.length))
                        message.mesa = [];
                    message.mesa.push($root.mirana.Mesa.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MesaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.MesaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.MesaList} MesaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MesaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MesaList message.
         * @function verify
         * @memberof mirana.MesaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MesaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mesa != null && message.hasOwnProperty("mesa")) {
                if (!Array.isArray(message.mesa))
                    return "mesa: array expected";
                for (let i = 0; i < message.mesa.length; ++i) {
                    let error = $root.mirana.Mesa.verify(message.mesa[i]);
                    if (error)
                        return "mesa." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MesaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.MesaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.MesaList} MesaList
         */
        MesaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.MesaList)
                return object;
            let message = new $root.mirana.MesaList();
            if (object.mesa) {
                if (!Array.isArray(object.mesa))
                    throw TypeError(".mirana.MesaList.mesa: array expected");
                message.mesa = [];
                for (let i = 0; i < object.mesa.length; ++i) {
                    if (typeof object.mesa[i] !== "object")
                        throw TypeError(".mirana.MesaList.mesa: object expected");
                    message.mesa[i] = $root.mirana.Mesa.fromObject(object.mesa[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MesaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.MesaList
         * @static
         * @param {mirana.MesaList} message MesaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MesaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.mesa = [];
            if (message.mesa && message.mesa.length) {
                object.mesa = [];
                for (let j = 0; j < message.mesa.length; ++j)
                    object.mesa[j] = $root.mirana.Mesa.toObject(message.mesa[j], options);
            }
            return object;
        };

        /**
         * Converts this MesaList to JSON.
         * @function toJSON
         * @memberof mirana.MesaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MesaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MesaList;
    })();

    mirana.VendedorList = (function() {

        /**
         * Properties of a VendedorList.
         * @memberof mirana
         * @interface IVendedorList
         * @property {Array.<mirana.IVendedor>|null} [vendedor] VendedorList vendedor
         */

        /**
         * Constructs a new VendedorList.
         * @memberof mirana
         * @classdesc Represents a VendedorList.
         * @implements IVendedorList
         * @constructor
         * @param {mirana.IVendedorList=} [properties] Properties to set
         */
        function VendedorList(properties) {
            this.vendedor = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VendedorList vendedor.
         * @member {Array.<mirana.IVendedor>} vendedor
         * @memberof mirana.VendedorList
         * @instance
         */
        VendedorList.prototype.vendedor = $util.emptyArray;

        /**
         * Creates a new VendedorList instance using the specified properties.
         * @function create
         * @memberof mirana.VendedorList
         * @static
         * @param {mirana.IVendedorList=} [properties] Properties to set
         * @returns {mirana.VendedorList} VendedorList instance
         */
        VendedorList.create = function create(properties) {
            return new VendedorList(properties);
        };

        /**
         * Encodes the specified VendedorList message. Does not implicitly {@link mirana.VendedorList.verify|verify} messages.
         * @function encode
         * @memberof mirana.VendedorList
         * @static
         * @param {mirana.IVendedorList} message VendedorList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendedorList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.vendedor != null && message.vendedor.length)
                for (let i = 0; i < message.vendedor.length; ++i)
                    $root.mirana.Vendedor.encode(message.vendedor[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VendedorList message, length delimited. Does not implicitly {@link mirana.VendedorList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.VendedorList
         * @static
         * @param {mirana.IVendedorList} message VendedorList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendedorList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VendedorList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.VendedorList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.VendedorList} VendedorList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendedorList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.VendedorList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.vendedor && message.vendedor.length))
                        message.vendedor = [];
                    message.vendedor.push($root.mirana.Vendedor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VendedorList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.VendedorList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.VendedorList} VendedorList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendedorList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VendedorList message.
         * @function verify
         * @memberof mirana.VendedorList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VendedorList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.vendedor != null && message.hasOwnProperty("vendedor")) {
                if (!Array.isArray(message.vendedor))
                    return "vendedor: array expected";
                for (let i = 0; i < message.vendedor.length; ++i) {
                    let error = $root.mirana.Vendedor.verify(message.vendedor[i]);
                    if (error)
                        return "vendedor." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VendedorList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.VendedorList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.VendedorList} VendedorList
         */
        VendedorList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.VendedorList)
                return object;
            let message = new $root.mirana.VendedorList();
            if (object.vendedor) {
                if (!Array.isArray(object.vendedor))
                    throw TypeError(".mirana.VendedorList.vendedor: array expected");
                message.vendedor = [];
                for (let i = 0; i < object.vendedor.length; ++i) {
                    if (typeof object.vendedor[i] !== "object")
                        throw TypeError(".mirana.VendedorList.vendedor: object expected");
                    message.vendedor[i] = $root.mirana.Vendedor.fromObject(object.vendedor[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VendedorList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.VendedorList
         * @static
         * @param {mirana.VendedorList} message VendedorList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VendedorList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.vendedor = [];
            if (message.vendedor && message.vendedor.length) {
                object.vendedor = [];
                for (let j = 0; j < message.vendedor.length; ++j)
                    object.vendedor[j] = $root.mirana.Vendedor.toObject(message.vendedor[j], options);
            }
            return object;
        };

        /**
         * Converts this VendedorList to JSON.
         * @function toJSON
         * @memberof mirana.VendedorList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VendedorList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VendedorList;
    })();

    mirana.RutaList = (function() {

        /**
         * Properties of a RutaList.
         * @memberof mirana
         * @interface IRutaList
         * @property {Array.<mirana.IRuta>|null} [ruta] RutaList ruta
         */

        /**
         * Constructs a new RutaList.
         * @memberof mirana
         * @classdesc Represents a RutaList.
         * @implements IRutaList
         * @constructor
         * @param {mirana.IRutaList=} [properties] Properties to set
         */
        function RutaList(properties) {
            this.ruta = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RutaList ruta.
         * @member {Array.<mirana.IRuta>} ruta
         * @memberof mirana.RutaList
         * @instance
         */
        RutaList.prototype.ruta = $util.emptyArray;

        /**
         * Creates a new RutaList instance using the specified properties.
         * @function create
         * @memberof mirana.RutaList
         * @static
         * @param {mirana.IRutaList=} [properties] Properties to set
         * @returns {mirana.RutaList} RutaList instance
         */
        RutaList.create = function create(properties) {
            return new RutaList(properties);
        };

        /**
         * Encodes the specified RutaList message. Does not implicitly {@link mirana.RutaList.verify|verify} messages.
         * @function encode
         * @memberof mirana.RutaList
         * @static
         * @param {mirana.IRutaList} message RutaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ruta != null && message.ruta.length)
                for (let i = 0; i < message.ruta.length; ++i)
                    $root.mirana.Ruta.encode(message.ruta[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RutaList message, length delimited. Does not implicitly {@link mirana.RutaList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.RutaList
         * @static
         * @param {mirana.IRutaList} message RutaList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RutaList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.RutaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.RutaList} RutaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.RutaList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ruta && message.ruta.length))
                        message.ruta = [];
                    message.ruta.push($root.mirana.Ruta.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RutaList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.RutaList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.RutaList} RutaList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RutaList message.
         * @function verify
         * @memberof mirana.RutaList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RutaList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ruta != null && message.hasOwnProperty("ruta")) {
                if (!Array.isArray(message.ruta))
                    return "ruta: array expected";
                for (let i = 0; i < message.ruta.length; ++i) {
                    let error = $root.mirana.Ruta.verify(message.ruta[i]);
                    if (error)
                        return "ruta." + error;
                }
            }
            return null;
        };

        /**
         * Creates a RutaList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.RutaList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.RutaList} RutaList
         */
        RutaList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.RutaList)
                return object;
            let message = new $root.mirana.RutaList();
            if (object.ruta) {
                if (!Array.isArray(object.ruta))
                    throw TypeError(".mirana.RutaList.ruta: array expected");
                message.ruta = [];
                for (let i = 0; i < object.ruta.length; ++i) {
                    if (typeof object.ruta[i] !== "object")
                        throw TypeError(".mirana.RutaList.ruta: object expected");
                    message.ruta[i] = $root.mirana.Ruta.fromObject(object.ruta[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a RutaList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.RutaList
         * @static
         * @param {mirana.RutaList} message RutaList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RutaList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.ruta = [];
            if (message.ruta && message.ruta.length) {
                object.ruta = [];
                for (let j = 0; j < message.ruta.length; ++j)
                    object.ruta[j] = $root.mirana.Ruta.toObject(message.ruta[j], options);
            }
            return object;
        };

        /**
         * Converts this RutaList to JSON.
         * @function toJSON
         * @memberof mirana.RutaList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RutaList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RutaList;
    })();

    mirana.RutaDespachoList = (function() {

        /**
         * Properties of a RutaDespachoList.
         * @memberof mirana
         * @interface IRutaDespachoList
         * @property {Array.<mirana.IRutaDespacho>|null} [rutaDespacho] RutaDespachoList rutaDespacho
         */

        /**
         * Constructs a new RutaDespachoList.
         * @memberof mirana
         * @classdesc Represents a RutaDespachoList.
         * @implements IRutaDespachoList
         * @constructor
         * @param {mirana.IRutaDespachoList=} [properties] Properties to set
         */
        function RutaDespachoList(properties) {
            this.rutaDespacho = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RutaDespachoList rutaDespacho.
         * @member {Array.<mirana.IRutaDespacho>} rutaDespacho
         * @memberof mirana.RutaDespachoList
         * @instance
         */
        RutaDespachoList.prototype.rutaDespacho = $util.emptyArray;

        /**
         * Creates a new RutaDespachoList instance using the specified properties.
         * @function create
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {mirana.IRutaDespachoList=} [properties] Properties to set
         * @returns {mirana.RutaDespachoList} RutaDespachoList instance
         */
        RutaDespachoList.create = function create(properties) {
            return new RutaDespachoList(properties);
        };

        /**
         * Encodes the specified RutaDespachoList message. Does not implicitly {@link mirana.RutaDespachoList.verify|verify} messages.
         * @function encode
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {mirana.IRutaDespachoList} message RutaDespachoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaDespachoList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rutaDespacho != null && message.rutaDespacho.length)
                for (let i = 0; i < message.rutaDespacho.length; ++i)
                    $root.mirana.RutaDespacho.encode(message.rutaDespacho[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RutaDespachoList message, length delimited. Does not implicitly {@link mirana.RutaDespachoList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {mirana.IRutaDespachoList} message RutaDespachoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RutaDespachoList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RutaDespachoList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.RutaDespachoList} RutaDespachoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaDespachoList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.RutaDespachoList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.rutaDespacho && message.rutaDespacho.length))
                        message.rutaDespacho = [];
                    message.rutaDespacho.push($root.mirana.RutaDespacho.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RutaDespachoList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.RutaDespachoList} RutaDespachoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RutaDespachoList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RutaDespachoList message.
         * @function verify
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RutaDespachoList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rutaDespacho != null && message.hasOwnProperty("rutaDespacho")) {
                if (!Array.isArray(message.rutaDespacho))
                    return "rutaDespacho: array expected";
                for (let i = 0; i < message.rutaDespacho.length; ++i) {
                    let error = $root.mirana.RutaDespacho.verify(message.rutaDespacho[i]);
                    if (error)
                        return "rutaDespacho." + error;
                }
            }
            return null;
        };

        /**
         * Creates a RutaDespachoList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.RutaDespachoList} RutaDespachoList
         */
        RutaDespachoList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.RutaDespachoList)
                return object;
            let message = new $root.mirana.RutaDespachoList();
            if (object.rutaDespacho) {
                if (!Array.isArray(object.rutaDespacho))
                    throw TypeError(".mirana.RutaDespachoList.rutaDespacho: array expected");
                message.rutaDespacho = [];
                for (let i = 0; i < object.rutaDespacho.length; ++i) {
                    if (typeof object.rutaDespacho[i] !== "object")
                        throw TypeError(".mirana.RutaDespachoList.rutaDespacho: object expected");
                    message.rutaDespacho[i] = $root.mirana.RutaDespacho.fromObject(object.rutaDespacho[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a RutaDespachoList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.RutaDespachoList
         * @static
         * @param {mirana.RutaDespachoList} message RutaDespachoList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RutaDespachoList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.rutaDespacho = [];
            if (message.rutaDespacho && message.rutaDespacho.length) {
                object.rutaDespacho = [];
                for (let j = 0; j < message.rutaDespacho.length; ++j)
                    object.rutaDespacho[j] = $root.mirana.RutaDespacho.toObject(message.rutaDespacho[j], options);
            }
            return object;
        };

        /**
         * Converts this RutaDespachoList to JSON.
         * @function toJSON
         * @memberof mirana.RutaDespachoList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RutaDespachoList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RutaDespachoList;
    })();

    mirana.MotivoAnulacionList = (function() {

        /**
         * Properties of a MotivoAnulacionList.
         * @memberof mirana
         * @interface IMotivoAnulacionList
         * @property {Array.<mirana.IMotivoAnulacion>|null} [motivoAnulacion] MotivoAnulacionList motivoAnulacion
         */

        /**
         * Constructs a new MotivoAnulacionList.
         * @memberof mirana
         * @classdesc Represents a MotivoAnulacionList.
         * @implements IMotivoAnulacionList
         * @constructor
         * @param {mirana.IMotivoAnulacionList=} [properties] Properties to set
         */
        function MotivoAnulacionList(properties) {
            this.motivoAnulacion = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MotivoAnulacionList motivoAnulacion.
         * @member {Array.<mirana.IMotivoAnulacion>} motivoAnulacion
         * @memberof mirana.MotivoAnulacionList
         * @instance
         */
        MotivoAnulacionList.prototype.motivoAnulacion = $util.emptyArray;

        /**
         * Creates a new MotivoAnulacionList instance using the specified properties.
         * @function create
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {mirana.IMotivoAnulacionList=} [properties] Properties to set
         * @returns {mirana.MotivoAnulacionList} MotivoAnulacionList instance
         */
        MotivoAnulacionList.create = function create(properties) {
            return new MotivoAnulacionList(properties);
        };

        /**
         * Encodes the specified MotivoAnulacionList message. Does not implicitly {@link mirana.MotivoAnulacionList.verify|verify} messages.
         * @function encode
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {mirana.IMotivoAnulacionList} message MotivoAnulacionList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotivoAnulacionList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.motivoAnulacion != null && message.motivoAnulacion.length)
                for (let i = 0; i < message.motivoAnulacion.length; ++i)
                    $root.mirana.MotivoAnulacion.encode(message.motivoAnulacion[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MotivoAnulacionList message, length delimited. Does not implicitly {@link mirana.MotivoAnulacionList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {mirana.IMotivoAnulacionList} message MotivoAnulacionList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotivoAnulacionList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MotivoAnulacionList message from the specified reader or buffer.
         * @function decode
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {mirana.MotivoAnulacionList} MotivoAnulacionList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotivoAnulacionList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.mirana.MotivoAnulacionList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.motivoAnulacion && message.motivoAnulacion.length))
                        message.motivoAnulacion = [];
                    message.motivoAnulacion.push($root.mirana.MotivoAnulacion.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MotivoAnulacionList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {mirana.MotivoAnulacionList} MotivoAnulacionList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotivoAnulacionList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MotivoAnulacionList message.
         * @function verify
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MotivoAnulacionList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.motivoAnulacion != null && message.hasOwnProperty("motivoAnulacion")) {
                if (!Array.isArray(message.motivoAnulacion))
                    return "motivoAnulacion: array expected";
                for (let i = 0; i < message.motivoAnulacion.length; ++i) {
                    let error = $root.mirana.MotivoAnulacion.verify(message.motivoAnulacion[i]);
                    if (error)
                        return "motivoAnulacion." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MotivoAnulacionList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {mirana.MotivoAnulacionList} MotivoAnulacionList
         */
        MotivoAnulacionList.fromObject = function fromObject(object) {
            if (object instanceof $root.mirana.MotivoAnulacionList)
                return object;
            let message = new $root.mirana.MotivoAnulacionList();
            if (object.motivoAnulacion) {
                if (!Array.isArray(object.motivoAnulacion))
                    throw TypeError(".mirana.MotivoAnulacionList.motivoAnulacion: array expected");
                message.motivoAnulacion = [];
                for (let i = 0; i < object.motivoAnulacion.length; ++i) {
                    if (typeof object.motivoAnulacion[i] !== "object")
                        throw TypeError(".mirana.MotivoAnulacionList.motivoAnulacion: object expected");
                    message.motivoAnulacion[i] = $root.mirana.MotivoAnulacion.fromObject(object.motivoAnulacion[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MotivoAnulacionList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof mirana.MotivoAnulacionList
         * @static
         * @param {mirana.MotivoAnulacionList} message MotivoAnulacionList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MotivoAnulacionList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.motivoAnulacion = [];
            if (message.motivoAnulacion && message.motivoAnulacion.length) {
                object.motivoAnulacion = [];
                for (let j = 0; j < message.motivoAnulacion.length; ++j)
                    object.motivoAnulacion[j] = $root.mirana.MotivoAnulacion.toObject(message.motivoAnulacion[j], options);
            }
            return object;
        };

        /**
         * Converts this MotivoAnulacionList to JSON.
         * @function toJSON
         * @memberof mirana.MotivoAnulacionList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MotivoAnulacionList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MotivoAnulacionList;
    })();

    mirana.DimensionService = (function() {

        /**
         * Constructs a new DimensionService service.
         * @memberof mirana
         * @classdesc Represents a DimensionService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function DimensionService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (DimensionService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DimensionService;

        /**
         * Creates new DimensionService service using the specified rpc implementation.
         * @function create
         * @memberof mirana.DimensionService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {DimensionService} RPC service. Useful where requests and/or responses are streamed.
         */
        DimensionService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link mirana.DimensionService#syncFuerzasVenta}.
         * @memberof mirana.DimensionService
         * @typedef syncFuerzasVentaCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncFuerzasVenta.
         * @function syncFuerzasVenta
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IFuerzaVentaList} request FuerzaVentaList message or plain object
         * @param {mirana.DimensionService.syncFuerzasVentaCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncFuerzasVenta = function syncFuerzasVenta(request, callback) {
            return this.rpcCall(syncFuerzasVenta, $root.mirana.FuerzaVentaList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncFuerzasVenta.
         * @function syncFuerzasVenta
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IFuerzaVentaList} request FuerzaVentaList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.DimensionService#syncMesas}.
         * @memberof mirana.DimensionService
         * @typedef syncMesasCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncMesas.
         * @function syncMesas
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IMesaList} request MesaList message or plain object
         * @param {mirana.DimensionService.syncMesasCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncMesas = function syncMesas(request, callback) {
            return this.rpcCall(syncMesas, $root.mirana.MesaList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncMesas.
         * @function syncMesas
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IMesaList} request MesaList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.DimensionService#syncVendedores}.
         * @memberof mirana.DimensionService
         * @typedef syncVendedoresCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncVendedores.
         * @function syncVendedores
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IVendedorList} request VendedorList message or plain object
         * @param {mirana.DimensionService.syncVendedoresCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncVendedores = function syncVendedores(request, callback) {
            return this.rpcCall(syncVendedores, $root.mirana.VendedorList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncVendedores.
         * @function syncVendedores
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IVendedorList} request VendedorList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.DimensionService#syncRutas}.
         * @memberof mirana.DimensionService
         * @typedef syncRutasCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncRutas.
         * @function syncRutas
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IRutaList} request RutaList message or plain object
         * @param {mirana.DimensionService.syncRutasCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncRutas = function syncRutas(request, callback) {
            return this.rpcCall(syncRutas, $root.mirana.RutaList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncRutas.
         * @function syncRutas
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IRutaList} request RutaList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.DimensionService#syncMotivosAnulacion}.
         * @memberof mirana.DimensionService
         * @typedef syncMotivosAnulacionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncMotivosAnulacion.
         * @function syncMotivosAnulacion
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IMotivoAnulacionList} request MotivoAnulacionList message or plain object
         * @param {mirana.DimensionService.syncMotivosAnulacionCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncMotivosAnulacion = function syncMotivosAnulacion(request, callback) {
            return this.rpcCall(syncMotivosAnulacion, $root.mirana.MotivoAnulacionList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncMotivosAnulacion.
         * @function syncMotivosAnulacion
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IMotivoAnulacionList} request MotivoAnulacionList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link mirana.DimensionService#syncRutasDespacho}.
         * @memberof mirana.DimensionService
         * @typedef syncRutasDespachoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {rpc.Reply} [response] Reply
         */

        /**
         * Calls syncRutasDespacho.
         * @function syncRutasDespacho
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IRutaDespachoList} request RutaDespachoList message or plain object
         * @param {mirana.DimensionService.syncRutasDespachoCallback} callback Node-style callback called with the error, if any, and Reply
         * @returns {undefined}
         * @variation 1
         */
        DimensionService.prototype.syncRutasDespacho = function syncRutasDespacho(request, callback) {
            return this.rpcCall(syncRutasDespacho, $root.mirana.RutaDespachoList, $root.rpc.Reply, request, callback);
        };

        /**
         * Calls syncRutasDespacho.
         * @function syncRutasDespacho
         * @memberof mirana.DimensionService
         * @instance
         * @param {mirana.IRutaDespachoList} request RutaDespachoList message or plain object
         * @returns {Promise<rpc.Reply>} Promise
         * @variation 2
         */

        return DimensionService;
    })();

    return mirana;
})();

export { $root as default };



//////////////////
// WEBPACK FOOTER
// ../mirana-proto/npm/mirana-proto.js
// module id = 269
// module chunks = 0